import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, Input, Output, EventEmitter, ChangeDetectorRef, HostListener, TemplateRef, HostBinding } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, FormControl, Form, ValidationErrors } from '@angular/forms';
import { SearchService } from '../search.service';
import { NavigationExtras, Router, ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../util/constants';
import { DateUtils } from '../util/date-utils';
import { FlightSearchQueryParam } from '../entity/flight-search-query-param';
import { sourceDestinationValidator } from '../shared/address-validator.directive';
import { GooglePlacesService } from '../google-places.service';
import { IntervalType } from '../enum/interval.type';
import { FlightQueryParam } from '../entity/flight-query-param';
import { FlightTripType } from '../enum/trip1.type';
import { FlightClassType } from '../enum/flight-class.type';
import { FlightTimeType } from '../enum/time.type';
import { NoOfStops } from '../enum/no-of-stops.type';
import { AirlinesType } from '../enum/airlines.type';
import { DeviceDetailsService } from '../device-details.service';
import { Subscription, Observable, Subject, range, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TravelersInfo } from '../entity/travelers-info';
import { UserProfile } from '../entity/user-profile';
import { UserAccountService } from '../user-account.service';
import { UserAccountInfo } from '../entity/user-account-info';
import { AlgoTypes } from '../enum/algo-types';
import { Role } from '../entity/employee-info';
import { searchModalBasic } from '../search-modal/search-modal.component';
import { HotelSearchService } from '../hotel-search.service';
import { DatePipe, LocationStrategy, PlatformLocation } from '@angular/common';
import { deserialize } from '../util/ta-json/src/methods/deserialize';
import { HotelQueryParam } from '../entity/hotel-query-param';
import { AddressType } from '../enum/address.type';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { _ } from 'src/app/util/title';
import { TranslateOptionsPipe } from '../util/translate-option';
import { GallopLocalStorageService } from '../gallop-local-storage.service';
import { CommonUtils } from '../util/common-utils';
import { NavigationUtil } from '../util/navigation-util';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PopupComponent } from '../popup/popup.component';
import { GeoLocationService } from '../geo-location.service';
import { CarBookingService } from '../car-booking.service';
import { FlightResult } from '../entity/flight-result';
import { BookingService } from '../booking.service';
import { HelpPopupComponent } from '../help-popup/help-popup.component';
import { invalid } from 'moment';
import { ConnectionService } from 'ng-connection-service';
import { ClientConfiguration } from '../client-config.service';
import { Title } from '@angular/platform-browser';
import { LoginService } from '../login.service';
import { AdminPanelService } from '../admin-panel.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { find, first } from 'rxjs/operators';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FilterComponent } from '../filter/filter.component';
import { idLocale } from 'ngx-bootstrap/chronos/i18n/id';
import { datepickerAnimation } from 'ngx-bootstrap/datepicker/datepicker-animations';
import { BsDatepickerDirective, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import { SeeDetailsComponent } from '../see-details/see-details.component';
import moment from 'moment';
import { AirportsComponent } from '../airports/airports.component';
import { FilterService } from '../filter.service';
//import * as http from "http";
declare var setNgxSmartModalOpen: any;
declare var setInputOnReadonly: any;
declare var setNgxSmartModalOpenStateClosed: any;
declare var setFocusOnInputField: any;
declare var unsetsetFocusOnInputField: any;
declare var setFocusOnHotelInputField: any;
declare var addNavigationComponentPadding: any;
declare var removeNavigationComponentPadding: any;
declare var focusAndOpenKeyboardIos: any;
declare var addingHeader: any;
@Component({
    selector: 'flight-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit {
  calendarWidth: number = 320; 
  checkinCalendarOpenedAt: number = 0; 
  checkoutCalendarOpenedAt: number = 0; 

  @ViewChild(AirportsComponent) airportsComponent!: AirportsComponent;
  @Input() componentType: string;
  @Input() showFilter: boolean = false;
  @Output() collapseToggle = new EventEmitter<boolean>();
  @Output() searchRequest = new EventEmitter();
  @Output() searchAgainWithFilter = new EventEmitter();
  @Output() changeSelectedFlight = new EventEmitter();

  // 🎯 Visual Viewport keyboard offset management
  private destroy$ = new Subject<void>();
  private activeInputElement: HTMLElement | null = null;
  private activeAirportModalElement: HTMLElement | null = null;

  changingValue: Subject<boolean> = new Subject();
  lastAirportQueryTime: Date = new Date();
  searchPopClicked = true;
  inputId = '';
  valueSelectedFromDropDown: boolean = false;
  // Flags to track when airport dropdown has been closed (user finished selecting)
  // Used to prevent showing validation errors while user is still typing/selecting
  // For main form: use 'source' and 'destination' keys
  // For multi-city: use 'source_0', 'destination_0', 'source_1', etc.
  airportDropdownClosed: { [key: string]: boolean } = {};
  locationDisabled = false;
  dropDownopen = false;
  employeeListCame = false;
  currScreenWidth = 1024;
  initResponse: any;
  detailCame = false;
  thankyoumodal : any;
  bsModalRef: BsModalRef;
  eventModalShown: boolean = false;
  declineEventId: string = null;
  showCurrentLocation: boolean = false;
  currentHotelLocation = 'Current Location';
  selectedCurrentLocation = false;
  boxSelect = false;
  searchForm: UntypedFormGroup;
  searchHotelForm: UntypedFormGroup;
  companyApprovalSubscription: Subscription;
  fetchInviteListSubscription: Subscription;
  passengerForm: UntypedFormGroup;
  timeOptions: any[];
  ageGroupList = [{ id: 'ADT', value: 'Adult (12 years and above)', label: '(Adult> 12 years and above)',superAdult:false }, { id: 'CHD', value: 'Child(2-11 years)', label: '(Child 2-11 years age)',superAdult:false }, { id: 'INF', value: 'Infant without seat(< 2 years)', label: '(Infant without seat < 2 years age)',superAdult:false }]
  selectIndex: number;
  selectFormControlname = '';
  bookingType = [{ 'id': 'BOOK_FOR_OTHERS', "name": 'Guest' }, { 'id': 'BOOK_FOR_SELF', "name": 'Myself' }]
  tripTypes = [
    { id: 'ONEWAY', value: 'ONEWAY', label: 'search.ONE_WAY'},
    { id: 'ROUNDTRIP', value: 'ROUNDTRIP', label: 'search.ROUND_TRIP' },
    { id: 'MULTICITY', value: 'MULTICITY', label: 'search.MULTI_CITY' }
  ];
  multipleLeg = environment.multipleLeg;
  showTransparentOverlay: boolean = false;
  minimumDate: Date = new Date();
  minimumDate1: Date = new Date();
  maximumDate: Date = new Date();
  maximumDate3: Date = new Date();
  searchString = '';
  minimumDateMultiple: Date = new Date();
  minimumDateLeg2: Date = new Date();
  minimumDateCheckout: Date = new Date();
  previousSearch: FlightSearchQueryParam;
  isCollapsed: boolean = true;
  isMobile: boolean;
  isTabletOrMobile: boolean;
  multicity = false;
  contactNumber= Constants.GALLOP_HELP_CONTACT_NO;
  invalidForm = [{ value: false, index: 0 }];
  flight: FlightResult[] = [];
  userDetails: TravelersInfo;
  deviceSubscription: Subscription;
  deviceLocationSubscription: Subscription;
  userDetailsSubscription: Subscription;
  userInItSubscription: Subscription;
  urlParameterSubscription: Subscription;
  listTravellerResponseSubscription: Subscription;
  listEmployeesResponseSubscription: Subscription;
  viewMode = 'tab1';
  minorAgeGroupSelected : boolean = false;
  departureAirports: string = "";
  arrivalAirports: string = "";
  timeTypeOptions = Constants.TIME_TYPE;
  departureTimeTypeOptions = [Constants.TIME_TYPE[0], Constants.TIME_TYPE[1]];
  returnTimeTypeOptions = [Constants.TIME_TYPE[1], Constants.TIME_TYPE[0]];

  // Custom time options with icons for new calendar design
  customTimeOptions = [
    {
      id: 0,
      titleID: 'Anytime',
      title: 'ngOption.Anytime',
      icon: 'anytime.png',
      hours: { start: 0, end: 24 }
    },
    {
      id: 1,
      titleID: 'Morning',
      title: 'ngOption.Morning',
      icon: 'morning.avif',
      hours: { start: 4, end: 9 }
    },
    {
      id: 2,
      titleID: 'Mid Day',
      title: 'ngOption.MidDay',
      icon: 'midday.avif',
      hours: { start: 11, end: 15 }
    },
    {
      id: 3,
      titleID: 'Evening',
      title: 'ngOption.Evening',
      icon: 'evening.avif',
      hours: { start: 15, end: 20 }
    },
    {
      id: 4,
      titleID: 'Night',
      title: 'ngOption.Night',
      icon: 'night.avif',
      hours: { start: 20, end: 4 }
    },
    {
      id: 5,
      titleID: 'Custom',
      title: 'Custom',
      icon: 'custom.avif',
      hours: { start: 0, end: 24 }
    }
  ];

  // Hourly time options for custom timing grid
  hourlyTimeOptions = [
    { id: 6, titleID: '0am', title: 'ngOption.0AM', hours: { start: 0, end: 0 } },
    { id: 7, titleID: '1am', title: 'ngOption.1AM', hours: { start: 1, end: 1 } },
    { id: 8, titleID: '2am', title: 'ngOption.2AM', hours: { start: 2, end: 2 } },
    { id: 9, titleID: '3am', title: 'ngOption.3AM', hours: { start: 3, end: 3 } },
    { id: 10, titleID: '4am', title: 'ngOption.4AM', hours: { start: 4, end: 4 } },
    { id: 11, titleID: '5am', title: 'ngOption.5AM', hours: { start: 5, end: 5 } },
    { id: 12, titleID: '6am', title: 'ngOption.6AM', hours: { start: 6, end: 6 } },
    { id: 13, titleID: '7am', title: 'ngOption.7AM', hours: { start: 7, end: 7 } },
    { id: 14, titleID: '8am', title: 'ngOption.8AM', hours: { start: 8, end: 8 } },
    { id: 15, titleID: '9am', title: 'ngOption.9AM', hours: { start: 9, end: 9 } },
    { id: 16, titleID: '10am', title: 'ngOption.10AM', hours: { start: 10, end: 10 } },
    { id: 17, titleID: '11am', title: 'ngOption.11AM', hours: { start: 11, end: 11 } },
    { id: 18, titleID: '12pm', title: 'ngOption.12PM', hours: { start: 12, end: 12 } },
    { id: 19, titleID: '1pm', title: 'ngOption.1PM', hours: { start: 13, end: 13 } },
    { id: 20, titleID: '2pm', title: 'ngOption.2PM', hours: { start: 14, end: 14 } },
    { id: 21, titleID: '3pm', title: 'ngOption.3PM', hours: { start: 15, end: 15 } },
    { id: 22, titleID: '4pm', title: 'ngOption.4PM', hours: { start: 16, end: 16 } },
    { id: 23, titleID: '5pm', title: 'ngOption.5PM', hours: { start: 17, end: 17 } },
    { id: 24, titleID: '6pm', title: 'ngOption.6PM', hours: { start: 18, end: 18 } },
    { id: 25, titleID: '7pm', title: 'ngOption.7PM', hours: { start: 19, end: 19 } },
    { id: 26, titleID: '8pm', title: 'ngOption.8PM', hours: { start: 20, end: 20 } },
    { id: 27, titleID: '9pm', title: 'ngOption.9PM', hours: { start: 21, end: 21 } },
    { id: 28, titleID: '10pm', title: 'ngOption.10PM', hours: { start: 22, end: 22 } },
    { id: 29, titleID: '11pm', title: 'ngOption.11PM', hours: { start: 23, end: 23 } }
  ];

  // Control custom calendar popup visibility for departure
  showCustomCalendar: boolean = false;
  selectedTimeOption: string = this.translate.instant('search.ANYTIME');
  showCustomTiming: boolean = false;
  selectedCustomTime: string = ''; // Stores the selected hourly time to display under Custom icon

  // Control custom calendar popup visibility for return date
  showCustomCalendar1: boolean = false;
  selectedTimeOption1: string = this.translate.instant('search.ANYTIME');
  showCustomTiming1: boolean = false;
  selectedCustomTime1: string = '';

  // Control custom calendar popup visibility for multicity
  showCustomCalendarMulticity: boolean[] = [];
  selectedTimeOptionMulticity: string[] = [];
  showCustomTimingMulticity: boolean[] = [];
  selectedCustomTimeMulticity: string[] = [];
  minDateMulticity: Date[] = [];

  // Control custom calendar popup visibility for hotel
  showHotelCheckinCalendar: boolean = false;
  showHotelCheckoutCalendar: boolean = false;
  private hotelCheckinClickOutsideListener: any;
  private hotelCheckoutClickOutsideListener: any;

  tripOptions: any;
  origTripOption:any;
  classOptions = Constants.classOptionsForTrain;
  ticketOptions =  Constants.ticketOptions;
  seatOptions=  Constants.seatOptions;
  railCardsOptions = Constants.railCardsOptions;
  roomCountOptions = Constants.ROOMS_COUNT;
  passengerOptions = Constants.PASSENGER_OPTIONS;
  queryParmsSubscription: Subscription;
  hotelChainOptions = Constants.HOTEL_BRAND_CODES_NAME_MAP;
  trainLineList = Constants.TRAIN_LINE_CODE_NAME_MAP;
  airportSource = '';
  useAirpotOnlySearch: boolean = environment.userAirportOnlySearch;
  sourceAirportModel: string;
  destinationAirportModel: string;
  appLoading = true;
  searchInputType: AddressType = Constants.SEARCH_INPUT_TYPE;
  tripType = '';
  leisureValue = 1;
  passengerTypeSpecific: any;
  errorShow: boolean;
  disabled: boolean;
  infants = 0;
  totalLeg = 0;
  adults = 2;
  njoySpecificBuild: boolean;
  @ViewChild('employeeType') ngselect: NgSelectComponent;
  @ViewChild('addressInput',{ static: false }) input!: ElementRef<HTMLInputElement>;
  autocomplete!: google.maps.places.Autocomplete;
  @ViewChild(FilterComponent) filterComponent: FilterComponent;
  @ViewChildren('customDatePickerMulticity') multicityDatepickers!: QueryList<BsDatepickerDirective>;
  connectionListener: Subscription;
  location_feature_enabled = false;
  autoCompleteOptions = {
    bounds: undefined,
    fields: ['formatted_address', 'place_id', 'types', 'address_components'],
    strictBounds: false,
    types: ['geocode'],
    componentRestrictions: undefined
  };
  trainLocations =[];
  CurrentTime: any;
  getEmployeeAndTravellerList:any;
  originalTrainLocationResponse: any;
  rotatingIndex: any;
  swapRotated: boolean = false;
  swapRotatedMulticity: boolean[] = [];
  // leisureItems=[{name:'Adults',value:'',number:0},{name:'Children',value:'Aged 2-12',number:0},{name:'Infants',value:'Aged 0-2',number:0}];
  constructor(
    private fb: UntypedFormBuilder,
    private loginService: LoginService,
    private searchService: SearchService,
    private googlePlacesService: GooglePlacesService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private router: Router,
    private location: PlatformLocation,
    private bookingService: BookingService,
    public translateService: TranslateService,
    private route: ActivatedRoute,
    private titleService: Title,
    public ngxSmartModalService: NgxSmartModalService,
    public userAccountInfoService: UserAccountService,
    public deviceDetailsService: DeviceDetailsService,
    private searchHotelService: HotelSearchService,
     private filterService: FilterService,
    private cdRef: ChangeDetectorRef,
    private connectionService: ConnectionService,
    private gallopLocalStorage: GallopLocalStorageService,
    private geoLocationService: GeoLocationService,
    private location1: Location,
    private carBookingService: CarBookingService,
    private clientConfiguration: ClientConfiguration,
    private adminPanelService: AdminPanelService,
    private toastr: ToastrService,
    private bsLocaleService: BsLocaleService,
  ) {
    if (this.searchService.bookingDone) {
      history.pushState(null, null, window.location.href);
    }
    if (this.searchService.hotelbookingDone) {
      history.pushState(null, null, window.location.href);
    }
    this.location.onPopState(() => {
      if (this.searchService.bookingDone) {
        window.history.forward()
      }
      if (this.searchService.hotelbookingDone) {
        this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
          {
            queryParams:
            {
            },
            replaceUrl: true
          }
        );
        setTimeout(() => {
          window.history.forward();
        }, 100);
      }
    });
    this.isCollapsed = true;
    this.njoySpecificBuild = this.userAccountInfoService.isItNjoyBuild();
    this.tripOptions = this.njoySpecificBuild ? Constants.TRIP_OPTIONS : Constants.TRIP_OPTIONS;
    if(this.searchService.selectedEventID){
     // this.tripOptions = this.tripOptions.filter(item => item.id !== 'MULTICITY')
    }
    this.origTripOption = this.njoySpecificBuild ? Constants.TRIP_OPTIONS : Constants.TRIP_OPTIONS;
    setInterval(() => {
      this.CurrentTime = new Date().getHours()
    }, 1);
    this.maximumDate.setDate(this.maximumDate.getDate() + 329);
    if (this.searchService.maxAllowedHotelStay) {
      this.maximumDate3.setDate(this.maximumDate3.getDate() + this.searchService.maxAllowedHotelStay);
    }
    // this.maximumDate3.setDate(this.maximumDate3.getDate() + 21);
    this.minimumDate.setDate(this.minimumDate.getDate());
    this.minimumDate1.setDate(this.minimumDate.getDate() - 1);
    this.minimumDateMultiple.setDate(this.minimumDate1.getDate() - 1);
    this.minimumDateLeg2.setDate(this.minimumDate1.getDate() - 1);
    this.createForm();
    this.appLoading = false;
    if ((environment.platform === 'iOS' && environment.appStoreBuildNumber > 24)
      ||
      (environment.platform === 'Android' && environment.appStoreBuildNumber > 25)
    ) {
      this.location_feature_enabled = true;
    }
  }
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const focused = $(':focus');
    if (focused) {
      if ($(focused).prop('tagName') === 'INPUT') {
        if (event.key === 'ArrowDown') {
          event.preventDefault();

          // Set flag to prevent blur from closing dropdown
          this.searchService.onSelectingFromDropdown = true;

          // Try to focus on dropdown items - use setTimeout to ensure Angular has finished rendering
          setTimeout(() => {
            // Check for new template structure first
            const firstSubitem = document.querySelector('.airport-subitem.tabindex0_0') as HTMLElement;
            const firstAirportItem = document.querySelector('.airport-item.tabindex0') as HTMLElement;
            const firstCityHeader = document.querySelector('.city-header.tabindex0') as HTMLElement;
            const firstSingleAirport = document.querySelector('.single-airport-item.tabindex0') as HTMLElement;

            if (firstSubitem) {
              // If first group is expanded (has child items visible), focus on first child
              firstSubitem.focus();
            } else if (firstSingleAirport) {
              // Focus on single airport item
              firstSingleAirport.focus();
            } else if (firstCityHeader) {
              // Focus on city header
              firstCityHeader.focus();
            } else if (firstAirportItem) {
              // Fallback to any airport item
              firstAirportItem.focus();
            } else {
              // Fallback for old template structure
              if ($('.airportItem.tabindex0')[0]) {
                if ($('#multipleAirports0') && $('#multipleAirports0').length > 0) {
                  $('.airportItem.tabindex0_0')[0].focus();
                } else {
                  $('.airportItem.tabindex0')[0].focus();
                }
              }
            }

            // Reset flag after a delay (longer than the blur timeout of 150ms)
            setTimeout(() => {
              this.searchService.onSelectingFromDropdown = false;
            }, 200);
          }, 0);
        }
      }
    }
  }
  private switchTripType = environment.amnetSpecificRelease ? AlgoTypes.LEISURE : AlgoTypes.PODUCTIVITY;
  isInputSearchTypeAirport() {
    return this.useAirpotOnlySearch;
  }
  private initPassengerTypeSpecific() {
    this.passengerTypeSpecific = JSON.parse(JSON.stringify(Constants.PASSENGERS_SPECIFIC));
    for (let passengerTypeObj of this.passengerTypeSpecific) {
      passengerTypeObj.number = Number.parseInt(this.searchForm.controls[passengerTypeObj.id].value);
    }
  }
  search = this.translateService.instant('search.AddTraveler');
  
  focusInput(event: any) {
    const input = event.currentTarget.querySelector('input[type="text"]');
    if (input) {
      input.focus();
    }
  }

  focusMulticityInput(event: any, index: number, type: string) {
    let inputId = '';
    if (type === 'source') {
      inputId = `inputFieldIDSourceAirport_${index}`;
    } else {
      inputId = `inputFieldIDDestAirport_${index}`;
    }
    
    const input = document.getElementById(inputId);
    if (input) {
      input.focus();
    } else {
      const genericInput = event.currentTarget.querySelector('input[type="text"]');
      if (genericInput) {
        genericInput.focus();
      }
    }
  }

  focusHotelInput(event: any) {
    const input = document.getElementById('hotelAddressCustomeLocationInputField');
    if (input) {
      input.focus();
    }
  }

  updateSourceValidators(min: number, max: number,formControl): void {
    const control = this.searchForm.get(formControl);
    if (!control) return;
  
    control.setValidators([
      Validators.required,
      this.spaceValidator,
      this.minLengthArray(min),
      this.maxLengthArray(max)
    ]);
  
    control.updateValueAndValidity();
  }
  createForm(): void {
    this.passengerTypeSpecific = JSON.parse(JSON.stringify(Constants.PASSENGERS_SPECIFIC));
    // var currentDate = new Date();
    // currentDate.setDate(currentDate.getDate() + 15);
    // var returnDate = new Date();
    // returnDate.setDate(returnDate.getDate() + 22);
    // var returnDateHotel = new Date();
    // returnDateHotel.setDate(returnDateHotel.getDate() + 16);
    let initialFormFields: any = {
      source: ['', Validators.compose([Validators.required, this.spaceValidator, this.minLengthArray(3), this.maxLengthArray(3)])],
      sourceCity: [null],
      destination: ['', Validators.compose([Validators.required, this.spaceValidator, , this.minLengthArray(3), this.maxLengthArray(3)])],
      destinationCity: [null],
      constraint: [IntervalType.DEPARTURE_BASED],
      constraint1: [IntervalType.DEPARTURE_BASED],
      departureDate: [null, Validators.compose([Validators.required])], // [new Date(currentDate)],
      arrivalDate: [null, Validators.compose([Validators.required])], //[new Date(returnDate)],
      constraintTime: [this.translate.instant('search.ANYTIME')],
      constraintTime1: [this.translate.instant('search.ANYTIME')],
      passengers: ['01'],
      adults: ["1"],
      seat: [""],
      ticket: [''],
      railCards:[''],
      children: ["0"],
      infants: ["0"],
      trip: [FlightTripType.ROUNDTRIP],
      timeTypeFilter: [FlightTimeType.DEPARTURE_BASED],
      timeTypeFilter1: [FlightTimeType.DEPARTURE_BASED],
      class: [FlightClassType.ECONOMY],
      classTypeSwitch: [this.switchTripType],
      flights: this.fb.array([]),
      trainLine: ['EUS']
    };
    if (this.isInputSearchTypeAirport()) {
      initialFormFields.sourceAirportCode = ['', Validators.compose([Validators.required, this.spaceValidator])];
      initialFormFields.destinationAirportCode = ['', Validators.compose([Validators.required, this.spaceValidator])];
    }
    this.searchForm = this.fb.group(
      initialFormFields, { validator: sourceDestinationValidator });


    // this.addFlight();
    this.searchHotelForm = this.fb.group({
      hotelAddress: ['', Validators.compose([Validators.required, this.spaceValidator])],
      hotelAddressCity: [''],
      currentLocation: [''],
      roomCount: ['1'],
      personCount: ['01'],
      hotelChain: [''],
      checkinDate: [null, Validators.compose([Validators.required])], //[new Date(currentDate)],
      checkoutDate: [null, Validators.compose([Validators.required])], //[new Date(returnDateHotel)]
    });

  }

  onPassengersChange(passegnerItem) {
    // 

    let params = "?ua_action=TravellersMenuItem&ua_item=" + parseInt(passegnerItem.value) + "&ua_type=flight";
    this.searchService.letsTrack(params);
    this.searchForm.controls['adults'].setValue("" + passegnerItem.value);
  }
  getAdditionalReqeustControl(): AbstractControl[] {
    return (<UntypedFormArray>this.searchForm.controls['flights']).controls;

  }

  onAddLeg() {
    if (this.multipleLeg !== this.getAdditionalReqeustControl().length) {
      this.addFlight();
      var arrayValue = { value: false, index: 0 };
      this.invalidForm.push(arrayValue);
      this.setMinimumDate((this.getAdditionalReqeustControl().length - 1));
    }
    //(<FormArray>this.searchForm.controls['flights']).push(new FormControl());
  }
  initAutocomplete(){
    this.autocomplete = new google.maps.places.Autocomplete(this.input.nativeElement, {
      fields: ['address_components', 'formatted_address', 'geometry', 'name', 'place_id', 'types'],
    });
    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      if (place && place.formatted_address) {
        const address = place.formatted_address;
        // Do something with address
      
      console.log('Selected Place:', place.formatted_address);
      this.handleHotelAddressChange(place, this.input.nativeElement.value);
      }
    });
  }
  ngAfterViewInit() {
    console.log('Input element:', this.input); //
    if (this.input) {
      this.initAutocomplete();
    }

    // Subscribe to trip type changes to trigger tripTypeChanged function
   

    this.cdRef.detectChanges();

  }
  searchAgain(event) {
    
    this.searchService.apiCallafterFlightSelection = false;
    this.searchService.backClick = false;
    this.searchAgainWithFilter.emit(event);
  }
  onRemoveLeg(index) {
    var tempArray = [...this.invalidForm];
    if (this.getAdditionalReqeustControl().length > 1) {
      this.removeFlight(index, tempArray);
    }
  }
  minLengthArray(min: number) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value) {
        if (c.value.length >= min)
          return null;

        return { 'minLengthArray': { valid: false } };
      }
    }
  }

  maxLengthArray(max: number) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value) {
        if (c.value.length <= max)
          return null;

        return { 'minLengthArray': { valid: false } };
      }
    }
  }
  public spaceValidator(control: AbstractControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }

  onBookingTypeClicked(type) {
    this.searchService.typeOfBooking = type;
    this.userAccountInfoService.typeOfBooking = type;
  }
  initializeQueryParamsfromRoute(): void {
    this.queryParmsSubscription = this.route.queryParamMap.subscribe((queryParams: Params) => {

      if (queryParams && queryParams.params && Object.keys(queryParams.params).length > 0
        && queryParams.params.resultFound) return;

      if (queryParams && queryParams.params && Object.keys(queryParams.params).length > 0
        && queryParams.params.query && queryParams.params.query.trim().length > 0) {
        if (queryParams.params.type && queryParams.params.type === 'hotel') {
          let queryParam: HotelQueryParam = deserialize(JSON.parse(decodeURIComponent(queryParams.params.query)), HotelQueryParam);
          if (parseInt(queryParam.roomCount) > 3) {
            queryParam.roomCount = "03";
          }
          this.searchHotelService.setPreviousSearch(queryParam);
        } else {
          let queryParam: FlightSearchQueryParam = deserialize(JSON.parse(decodeURIComponent(queryParams.params.query)), FlightSearchQueryParam);
          this.searchService.setPreviousSearch(queryParam);
        }
        this.setPreviousSearch();
      }

    });
  }

  getTranslatedOptions(items) {
    let returnItems = JSON.parse(JSON.stringify(items));
    for (let item of returnItems) {
      item.value = this.translate.instant(item.value);
    }
    return returnItems;
  }
  isTextEnabled() {
    if (environment.platform.toLowerCase() === 'android' && environment.appStoreBuildNumber >= 26) {
      return true;
    }
    if (environment.platform.toLowerCase() === 'ios' && environment.appStoreBuildNumber >= 27) {
      return true;
    }
    return false;
  }
  getPhoneNo(): any {
    return Constants.GALLOP_HELP_CONTACT_NO;
  }
  getEmailId(): any {
    return this.clientConfiguration.agentEmailId;
  }
  setPreviousSearch(): void {
    // this.setInitTripType(this.initResponse, this.userAccountInfoService.initResponseReceivedFoorSearchPage)
    if (!this.route.snapshot.queryParams['query'] && this.searchService.bookingAndApprovalDone && !this.searchService.searchHeaderCliked) {
      return;
    }
    this.previousSearch = this.searchService.getPreviousSearch();


    if (this.previousSearch) {
      if (this.previousSearch.trip === 'MULTICITY') {
        this.multicity = true;
        this.searchService.isSearchPage = false;
      }
      if (this.previousSearch.travellerEmails && this.previousSearch.travellerEmails.length > 0 && !this.searchService.bookingAndApprovalDone && !this.bookingService.previousTransactionId && !this.searchService.multiTripBooking || this.searchService.searchHeaderCliked) {
        this.searchService.employeeEmail = [];
        for (let item of this.previousSearch.travellerEmails) {
          if (this.userAccountInfoService.showRadio) {
            if (item !== 'GUEST') {
              let employee = this.searchService.employeeList.filter(item1 => item1.email === item);
              let employee1 = { Name: '', Id: -1, Type: '' };
              if (employee && employee.length > 0 && employee[0].employeeInfo) {
                employee1['Name'] = employee[0].firstName + " " + employee[0].lastName;
                employee1['Id'] = employee[0].employeeInfo.employeeId;
                employee1['email'] = employee[0].email;
              } else {
                if (this.bookingService.rebookingTravlleremail && this.bookingService.rebookingTravlleremail.length > 0) {
                  let guestTraveler = this.bookingService.rebookingTravlleremail.find(item1 => item1.email === item)
                  if (guestTraveler) {
                    employee1['Name'] = guestTraveler.firstName + " " + guestTraveler.lastName;
                    employee1['Id'] = -1;
                    employee1['email'] = guestTraveler.email;
                  }
                }
              }
              let userid = this.userAccountInfoService.getUserEmail();
              if (userid === employee1['email']) {
                employee1['Id'] = 0;
                employee1['Name'] = 'search.Myself';
              } else if (item === 'GUEST') {
                employee1['Name'] = 'search.Guest';
                employee1['Id'] = 1;
                employee1['email'] = 'GUEST';
              }
              this.searchService.employeeEmail.push(employee1)
            } else {
              let employee1 = { Name: '', Id: -1, Type: '' };
              employee1['Name'] = 'search.Guest';
              employee1['Id'] = 1;
              employee1['email'] = 'GUEST';
              this.searchService.employeeEmail.push(employee1)
            }
          } else {
            let employee1 = { Name: '', Id: -1, Type: '' };
            let userid = this.userAccountInfoService.getUserEmail();
            employee1['Id'] = 0;
            employee1['Name'] = 'search.Myself';
            employee1['email'] = userid;
            if (!this.route.snapshot.queryParams['query']) {
              this.searchService.employeeEmail.push(employee1)
            }
          }
        }
        if (this.previousSearch.travellerAgeGroup && this.previousSearch.travellerAgeGroup.length > 0) {
          this.searchService.ageGroupArray = [];
          this.searchService.ageGroupArray = this.previousSearch.travellerAgeGroup;
        }else{
          if(this.previousSearch.adults != '0' && parseInt(this.previousSearch.adults) > 0 ){
              this.searchService.ageGroupArray = [];
                this.searchService.employeeEmail.forEach(e=>{
                    this.searchService.ageGroupArray.push({ id: 'ADT', value: 'Adult (12 years and above)', label: '(Adult> 12 years and above)',superAdult:true })
                })
            };
        };

      }
      if (this.searchService.employeeEmail.length > 0) {
        for (let item of this.searchService.employeeEmail) {
          if (item.email !== 'GUEST') {
            this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
          }
        }
      }
      this.setPreviousSearchConstraint();
      if(this.searchService.trainFilter.length > 0){
        this.searchForm.controls['trainLine'].enable();
        this.searchForm.controls['trainLine'].setValue('EUS');
      }
      this.searchForm.controls['departureDate'].enable();
      this.calenderMinimutimeSet(this.searchService.currentTimeZone);
      this.searchForm.patchValue(this.previousSearch);
      if (this.previousSearch.classTypeSwitch) {
        this.switchTripType = (this.previousSearch.classTypeSwitch) as AlgoTypes;
      }
      // Restore selected time options from previous search
      if (this.previousSearch.constraintTime) {
        const timeValue = this.previousSearch.constraintTime;
        if (this.hourlyTimeOptions && this.hourlyTimeOptions.some(h => h.titleID === timeValue)) {
          this.selectedTimeOption = 'Custom';
          this.selectedCustomTime = timeValue;
        } else {
          this.selectedTimeOption = timeValue;
          this.selectedCustomTime = '';
        }
      }
      if (this.previousSearch.constraintTime1) {
        const timeValue1 = this.previousSearch.constraintTime1;
        if (this.hourlyTimeOptions && this.hourlyTimeOptions.some(h => h.titleID === timeValue1)) {
          this.selectedTimeOption1 = 'Custom';
          this.selectedCustomTime1 = timeValue1;
        } else {
          this.selectedTimeOption1 = timeValue1;
          this.selectedCustomTime1 = '';
        }
      }
      this.patchFormArrayFromQueryParam();
      if (this.isInputSearchTypeAirport()) {
        setTimeout(() => {
          $('#inputFieldIDSourceAirport').find('input[type=text]').val(this.previousSearch.source);
          $('#inputFieldIDDestAirport').find('input[type=text]').val(this.previousSearch.destination);
        }, 100);
        if (this.searchForm.controls['sourceAirportCode'].value == null
          || this.searchForm.controls['sourceAirportCode'].value.trim() === '') {
          this.searchForm.controls['sourceAirportCode'].setValue(this.previousSearch.source);
        }

        if (this.searchForm.controls['destinationAirportCode'].value == null
          || this.searchForm.controls['destinationAirportCode'].value.trim() === '') {
          this.searchForm.controls['destinationAirportCode'].setValue(this.previousSearch.destination);
        }
      } else {
        if (this.searchForm.controls['sourceCity'].value == null
          || this.searchForm.controls['sourceCity'].value.trim() === '') {
          this.searchForm.controls['sourceCity'].setValue(this.previousSearch.source);
        }

        if (this.searchForm.controls['destinationCity'].value == null
          || this.searchForm.controls['destinationCity'].value.trim() === '') {
          this.searchForm.controls['destinationCity'].setValue(this.previousSearch.destination);
        }
      }

    }
    let previousHotelSearchHotel = this.searchHotelService.getPreviousSearch();
    if (previousHotelSearchHotel) {
      if (previousHotelSearchHotel.travellerEmail && previousHotelSearchHotel.travellerEmail.length > 0 && this.viewMode !== 'tab1' && !this.searchService.bookingAndApprovalDone && !this.searchService.multiTripBooking || this.searchService.searchHeaderCliked || this.searchService.comingFromRetryBooking) {
        this.searchService.employeeEmail = [];
        this.searchService.comingFromRetryBooking=false;
        for (let item of previousHotelSearchHotel.travellerEmail) {
          if (this.userAccountInfoService.showRadio) {
            if (item !== 'GUEST') {
              let employee = this.searchService.employeeList.filter(item1 => item1.email === item);
              let employee1 = { Name: '', Id: -1, Type: '' };
              if (employee && employee.length > 0 && employee[0].employeeInfo) {
                employee1['Name'] = employee[0].firstName + " " + employee[0].lastName;
                employee1['Id'] = employee[0].employeeInfo.employeeId;
                employee1['email'] = employee[0].email;
              } else {
                if (this.bookingService.rebookingTravlleremail && this.bookingService.rebookingTravlleremail.length > 0) {
                  let guestTraveler = this.bookingService.rebookingTravlleremail.find(item1 => item1.email === item)
                  if (guestTraveler) {
                    employee1['Name'] = guestTraveler.firstName + " " + guestTraveler.lastName;
                    employee1['Id'] = -1;
                    employee1['email'] = guestTraveler.email;
                  }
                }
              }
              let userid = this.userAccountInfoService.getUserEmail();
              if (userid === employee1['email']) {
                employee1['Id'] = 0;
                employee1['Name'] = 'search.Myself';
              } else if (item === 'GUEST') {
                employee1['Name'] = 'search.Guest';
                employee1['Id'] = 1;
                employee1['email'] = 'GUEST';
              }
              this.searchService.employeeEmail.push(employee1)
            } else {
              let employee1 = { Name: '', Id: -1, Type: '' };
              employee1['Name'] = 'search.Guest';
              employee1['Id'] = 1;
              employee1['email'] = 'GUEST';
              this.searchService.employeeEmail.push(employee1)
            }
          } else {
            let employee1 = { Name: '', Id: -1, Type: '' };
            let userid = this.userAccountInfoService.getUserEmail();
            employee1['Id'] = 0;
            employee1['Name'] = 'search.Myself';
            employee1['email'] = userid;
            if (!this.route.snapshot.queryParams['query']) {
              this.searchService.employeeEmail.push(employee1)
            }
          }
        }
      }
      if (this.searchService.employeeEmail.length > 0) {
        for (let item of this.searchService.employeeEmail) {
          if (item.email !== 'GUEST') {
            this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
          }
        }
      }
      
      if (previousHotelSearchHotel.travellerEmail) {
              this.searchService.ageGroupArray = [];
                this.searchService.employeeEmail.forEach(e=>{
                    this.searchService.ageGroupArray.push({ id: 'ADT', value: 'Adult (12 years and above)', label: '(Adult> 12 years and above)',superAdult:true })
                })

        };
      
      
      this.searchHotelForm.controls['checkinDate'].enable();

      this.setPreviousHotelSearch(previousHotelSearchHotel);
      this.searchHotelForm.patchValue(previousHotelSearchHotel);
      this.setSearchForm(-1, this.searchService.currentTimeZone);

      if (this.searchHotelForm.controls['hotelAddress'].value === 'Your current location') {
        this.selectedCurrentLocation = true;
      }
    }

  }
  getTaverleremail(item) {
    const [first, second] = item.split('@');
    //
    return first;
  }
  getTaverleremail1(item) {
    const [fisrt, second] = item.split('@');
    // 
    return second;
  }
  setPreviousHotelSearch(searchObj: any) {
    let inputCheckInDate: Date = null;
    let inputCheckOutDate: Date = null;
    if (!(searchObj.checkinDate instanceof Date)) {
      inputCheckInDate = new Date(searchObj.checkinDate.split('T')[0]);
      inputCheckOutDate = new Date(searchObj.checkoutDate.split('T')[0]);
      searchObj.checkinDate = new Date(new Date(inputCheckInDate).getTime() + new Date(inputCheckInDate).getTimezoneOffset() * 60 * 1000);
      searchObj.checkoutDate = new Date(new Date(inputCheckOutDate).getTime() + new Date(inputCheckOutDate).getTimezoneOffset() * 60 * 1000);
    }
  }
  setPreviousSearchConstraintForGivenLeg(searchObj: any) {
    let inputDate: Date = new Date();

    let inputArrivalDate: Date = null;
    let inputDepartureDate: Date = null;
    if (!(searchObj.arrivalDate instanceof Date)) {
      inputDepartureDate = new Date(searchObj.departureDate.split('T')[0]);
      if (searchObj.arrivalDate && searchObj.arrivalDate.trim().length > 0) {
        inputArrivalDate = new Date(searchObj.arrivalDate.split('T')[0]);
      }
      searchObj.departureDate = new Date(new Date(inputDepartureDate).getTime() + new Date(inputDepartureDate).getTimezoneOffset() * 60 * 1000);
      searchObj.arrivalDate = new Date(new Date(inputArrivalDate).getTime() + new Date(inputArrivalDate).getTimezoneOffset() * 60 * 1000);
    }
    searchObj.source = searchObj.source.trim();
    searchObj.destination = searchObj.destination.trim();
  }

  setPreviousSearchConstraint() {
    this.setPreviousSearchConstraintForGivenLeg(this.previousSearch);
    if (this.previousSearch.flights && this.previousSearch.flights.length > 0) {
      for (let legIndex = 0; legIndex < this.previousSearch.flights.length; legIndex++) {
        let legN = this.previousSearch.flights[legIndex];
        this.setPreviousSearchConstraintForGivenLeg(legN);
      }
    }

  }
  setInitTripType(resp, item) {
    if (resp && resp.status === 'success' && !this.route.snapshot.queryParams['query']) {

      if (resp.defaultTripType && !item) {
        if (resp.defaultTripType === 'ROUNDTRIP') {
          this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
          this.searchForm.controls['arrivalDate'].updateValueAndValidity();
        } else {
          this.searchForm.controls['arrivalDate'].clearValidators();
          this.searchForm.controls['arrivalDate'].updateValueAndValidity();
        }
        if (resp.defaultTripType === 'ONEWAY') {
          this.searchForm.controls['trip'].setValue('ONEWAY');


        } else if (resp.defaultTripType === 'ROUNDTRIP') {
          this.searchForm.controls['trip'].setValue('ROUNDTRIP');

        } else if (resp.defaultTripType === 'MULTICITY') {
          var tempArray = [...this.invalidForm];
          this.invalidForm = [{ value: false, index: 0 }];
          this.multicity = false;
          while (this.getAdditionalReqeustControl().length !== 0) {
            this.removeFlight(0, tempArray);
          }
          setTimeout(() => {
            if (!this.previousSearch) {
              this.searchForm.controls['trip'].setValue('MULTICITY');
              this.addFlight();
              this.searchService.isSearchPage = false;
              this.setMinimumDate((0));
              this.multicity = true;

              // Initialize multicity calendar state
              this.showCustomCalendarMulticity = [];
              this.selectedTimeOptionMulticity = [];
              this.showCustomTimingMulticity = [];
              this.selectedCustomTimeMulticity = [];
              this.selectedTimeOptionMulticity[0] = this.translate.instant('search.ANYTIME');
              this.showCustomTimingMulticity[0] = false;
              this.showCustomCalendarMulticity[0] = false;
            }
          }, 100);


        }
        setTimeout(() => {
          this.userAccountInfoService.initResponseReceivedFoorSearchPage = true;
        }, 100);
      } else if (resp.defaultTripType && item) {
        if (resp.defaultTripType === 'ROUNDTRIP') {
          this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
          this.searchForm.controls['arrivalDate'].updateValueAndValidity();
        } else {
          this.searchForm.controls['arrivalDate'].clearValidators();
          this.searchForm.controls['arrivalDate'].updateValueAndValidity();
        }
        if (resp.defaultTripType === 'ONEWAY') {
          this.searchForm.controls['trip'].setValue('ONEWAY');


        } else if (resp.defaultTripType === 'ROUNDTRIP') {
          this.searchForm.controls['trip'].setValue('ROUNDTRIP');

        } else if (resp.defaultTripType === 'MULTICITY') {
          var tempArray = [...this.invalidForm];
          this.invalidForm = [{ value: false, index: 0 }];
          this.multicity = false;
          while (this.getAdditionalReqeustControl().length !== 0) {
            this.removeFlight(0, tempArray);
          }
          setTimeout(() => {
            if (!this.previousSearch) {
              this.searchForm.controls['trip'].setValue('MULTICITY');
              this.addFlight();
              this.searchService.isSearchPage = false;
              this.setMinimumDate((0));
              this.multicity = true;

              // Initialize multicity calendar state
              this.showCustomCalendarMulticity = [];
              this.selectedTimeOptionMulticity = [];
              this.showCustomTimingMulticity = [];
              this.selectedCustomTimeMulticity = [];
              this.selectedTimeOptionMulticity[0] = this.translate.instant('search.ANYTIME');
              this.showCustomTimingMulticity[0] = false;
              this.showCustomCalendarMulticity[0] = false;
            }
          }, 100);


        }
        setTimeout(() => {
          this.userAccountInfoService.initResponseReceivedFoorSearchPage = true;
        }, 100);
      }

    }
  }
  sortList(data) {
    data.sort(function (a, b) {
      // 
      if (a.userName === "" || !a.userName) {
        return 1;
      } else if (b.userName === "" || !b.userName) {
        return -1;
      } else if (a.userName < b.userName) { return -1; }
      else if (a.userName > b.userName) { return 1; }
      return 0;
    })
    return data;
  }
  
  
  swapOriginAndDeatinationForMuticity(i) {
    this.rotatingIndex = i;
    this.swapRotatedMulticity[i] = true;
    setTimeout(() => {
      this.swapRotatedMulticity[i] = false;
    }, 600);
    
    let formarray: any = (this.searchForm.get('flights') as UntypedFormArray).at(i);
    let dest = formarray.controls['source'].value;
    formarray.controls['source'].setValue(formarray.controls['destination'].value);
    formarray.controls['sourceAirportCode'].setValue(formarray.controls['destination'].value);
    formarray.controls['destination'].setValue(dest);
    formarray.controls['destinationAirportCode'].setValue(dest);
    let params = "?ua_action=swappingSourceDestination=1&ua_item=" + 'MULTICITY';
    this.searchService.letsTrack(params);
    for (let item of this.searchService.sourceLocationForMultilatLng) {
      if (item.source === formarray.controls['source'].value) {
       
        this.setTimeZoneForAirportSearch(item,i);
      }
    }
    for (let item of this.searchService.destLocationForMultilatLng) {
      if (item.source === formarray.controls['source'].value) {
        this.setTimeZoneForAirportSearch(item,i);
      }
    }
    
      setTimeout(() => {
      if (this.rotatingIndex === i) {
        this.rotatingIndex = null;
      }
    }, 1500);
  }
  swapOriginAndDeatination(swap) {
    this.rotatingIndex = swap;
    this.swapRotated = true;
    setTimeout(() => {
      this.swapRotated = false;
    }, 600);
    let dest = this.searchForm.controls['source'].value;
    this.searchForm.controls['source'].setValue(this.searchForm.controls['destination'].value);
    this.searchForm.controls['sourceAirportCode'].setValue(this.searchForm.controls['destination'].value);
    this.searchForm.controls['destination'].setValue(dest);
    this.searchForm.controls['destinationAirportCode'].setValue(dest);
    let params = "?ua_action=swappingSourceDestination=1&ua_item=" + 'ONEWAYORROUNDTRIP';
    this.searchService.letsTrack(params);
    if (this.searchService.sourceLocationForlatLng.source === this.searchForm.controls['source'].value) {
      this.setTimeZoneForAirportSearch(this.searchService.sourceLocationForlatLng,-1);
    }

    if (this.searchService.destLocationForlatLng.source === this.searchForm.controls['source'].value) {

      this.setTimeZoneForAirportSearch(this.searchService.destLocationForlatLng.timeZoneId,-1);
    }

     setTimeout(() => {
      if (this.rotatingIndex === swap) {
        this.rotatingIndex = null;
      }
    }, 500);
  }
  setTravellerForMUltiBooking() {
    let index = 0
    for (let item of this.searchService.employeeEmail) {
      if (this.userAccountInfoService.showRadio) {
        if (item.email !== 'GUEST') {
          let employee = this.searchService.employeeList.filter(item1 => item1.email === item.email);
          let employee1 = { Name: '', Id: -1, Type: '' };
          if (employee && employee.length > 0 && employee[0].employeeInfo) {
            employee1['Name'] = employee[0].firstName + " " + employee[0].lastName;
            employee1['Id'] = employee[0].employeeInfo.employeeId;
            employee1['email'] = employee[0].email;
          }
          let userid = this.userAccountInfoService.getUserEmail();
          if (userid === employee1['email']) {
            employee1['Id'] = 0;
            employee1['Name'] = 'search.Myself';
          } else if (item === 'GUEST') {
            employee1['Name'] = 'search.Guest';
            employee1['Id'] = 1;
            employee1['email'] = 'GUEST';
          }
          this.searchService.employeeEmail[index] = employee1
        } else {
          let employee1 = { Name: '', Id: -1, Type: '' };
          employee1['Name'] = 'search.Guest';
          employee1['Id'] = 1;
          employee1['email'] = 'GUEST';
          this.searchService.employeeEmail[index] = employee1
        }
      } else {
        let employee1 = { Name: '', Id: -1, Type: '' };
        let userid = this.userAccountInfoService.getUserEmail();
        employee1['Id'] = 0;
        employee1['Name'] = 'search.Myself';
        employee1['email'] = userid;
        if (!this.route.snapshot.queryParams['query']) {
          this.searchService.employeeEmail[index] = employee1;
        }
      }
      index++;
    }
  }
  ngOnInit() {
    // Define custom locale with 2-letter weekday names for datepicker
    defineLocale('custom-en', {
      ...enGbLocale,
      weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
    });
    this.bsLocaleService.use('custom-en');

   document.body.classList.add('search-body');
    addingHeader();
    this.closeAirportComponent();
    // 🎯 Setup Visual Viewport listener for keyboard offset
    if ('visualViewport' in window) {
      this.setupVisualViewportListener();
    } else {
      console.warn('Visual Viewport API not supported. Falling back to default top: 0.');
    }

    this.searchHotelService.hotelCodeHasNoRoom = [];
    this.bookingService.bookRequestProgress = false;
    this.searchService.type1 = [];
    this.searchService.paymentPage = false;
    
    // Reset the coming back from flights flag after component initialization
   
    this.searchService.seatSelectArray1 = [];
    this.bookingService.priceChangeData = [];
    this.bookingService.priceChanngeFlight = undefined;
    this.deviceSubscription = this.deviceDetailsService.currScreenWidth$.subscribe(screenWidth => {
      this.currScreenWidth = screenWidth;
    });
    // this.searchService.multipleOutgoingSelectedFlight =[];
    this.bookingService.cardAllowed = [];
    this.searchHotelService.selectTypeFrom = 'list';
    this.searchHotelService.selectedHotelFromMap = undefined;
    this.searchHotelService.roomPriceChange = [];
    this.carBookingService.originalCarSearchResponse = [];
    this.carBookingService.noFilterRequired = 0;
    this.carBookingService.locationFound = 0;
    this.urlParameterSubscription = this.route.queryParamMap.subscribe((queryParams: Params) => {
      if (queryParams && queryParams.params && Object.keys(queryParams.params).length > 0) {
        if (!this.searchService.searchHeaderCliked && !queryParams.params['query'] && !this.searchService.comingBackFromFlights) {
          this.setEventData(queryParams.params);
        }
        if (queryParams.params && queryParams.params['redirectedBackFromSignIn']) {
          this.userAccountInfoService.comingFromLoginPage = true;
          this.detailCame = false;
          if (this.listEmployeesResponseSubscription) {
            this.listEmployeesResponseSubscription.unsubscribe();
          }
          if (this.listTravellerResponseSubscription) {
            this.listTravellerResponseSubscription.unsubscribe();
          }
        } else {
          this.userAccountInfoService.comingFromLoginPage = false;
        }
        // Check if we need to open event modal from header nav click
        if (queryParams.params && queryParams.params['showEventModal'] === 'true') {
          this.openEventModalFromNav();
        }
        if (queryParams.params.type && queryParams.params.type === 'hotel') {
          this.viewMode = 'tab2';
          if (this.searchService.multiTripBooking) {
            this.setTravellerForMUltiBooking();
          }
          
          //this.titleService.setTitle('Hotel Search');
          this.titleService.setTitle(this.translateService.instant('search.HotelSearch'));
          setTimeout(() => {
            console.log('Input element:', this.input,this.autocomplete);
            if (this.input) {
              this.initAutocomplete();
            }
        
            this.cdRef.detectChanges();
          }, 0);
        } else if (queryParams.params.type && queryParams.params.type === 'car') {
          this.viewMode = 'tab3';
          if (this.searchService.multiTripBooking) {
            this.setTravellerForMUltiBooking();
          }
          
          //this.titleService.setTitle('Car Search');
          if (this.searchService.multiTripBooking) {
            this.setTravellerForMUltiBooking();
          }
          this.titleService.setTitle(this.translateService.instant('search.CarSearch'));
        } else if (queryParams.params.type && queryParams.params.type === 'allbookings') {
          this.viewMode = 'tab4';
          this.showAllBookings = true;
          this.searchService.showAllBookings = true;
          //this.titleService.setTitle('Car Search');
          this.titleService.setTitle(this.translateService.instant('search.ALLBookings'));
        }else if (queryParams.params.type && queryParams.params.type === 'train') {
          this.viewMode = 'tab5';
          if(this.searchService.multiTripBooking){
            this.setTravellerForMUltiBooking();
          }
          this.titleService.setTitle(this.translate.instant('search.TrainSearch'));
        //  if (!this.searchService.searchHeaderCliked && !this.route.snapshot.queryParams['query']) {
          this.getStationListForTrain();
         // }
        }
        else {
          this.viewMode = 'tab1';
          if (this.searchService.multiTripBooking) {
            this.setTravellerForMUltiBooking();
          }
          if (!this.searchService.showFlightTab && this.searchService.showHotelTab) {
            this.hotelTabClicked();
          }
          if (!this.searchService.showFlightTab && !this.searchService.showHotelTab && this.searchService.showCarTab) {
            this.carTabClicked();
          }
          // this.titleService.setTitle('Flight Search');
          this.titleService.setTitle(this.translateService.instant('search.FlightSearch'));
          if(this.searchService.trainFilter.length > 0){
            this.titleService.setTitle(this.translate.instant('search.TrainSearch'));
          }
          // this.searchForm.controls['trip'].setValue('ONEWAY');
          // this.setInitTripType(this.initResponse,false)
        }
      } else {
        this.viewMode = 'tab1';
        if (this.searchService.multiTripBooking) {
          this.setTravellerForMUltiBooking();
        }
        this.titleService.setTitle(this.translateService.instant('search.FlightSearch'));
        if(this.searchService.trainFilter.length > 0){
          this.titleService.setTitle(this.translate.instant('search.TrainSearch'));
        }
        // this.titleService.setTitle('Flight Search');
        // this.searchForm.controls['trip'].setValue('ONEWAY');
        //this.setInitTripType(this.initResponse,false)
      }

    });
    this.userInItSubscription = this.userAccountInfoService.userAccountInitObjObserver$.subscribe(resp => {
      if (resp && resp.status === 'success') {
        this.initResponse = resp;
        if (resp.defaultConfig) {
          this.searchService.mapSupprted = resp.defaultConfig.mapsSupported;
          this.searchService.tripFeatureEnabled = resp.defaultConfig.tripFeatureEnabled;
          this.searchService.infantBookingAllowed = resp.defaultConfig.minorBookingSupported;
          this.searchService.showFlightTab = resp.defaultConfig.flightsEnabled;
          this.searchService.showCarTab = resp.defaultConfig.carsEnabled;
          this.searchService.showHotelTab = resp.defaultConfig.hotelsEnabled;
          this.searchService.logoIcon = resp.defaultConfig.logoIcon;
          if (!this.searchService.showFlightTab && this.searchService.showHotelTab) {
            this.hotelTabClicked();
          }
          if (!this.searchService.showFlightTab && !this.searchService.showHotelTab && this.searchService.showCarTab) {
            this.carTabClicked();
          }
        }
        if (resp.maxAllowedHotelStay) {
          this.searchService.maxAllowedHotelStay = resp.maxAllowedHotelStay;
          this.maximumDate3.setDate(this.maximumDate3.getDate() + resp.maxAllowedHotelStay);
        }
        this.setInitTripType(resp, this.userAccountInfoService.initResponseReceivedFoorSearchPage)
        if (!resp.multiCitySupported) {
          this.tripOptions = this.tripOptions.filter(item => item.id !== 'MULTICITY')
        }
        this.userAccountInfoService.initResponseReceived = true;
        if (this.userAccountInfoService.userIsDeptAdmin) {
          if (this.userAccountInfoService.onBoardingTask.indexOf('booking') === -1) {
            let params = "?ua_action=OnboardingTasks&ua_item=booking";
            this.searchService.letsTrack(params);
          }
        }
      }
    });

    this.searchInProgress = false;
    this.clearPreviousResults();

    this.deviceSubscription = this.deviceDetailsService.isMobile1().subscribe(isMobile => {
      this.isMobile = isMobile;
      if (this.isResult) {
        this.setIsCollapsed(true);
        if (isMobile) {
          addNavigationComponentPadding();
        }
        NavigationUtil.setCurrentNavigationMenu(NavigationUtil.NAVIGATION_MENU_RESULTS);
      } else {
        NavigationUtil.setCurrentNavigationMenu(NavigationUtil.NAVIGATION_MENU_BOOK);
        removeNavigationComponentPadding();
      }
    });
    this.deviceDetailsService.isTabletOrMobile().subscribe(isTabletOrMobile => {
      this.isTabletOrMobile = isTabletOrMobile;
    });
    if (this.location_feature_enabled) {
      this.searchHotelForm.get('hotelAddress').valueChanges.subscribe(value => {
        if (value) {
          this.showCurrentLocation = false;
        } else {
          this.showCurrentLocation = true;
        }
      }
      );
    }
    this.deviceLocationSubscription = this.deviceDetailsService.userIPLoation$.subscribe(location => {
      if (!this.searchForm.controls['source'].value || this.searchForm.controls['source'].value == null
        || this.searchForm.controls['source'].value.length == 0) {
        if (!this.isInputSearchTypeAirport() && location) this.setDefaultOrigin(location.address, location.city);
      }
    });
    if (!this.searchService.multiTripBooking || this.searchService.multiTripBooking) {
      this.listTravellerResponseSubscription = this.adminPanelService.employeeListResponseObservable$.subscribe(response => {
        if (response) {
          if (response.length > 0) {
            this.searchService.employeeList = response;
          }
        }
      });
          this.getEmployeeAndTravellerList = () => {
      this.listEmployeesResponseSubscription = this.searchService.travellerListResponseObservable$.subscribe(response => {
      
        if (!this.employeeListCame && !this.route.snapshot.queryParams['query']) {
          if (response) {
            if (response.length > 0) {
              this.searchService.travellerList = response;
              this.employeeListCame = true;
              let userid = this.userAccountInfoService.getUserEmail();
              let userName = this.userAccountInfoService.getUserName();
              let sortEmployee = this.sortList(response);
              if (this.searchService.selectedEventForBooking && this.searchService.selectedEventForBooking.length > 0) {
                let userid = this.userAccountInfoService.getUserEmail();
                this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
              }else if ((this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0)&&  this.userAccountInfoService.showRadio && this.njoySpecificBuild && !this.bookingService.previousTransactionId ){
        
                this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
              } else if (this.userAccountInfoService.showRadio && !this.njoySpecificBuild && (this.isUserCompanyTravelManager() || this.userAccountInfoService.isUserCorporateAdmin()) && (!this.searchService.multiTripBooking && !this.bookingService.previousTransactionId && !this.route.snapshot.queryParams['query'])) {
                this.searchService.employeeEmail = [];
                this.searchService.ageGroupArray = [];
              } else if (this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0
                && (!this.bookingService.previousTransactionId && !this.isUserCompanyTravelManager() && !this.userAccountInfoService.isUserCorporateAdmin())) {
                this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
              } else if (!this.searchService.searchStart && this.bookingService.previousTransactionId && this.bookingService.rebookingTravlleremail && this.bookingService.rebookingTravlleremail.length > 0) {
                this.searchService.employeeEmail = [];
                this.searchService.ageGroupArray = [];
                let i = 0;
                for (let user of this.bookingService.rebookingTravlleremail) {
                  let findIndex = sortEmployee.findIndex(item => item.userId === user.email);
                  if (findIndex > -1) {
                    let userid = this.userAccountInfoService.getUserEmail();
                    if (userid !== user.email) {
                      let employee = { Name: '', Id: -1, Type: '' }
                      employee['Name'] = sortEmployee[findIndex].userName;
                      employee['Id'] = 1;
                      employee['email'] = sortEmployee[findIndex].userId;
                      this.searchService.employeeEmail.push(employee);
                    } else {
                      let employee = { Name: 'search.Myself', Id: -1, Type: '' };
                      employee['Id'] = 0;
                      employee['email'] = sortEmployee[findIndex].userId;
                      this.searchService.employeeEmail.push(employee);
                    }
                  } else {
                    let employee = { Name: '', Id: -1, Type: '' }
                    employee['Name'] = user.firstName + user.lastName;
                    employee['Id'] = -1;
                    employee['email'] = user.email;
                    if (user && user.travellerType == 'INFANT') {
                      let groupAge = this.ageGroupList.find(item => item.id === 'INF');
                      this.searchService.ageGroupArray[i] = groupAge;
                    } else if (user && user.travellerType == 'ADULT') {
                      let groupAge = this.ageGroupList.find(item => item.id === 'ADT');
                      groupAge.superAdult =true;
                      this.searchService.ageGroupArray[i] = groupAge;
                    }
                    else if (user && user.travellerType == 'CHILD') {
                      let groupAge = this.ageGroupList.find(item => item.id === 'CHD');
                      this.searchService.ageGroupArray[i] = groupAge;
                    }
                    this.searchService.employeeEmail.push(employee);
                  }
                  i++;
                }
                this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
                this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
                
              }
              
              let undefinedEmail =  this.searchService.employeeEmail.findIndex(e => (e.Name == 'search.Myself' && e.email == undefined));
              if(undefinedEmail >= 0){
                 this.searchService.employeeEmail[undefinedEmail] = { Name: 'search.Myself', Id: 0, email: userid };
              };
              this.searchService.employeeOptions = new Array(1).fill(null).map(_ => []);
              this.searchService.originalEmployeeOptions = new Array(1).fill(null).map(_ => []);
              this.searchService.originalEmployeeOptions[0] = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
              this.searchService.employeeOptions[0] = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
              for (let item of sortEmployee) {
                let employee = { Name: '', Id: -1, Type: '' }
                let userid = this.userAccountInfoService.getUserEmail();
                if (userid !== item.userId) {
                  employee['Name'] = item.userName
                  if (item['employeeIdentifier']) {
                    employee['Name'] = employee['Name'] + ' - ' + item['employeeIdentifier'];
                  }
                  employee['Id'] = 1;
                  employee['email'] = item.userId;
                  employee.Type = 'search.OtherEmployees';
                  this.searchService.employeeOptions[0].push(employee);
                  this.searchService.originalEmployeeOptions[0].push(employee);
                }
              }
              for (let item of this.searchService.employeeEmail) {
                if (item.email !== "GUEST") {
                  this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
                }
              }
            } else {
              let userid = this.userAccountInfoService.getUserEmail();
              let userName = this.userAccountInfoService.getUserName();
               if (this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0 && this.userAccountInfoService.showRadio && this.njoySpecificBuild){
                this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
              } else if (this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0
                && (!this.isUserCompanyTravelManager() && !this.userAccountInfoService.isUserCorporateAdmin())) {
                this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
              }
              this.searchService.travellerList = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
              this.searchService.employeeOptions = new Array(1).fill(null).map(_ => []);
              this.searchService.originalEmployeeOptions = new Array(1).fill(null).map(_ => []);
              this.searchService.originalEmployeeOptions[0] = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
              this.searchService.employeeOptions[0] = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
              for (let item of this.searchService.employeeEmail) {
                if (item.email !== "GUEST") {
                  this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
                }
              }

            }
            

          } else {
            if( this.userAccountInfoService.getUserEmail()){
            let userid = this.userAccountInfoService.getUserEmail();
              this.setmySelfUser(userid)
          }else{
            this.userDetailsSubscription = this.userAccountInfoService.userAccountInfoObjObserver$.subscribe((userProfile: UserAccountInfo) => {
              if (this.userAccountInfoService.isLoggedIn() && this.userAccountInfoService.getUserEmail()){
              let userid = this.userAccountInfoService.getUserEmail();
              this.setmySelfUser(userid)
            }

        });
        }
          }
        }
      });
    }
  this.getEmployeeAndTravellerList();
  }
    this.detailCame = false;
    this.userDetailsSubscription = this.userAccountInfoService.userAccountInfoObjObserver$.subscribe((userProfile: UserAccountInfo) => {
      if (CommonUtils.doesPathContain(window.location.href, 'search')) {

        if (this.searchForm.controls['source'].value && this.searchForm.controls['source'].value.length >= 3) return;
        if (!this.isInputSearchTypeAirport() && userProfile && userProfile.userInfo != null) {
          if (userProfile.userInfo.home && userProfile.userInfo.home != null && userProfile.userInfo.home.address
            && userProfile.userInfo.home.address.length > 4) {
            this.setDefaultOrigin(userProfile.userInfo.home.address, "City");
          }
        }
      }


      let userid = this.userAccountInfoService.getUserEmail();
      let sToken = this.userAccountInfoService.getSToken();
      if (userProfile) {

        if (this.userAccountInfoService.showRadio && !this.njoySpecificBuild && (this.isUserCompanyTravelManager() || this.userAccountInfoService.isUserCorporateAdmin()) && !this.bookingService.previousTransactionId && !this.searchService.multiTripBooking) {
          this.searchService.employeeEmail = [];
          this.searchService.ageGroupArray = [];
          if (this.route.snapshot.queryParams['query']) {
            this.searchService.bookingAndApprovalDone = true;
          }
        }
        this.detailCame = true;
        if (this.userAccountInfoService.showRadio) {
          if (this.userAccountInfoService.isConnected) {
            if ((this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0)&&  this.userAccountInfoService.showRadio && this.njoySpecificBuild && !this.bookingService.previousTransactionId ){
        
              this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
            }
          }
        } else {
          if ((this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0 && !this.route.snapshot.queryParams['query'])) {
            this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
          }
        }
        if (this.userAccountInfoService.isConnected) {
          this.userAccountInfoService.fetchUserPreferences();
        }

        // Only fetch invite list if user is logged in with valid credentials
        if (this.userAccountInfoService.isLoggedIn() && this.userAccountInfoService.getUserEmail() && this.userAccountInfoService.getSToken() ) {
        this.fetchInviteListSubscription = this.userAccountInfoService.fetchInviteList().subscribe(resp => {
            // Check if user is still logged in when response comes back
            if (resp && resp.success && this.userAccountInfoService.isLoggedIn()) {
            if (resp.data && resp.data.length > 0) {
              this.userAccountInfoService.eventList = resp.data;
              if (this.route.snapshot.queryParams && !this.route.snapshot.queryParams.query && this.route.snapshot.queryParams && !this.route.snapshot.queryParams.eventid && !this.eventModalShown && !this.searchService.showAllBookings && !this.searchService.multiTripBooking && !this.bookingService.previousTransactionId){
                if(this.bsModalRef){
                  this.bsModalRef.hide();
                }
                this.bsModalRef = this.modalService.show(this.eventTripDetsils, { class: 'modal-dialog-centered event-modal-dialog' });
                document.body.classList.add('event-modal-open');
                this.bsModalRef.onHidden.subscribe(() => {
                  document.body.classList.remove('event-modal-open');
                });
                this.eventModalShown = true;
              }
              if (!this.searchService.searchHeaderCliked) {
                if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.eventid && !this.route.snapshot.queryParams['query'] && !this.searchService.comingBackFromFlights){
                  this.setEventData(this.route.snapshot.queryParams);
                }
              }
            } else {
              this.userAccountInfoService.eventList = [];
            }
          }
          });
        }


        let startDate1: Date = new Date();
        let endDate1: Date = new Date();
        endDate1.setDate(endDate1.getDate() + 1);
        startDate1.setDate(startDate1.getDate() -1);
        let tempdate1 = DateUtils.getFormattedDateWithoutTimeZone(startDate1);
        let tempdate2 = DateUtils.getFormattedDateWithoutTimeZone(endDate1);
        let startDate = DateUtils.getDayAsLocalISODateString(tempdate1);
        let endDate = DateUtils.getDayAsLocalISODateString(tempdate2);
        this.adminPanelService.fetchCompanyApprovals(this.userAccountInfoService.getUserCompanyId(), startDate, endDate, 'all');
      }
      // if (!this.userAccountInfoService.njoySpecificBuild) {
      //   if (this.userAccountInfoService.userIsAdmin && this.userAccountInfoService.comingFromLoginPage) {

      //     // this.userAccountInfoService.comingFromLoginPage = false;
      //     if (this.userAccountInfoService.userIsDeptAdmin && !this.loginService.currentUrl) {
      //      // this.titleService.setTitle('Dashboard');
      //       this.titleService.setTitle(this.translateService.instant('search.Dashboard'));
      //       window.location.href = (this.loginService.initResponse.dashboardAppBaseUrl + 'admin?type=dashboard'
      //         + "&userid=" + userid + "&sToken=" + sToken
      //       );
      //       this.loginService.currentUrl = undefined;
      //     } else if (!this.loginService.currentUrl) {
      //      // this.titleService.setTitle('Pending Approvals');
      //       this.titleService.setTitle(this.translateService.instant('search.PendingApprovals'));
      //       window.location.href = (this.loginService.initResponse.dashboardAppBaseUrl + 'admin?type=approvals&subType=pending'
      //         + "&userid=" + userid + "&sToken=" + sToken
      //       )
      //       this.loginService.currentUrl = undefined;
      //     }
      //   }
      // } else {
          // this.userAccountInfoService.comingFromLoginPage = false;

      // }
    });
    this.companyApprovalSubscription = this.adminPanelService.companyApprovalResponseObservable$.subscribe((reportResponse) => {
      if (reportResponse) {
        if (reportResponse.pendingApprovals.length > 0) {
          for (let item of reportResponse.pendingApprovals) {
            if (this.getTimeDiffernece(item).mins > 0) {
              this.searchService.showApprovalaInMenu = true;
              break;
            } else {
              this.searchService.showApprovalaInMenu = false;
            }
          }

        } else {
          this.searchService.showApprovalaInMenu = false;
        }

      } else {
        this.searchService.showApprovalaInMenu = false;
      }
    });
    if (!this.route.snapshot.queryParams['query']) {
      //   this.setInitTripType(this.initResponse, this.userAccountInfoService.initResponseReceivedFoorSearchPage)
      if (this.searchService.bookingAndApprovalDone && !this.searchService.searchHeaderCliked) {
        return;
      } else {
        this.setPreviousSearch();
      }

    } else if (this.route.snapshot.queryParams['resultFound']) {
      this.setPreviousSearch();
    }
    else {
      this.initializeQueryParamsfromRoute();
    }

    this.initPassengerTypeSpecific();
    if (this.isResult) {
      this.setIsCollapsed(true);
      if (this.isMobile) {
        addNavigationComponentPadding();
      }
    } else {
      removeNavigationComponentPadding();
    }
  }
  latlongSubscription: Subscription;
  getDisplayDate(dateString) {
    return new Date(dateString.substring(0, 19));
  }
  setmySelfUser(userId){
    let userid = userId;
    let userName = this.userAccountInfoService.getUserName();
    if ((this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0)&&  this.userAccountInfoService.showRadio && this.njoySpecificBuild && !this.bookingService.previousTransactionId ){

      this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
    } else if (this.userAccountInfoService.showRadio && !this.njoySpecificBuild && (this.isUserCompanyTravelManager() || this.userAccountInfoService.isUserCorporateAdmin()) && (!this.searchService.multiTripBooking && !this.bookingService.previousTransactionId && !this.route.snapshot.queryParams['query'])) {
      this.searchService.employeeEmail = [];
      this.searchService.ageGroupArray = [];
    }else if (this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0
      && (!this.isUserCompanyTravelManager() && !this.userAccountInfoService.isUserCorporateAdmin())) {
      this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };
    }
    this.searchService.travellerList = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
    this.searchService.employeeOptions = new Array(1).fill(null).map(_ => []);
    this.searchService.originalEmployeeOptions = new Array(1).fill(null).map(_ => []);
    this.searchService.originalEmployeeOptions[0] = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
    this.searchService.employeeOptions[0] = [{ Name: 'search.Myself', Id: 0, email: userid }, { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' }];
    for (let item of this.searchService.employeeEmail) {
      if (item.email !== "GUEST") {
        this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
      }
    }

  }
  setEventData(val?) {
    if (val && val['eventid'] !=='exitEvent') {
      let userprefernce = this.userAccountInfoService.getUserPredferences();
      let userProfile = this.userAccountInfoService.getAccountInfo();
      if (val && val.eventid){
        this.searchService.selectedEventID = val.eventid;
      }
      let event = this.userAccountInfoService.eventList.filter(item => item.event.id === this.searchService.selectedEventID);
      if (event && event[0] && event[0].event.id) {
        this.searchService.selectedEventForBooking = event;
        document.body.classList.remove('event-modal-open');
        if (this.searchService.selectedEventForBooking && this.searchService.selectedEventForBooking.length > 0 && !this.route.snapshot.queryParams['query']) {
         // this.tripOptions = this.tripOptions.filter(item => item.id !== 'MULTICITY')

          this.searchForm.controls['trip'].setValue('ROUNDTRIP');

          if (this.searchService.selectedEventForBooking[0].inviteDetails.allowedDepartAirports.length > 0) {
            this.searchForm.controls['source'].setValue(this.searchService.selectedEventForBooking[0].inviteDetails.allowedDepartAirports[0]);
            this.searchForm.controls['source' + 'AirportCode'].setValue(this.searchService.selectedEventForBooking[0].inviteDetails.allowedDepartAirports[0])
          } else {
            if (userprefernce && userprefernce.homeAirport && userprefernce.homeAirport.length > 0) {
              this.searchForm.controls['source'].setValue(userprefernce.homeAirport[0]);
              this.searchForm.controls['source' + 'AirportCode'].setValue(userprefernce.homeAirport[0]);
            }
          }
          if (this.searchService.selectedEventForBooking[0].event.items && this.searchService.selectedEventForBooking[0].event.items.length > 0 && this.searchService.selectedEventForBooking[0].event.items[0].destinationAirports.length > 0) {
            this.searchForm.controls['destination'].setValue(this.searchService.selectedEventForBooking[0].event.items[0].destinationAirports[0]);
            this.searchForm.controls['destination' + 'AirportCode'].setValue(this.searchService.selectedEventForBooking[0].event.items[0].destinationAirports[0]);
          }
          this.searchService.allowedPaymentMethods = this.searchService.selectedEventForBooking[0].event.items && this.searchService.selectedEventForBooking[0].event.items.length > 0  ? this.searchService.selectedEventForBooking[0].event.items[0].allowedPaymentMethods:null;
          this.searchForm.controls['departureDate'].setValue(new Date(this.searchService.selectedEventForBooking[0].event.start.substring(0, 19)));
          this.searchForm.controls['arrivalDate'].setValue(new Date(this.searchService.selectedEventForBooking[0].event.end.substring(0, 19)));
          let userid = this.userAccountInfoService.getUserEmail();
          this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };

        }
      } else if (this.userAccountInfoService.eventList && this.userAccountInfoService.eventList.length > 0) {
        // Only clear selectedEventID if we have a loaded event list and the event is genuinely not found
        // Don't clear if event list hasn't loaded yet (race condition)
        this.searchService.selectedEventID = null;
      }
    }
    else if (val && val['eventid']==='exitEvent') {
      this.searchForm.controls['source'].setValue(null);
      this.searchService.selectedEventID =null;
      if (this.initResponse && this.initResponse.multiCitySupported) {
      this.tripOptions=this.origTripOption;
      }
      this.searchForm.controls['source' + 'AirportCode'].setValue(null);
      this.searchForm.controls['destination'].setValue(null);
      this.searchForm.controls['destination' + 'AirportCode'].setValue(null);
      this.searchForm.controls['departureDate'].setValue(null);
      this.searchForm.controls['arrivalDate'].setValue(null);
      this.router.navigate(['/'+this.userAccountInfoService.getDefaultRoutePath()], {
        queryParams: {},
        replaceUrl: true
      });
    }



  }
getaiprortsNearAddressGiven(){
  let homeAirports;
  this.userAccountInfoService.getAirportsNearaddressGiven(this.searchHotelForm.controls['hotelAddress'].value).subscribe(resp=>{
    if(resp && resp.status==='success'){
      var homeAirports = JSON.parse(resp.data);
      if(homeAirports && homeAirports.length >0){
       homeAirports =  homeAirports[0].timeZoneId;
       return homeAirports;
      }
    }else{
      return homeAirports;
    }
  })
  return homeAirports;
}
  enableChekinDateDate() {
    if (this.searchHotelForm.controls['hotelAddress'].value && this.searchHotelForm.controls['hotelAddress'].value !== '') {
   let timeZoneArea =  this.getaiprortsNearAddressGiven();
        if(timeZoneArea){
          this.setSearchForm(-1,timeZoneArea);
        } else {
         
            this.setSearchForm(-1);
          
        }
      }
    
    

  }
  goToEvent(item){
    this.searchService.selectedEventID = item.event.id;
    if(this.bookingService.previousTransactionId){
      this.bookingService.oldTripSessionId = undefined;
      this.bookingService.previousBooking =undefined;
      this.bookingService.previousTransaction=undefined;
      this.bookingService.previousTransactionId= undefined;
      this.bookingService.rebookingTravlleremail=[];
      this.searchService.searchStart=false;
      if ((this.isUserCompanyTravelManager() || this.userAccountInfoService.isUserCorporateAdmin()) && !this.bookingService.previousTransactionId) {
        this.searchService.employeeEmail = [];
        this.searchService.bookingAndApprovalDone =true;
      }
      this.searchService.employeeOptions[0]= this.searchService.originalEmployeeOptions[0];
    }
    this.router.navigate(['/'+this.userAccountInfoService.getDefaultRoutePath()], {
      queryParams: {eventid:item.event.id},
      replaceUrl: true
    });
    this.bsModalRef.hide();
  }
  openCheckinCalender(checkinDatePicker) {
    if (this.searchHotelForm.controls['hotelAddress'].value && this.searchHotelForm.controls['hotelAddress'].value !== '') {
      checkinDatePicker.toggle();
    } else {
      this.toastr.error(this.translate.instant('setting.Pleaseenteradestination'));
    }
  }
  openDepartureCalender(checkinDatePicker) {
    if (this.searchForm.controls['source'].value && this.searchForm.controls['source'].value !== '') {
      checkinDatePicker.toggle();;
    }else{
         if(this.viewMode == 'tab1') this.toastr.error(this.translate.instant('setting.Pleaseenteranoriginairport'));
         else if(this.viewMode == 'tab5') this.toastr.error("Please enter an origin station.")
    }
  }
  openMulticityDepartureCalender(checkinDatePicker, index) {
    let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(index);
    if (form.controls['source'].value && form.controls['source'].value !== '') {
      checkinDatePicker.toggle();
    }else{
      if(this.viewMode == 'tab1') this.toastr.error(this.translate.instant('setting.Pleaseenteranoriginairport'));
      else if(this.viewMode == 'tab5') this.toastr.error("Please enter an origin station.")
    }
  }
  autoCompleteSourceItems: any = [];
  autoCompleteDestItems: any = [];
  configOrigin: any = { 'class': 'autocompleteAirports', 'max': 10, 'placeholder': this.translate.instant('search.Origin'), 'sourceField': ['airport'] };
  configDestination: any = { 'class': 'autocompleteAirports', 'max': 10, 'placeholder': this.translate.instant('search.Destination'), 'sourceField': ['airport'] };
  setSearchForm(index,currTimezone?){
    if(this.viewMode==='tab1' || this.viewMode === 'tab5'){
      if(currTimezone){
        this.calenderMinimutimeSet(currTimezone)
      }
      if (index !== -1 || index === 0) {
        let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(index);

        let selectedDate = (form.controls['departureDate'] && form.controls['departureDate'].value) ? form.controls['departureDate'].value.setHours(0, 0, 0, 0) : null;
        let rangeDate = this.minimumDate.setHours(0, 0, 0, 0);
        if (!this.searchService.searchHeaderCliked && form.controls['source'].value && form.controls['source'].value !== '' && selectedDate && selectedDate < rangeDate) {
          form.controls['departureDate'].setValue(null);
        }
      }

      let selectedDate = (this.searchForm.controls['departureDate'] && this.searchForm.controls['departureDate'].value) ? this.searchForm.controls['departureDate'].value.setHours(0, 0, 0, 0) : null;
      let rangeDate = this.minimumDate.setHours(0, 0, 0, 0);
      if (!this.searchService.searchHeaderCliked && this.searchForm.controls['source'].value && this.searchForm.controls['source'].value !== '' && selectedDate && selectedDate < rangeDate) {
        this.searchForm.controls['departureDate'].setValue(null);
      }




    } else if (this.viewMode === 'tab2') {

      if (currTimezone) {
        this.calenderMinimutimeSet(currTimezone);
      }
      let selectedDate = (this.searchHotelForm.controls['checkinDate'] && this.searchHotelForm.controls['checkinDate'].value) ? this.searchHotelForm.controls['checkinDate'].value.setHours(0, 0, 0, 0) : null;
      let rangeDate = this.minimumDate1.setHours(0, 0, 0, 0);
      if (!this.searchService.searchHeaderCliked && this.searchHotelForm.controls['hotelAddress'].value && this.searchHotelForm.controls['hotelAddress'].value !== '' && selectedDate && selectedDate < rangeDate) {
        this.searchHotelForm.controls['checkinDate'].setValue(null);
      }
    }
  }
calenderMinimutimeSet(currTimezone){
    if(currTimezone){
      let d = new Date(new Date().toLocaleString("en-US", { timeZone: currTimezone }));
      if(this.viewMode==='tab1' || this.viewMode === 'tab5'){
        this.minimumDate = d;
      }
      if (this.viewMode === 'tab2')
        var time = "5:00 AM";
      var now = new Date();
      var dt = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " + time;
      var userval = new Date(dt);
      if (d < userval) {
        this.minimumDate1.setDate(d.getDate() - 1);
      } else {
        this.minimumDate1.setDate(d.getDate());

      }
    }
    return;

  }
  setDateWithTimeZone(item, index) {
    this.userAccountInfoService.getTimeZone(item.location).subscribe(resp => {
      if (resp && resp.timeZoneId) {
        this.searchService.currentTimeZone = resp.timeZoneId;
        this.searchService.searchHeaderCliked = false;

        this.setSearchForm(index, resp.timeZoneId)
        
      } else {
        this.searchService.searchHeaderCliked = false;
        this.setSearchForm(index);
      }
    })
  }
trainRouteSelectedInOrigin=[];
routeSetForDestination(){
  if(this.viewMode==='tab5'){
    let originValue=    this.searchForm.controls['source'].value;
    let originObject = this.autoCompleteSourceItems.filter(item1 => item1.airports[0].code===originValue)
    if(originObject && originObject.length > 0 && originObject[0].airports[0].routes){
     this.trainRouteSelectedInOrigin = originObject[0].airports[0].routes;
    }else{
     this.trainRouteSelectedInOrigin=[];
    }
     }
}
  onAutoCompleteSelect(item: any) {
    this.valueSelectedFromDropDown = true;
    this.showAirportComponent = false;

    // 🎯 Blur active element to close keyboard on mobile
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    // 🎯 Deactivate airport input positioning
    this.deactivateAirportInput();
    if (item.code) {
      // Update both the display control and the validation control
      const formUpdate = {};
      formUpdate[this.selectFormControlname] = item.code;
      formUpdate[this.selectFormControlname + 'AirportCode'] = item.code;
      this.searchForm.patchValue(formUpdate);
      if (this.selectFormControlname === 'source') {
        this.sourceAirportModel = item.code;
        let locationObj = { source: item.code, location: item.location ,timeZoneId:item.timeZoneId};
        this.searchService.sourceLocationForlatLng = locationObj;
        this.setTimeZoneForAirportSearch(item,-1);
        // this.autoCompleteSourceItems = [];
      } else {
        this.destinationAirportModel = item.code;
        let locationObj = { source: item.code, location: item.location,timeZoneId:item.timeZoneId };
        this.searchService.destLocationForlatLng = locationObj
        // this.autoCompleteDestItems = [];
      }
      if (this.selectFormControlname === 'source') {
        this.routeSetForDestination();
       
        this.autoCompleteSourceItems = [];
      } else {
        this.autoCompleteDestItems = [];
      }
      this.searchForm.markAsTouched();
      setTimeout(() => {
        $('#' + this.searchService.inputId).find('input[type=text]').val(item.code);
      }, 1);
    }
  }
  getTimeDiffernece(data) {
    const time = data.approvalExpiryTime;
    let bookingTime = new Date(time);
    let currentTime = new Date();
    let durationInMins = DateUtils.getDateDiffInMinutes(bookingTime, currentTime);
    //);
    return DateUtils.getDurationAsHrsMinObj(durationInMins);
  }
  setTimeZoneForAirportSearch(item,index){
    this.searchService.currentTimeZone = item.timeZoneId;
    this.searchService.searchHeaderCliked = false;

    this.setSearchForm(index, item.timeZoneId)
  }
  onAutoCompleteDropDownClosed(matchedItem, index, formcontrolname) {
    if (matchedItem && matchedItem.code.trim().length == 3) {
      let data = this.autoCompleteDestItems;
      if (formcontrolname === 'source') {
        data = this.autoCompleteSourceItems;
        this.setTimeZoneForAirportSearch(matchedItem,index);
      }

      this.selectAirport(matchedItem.code, formcontrolname, index, data);
    } else {
      this.setSearchForm(index);
    }
  }
  showToatsr() {
    if (!this.detailCame) {
      this.toastr.warning(this.translateService.instant("search.FetchingDetails"))
      return;
    }
    if (!this.userAccountInfoService.showRadio) {
      this.toastr.error(this.translateService.instant("search.Bookingforothersisnotallowedforyou.Pleasecontactyouadministratortoenabletheabilitytobookforothers."))
      return;
    }
  }
  removeTravler(item, i, employeeDropdown) {
    if (!this.detailCame) {
      this.toastr.warning(this.translateService.instant("search.FetchingDetails"))
      return;
    }
    if (!this.userAccountInfoService.showRadio) {
      this.toastr.error(this.translateService.instant("search.Bookingforothersisnotallowedforyou.Pleasecontactyouadministratortoenabletheabilitytobookforothers."))
      return;
    }
    this.searchService.employeeEmail.splice(i, 1);
    this.searchService.ageGroupArray.splice(i, 1);
    this.searchService.employeeOptions[0] = this.searchService.originalEmployeeOptions[0];
    for (let item of this.searchService.employeeEmail) {
      if (item.email !== "GUEST") {
        this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
      }
    }
    this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
    this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
    if (this.viewMode === 'tab2') {
      // this.searchHotelForm.controls['personCount'].setValue("" + this.searchService.employeeEmail.length);
      this.searchHotelForm.controls['roomCount'].setValue("" + this.searchService.employeeEmail.length);
    }
    if (this.searchService.employeeEmail.length === 0) {
      this.ngselect.toggle();
      setTimeout(() => {
        this.ngselect.focus();
      }, 10);
    }
  }
  ageGroupChanged(event, i) {
    if (event && event.id) {
      event.superAdult =true;
      this.searchService.ageGroupArray[i] = event
    }

  }
  getAgeGroup(i) {
    let userid = this.userAccountInfoService.getUserEmail();
    if (this.searchService.employeeEmail[i] && this.searchService.employeeEmail[i].email !== 'GUEST') {

      let employee: any = this.searchService.travellerList.filter(item => item.userId === this.searchService.employeeEmail[i].email)
      if (employee && employee.length > 0 && employee[0].dob) {
        employee = employee[0];
        let dob = new Date(employee.dob);
        let leg1DateControl = this.searchForm.controls['departureDate'];
        let todayDate;
        if (leg1DateControl.value) {
          todayDate = leg1DateControl.value;
        } else {
          todayDate = new Date();
        }
        const oneDay = 24 * 60 * 60 * 1000;
        let twelveYearsAgo: Date = new Date(todayDate.getFullYear() - 11, todayDate.getMonth(), todayDate.getDate());
        let sixteenAgo: Date = new Date(todayDate.getFullYear() - 16, todayDate.getMonth(), todayDate.getDate());
        let twoYearsAgo: Date = new Date(todayDate.getFullYear() - 2, todayDate.getMonth(), todayDate.getDate());
        let twoyesrDiff = Math.round(Math.abs((todayDate.getTime() - twoYearsAgo.getTime()) / oneDay));
        let differenceInMs: number = todayDate.getTime() - twelveYearsAgo.getTime();
        let differenceInMs2: number = todayDate.getTime() - sixteenAgo.getTime();
        let days: number = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
        let days2: number = Math.floor(differenceInMs2 / (1000 * 60 * 60 * 24));
        let diff2 = Math.floor((todayDate.getTime() - dob.getTime()) / oneDay);
        if(diff2 > days2){
          let ageGroup = this.ageGroupList.filter(item => item.id === 'ADT');
          ageGroup[0].superAdult=true;
          this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
          return this.searchService.ageGroupArray[i].value
        }else if (diff2 > days) {
          let ageGroup = this.ageGroupList.filter(item => item.id === 'ADT');
          ageGroup[0].superAdult=false;
          this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
          return this.searchService.ageGroupArray[i].value
        } else if (diff2 >= twoyesrDiff && diff2 <= days) {
          let ageGroup = this.ageGroupList.filter(item => item.id === 'CHD');
          this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
          return this.searchService.ageGroupArray[i].value
        } else if (diff2 < twoyesrDiff) {
          let ageGroup = this.ageGroupList.filter(item => item.id === 'INF');
          this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
          return this.searchService.ageGroupArray[i].value
        }
      } else if (userid === this.searchService.employeeEmail[i].email && this.userAccountInfoService.getAccountInfo()) {
        let userInfoDTO = this.userAccountInfoService.getAccountInfo().userInfo;
        let dob;
        if (userInfoDTO && userInfoDTO.dob) {
          dob = new Date(userInfoDTO.dob);

          let todayDate;
          let leg1DateControl = this.searchForm.controls['departureDate'];
          if (leg1DateControl.value) {
            todayDate = leg1DateControl.value;
          } else {
            todayDate = new Date();
          }
          const oneDay = 24 * 60 * 60 * 1000;
          let twelveYearsAgo: Date = new Date(todayDate.getFullYear() - 11, todayDate.getMonth(), todayDate.getDate());
          let sixteenAgo: Date = new Date(todayDate.getFullYear() - 16, todayDate.getMonth(), todayDate.getDate());
          let twoYearsAgo: Date = new Date(todayDate.getFullYear() - 2, todayDate.getMonth(), todayDate.getDate());
          let twoyesrDiff = Math.round(Math.abs((todayDate.getTime() - twoYearsAgo.getTime()) / oneDay));
          let differenceInMs: number = todayDate.getTime() - twelveYearsAgo.getTime();
          let differenceInMs2: number = todayDate.getTime() - sixteenAgo.getTime();
          let days: number = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
          let days2: number = Math.floor(differenceInMs2 / (1000 * 60 * 60 * 24));
          let diff2 = Math.floor((todayDate.getTime() - dob.getTime()) / oneDay);
          if(diff2 > days2){
            let ageGroup = this.ageGroupList.filter(item => item.id === 'ADT');
            ageGroup[0].superAdult=true;
            this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
            return this.searchService.ageGroupArray[i].value
          }else if (diff2 > days) {
            let ageGroup = this.ageGroupList.filter(item => item.id === 'ADT');
            ageGroup[0].superAdult=false;
            this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
            return this.searchService.ageGroupArray[i].value
          } else if (diff2 >= twoyesrDiff && diff2 <= days) {
            let ageGroup = this.ageGroupList.filter(item => item.id === 'CHD');
            this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
            return this.searchService.ageGroupArray[i].value
          } else if (diff2 < twoyesrDiff) {
            let ageGroup = this.ageGroupList.filter(item => item.id === 'INF');
            this.searchService.ageGroupArray[i] = JSON.parse(JSON.stringify(ageGroup[0]));
            return this.searchService.ageGroupArray[i].value
          }
        } else {
          if (!this.searchService.ageGroupArray[i]) {
            return 'Select age group';
          } else {
            return this.searchService.ageGroupArray[i].value;
          }
        }

      } else {
        if (!this.searchService.ageGroupArray[i]) {
          return 'Select age group';
        } else {
          return this.searchService.ageGroupArray[i].value;
        }
      }
    } else {
      if (!this.searchService.ageGroupArray[i]) {
        return 'Select age group';
      } else {
        return this.searchService.ageGroupArray[i].value;
      }
    }
  }
  openDropdown(item, item1) {
    let open = this.getItemDob(item1);
    if (!open && !this.bookingService.previousTransactionId) {
      item.toggle();
    }
  }
  getItemDob(item1) {
    let userid = this.userAccountInfoService.getUserEmail();
    if (item1 && item1.email !== 'GUEST') {
      let employee: any = this.searchService.travellerList.filter(item => item.userId === item1.email)
      if (employee && employee.length > 0 && employee[0].dob) {
        return true;
      } else if (userid === item1.email && this.userAccountInfoService.getAccountInfo()) {
        let userInfoDTO = this.userAccountInfoService.getAccountInfo().userInfo;
        if (userInfoDTO && userInfoDTO.dob) {
          return true;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  handleKeyDown1(event) {
    if (event && event.email) {
      this.showEmployeeTypeChanged(event.email);
    }

  }
  showEmployeeTypeChanged(event) {
    let userid = this.userAccountInfoService.getUserEmail();
    let finndIndex = this.searchService.employeeOptions[0].findIndex(item => item.email === event)
    if (this.searchService.employeeOptions[0][finndIndex].email === userid) {
      
      this.searchService.employeeEmail.unshift(this.searchService.employeeOptions[0][finndIndex]);

    } else {
      this.searchService.employeeEmail.push(this.searchService.employeeOptions[0][finndIndex]);
    }

    for (let item of this.searchService.employeeEmail) {
      if (item.email !== "GUEST") {
        this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
      }
      if (this.ngselect.isOpen) {
        this.ngselect.toggle();

      }
    }
    

    if (this.viewMode === 'tab2') {
      // this.searchHotelForm.controls['personCount'].setValue("" + this.searchService.employeeEmail.length);
      this.searchHotelForm.controls['roomCount'].setValue("" + this.searchService.employeeEmail.length);
    }
    this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
    this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
    let storagePassangerData: any = this.gallopLocalStorage.getItem('passengersFormData');
    if (storagePassangerData && (storagePassangerData != null)) {
      this.gallopLocalStorage.removeItem('passengersFormData');

    }
  }
  showDropDoown() {
    if(!this.userAccountInfoService.showRadio){
      return false;
    }
    if (this.searchService.multiTripBooking || this.bookingService.previousBooking) {
      return false;
    }else if (this.viewMode === 'tab1' || this.viewMode === 'tab5') {
      return true;
    } else if (this.viewMode === 'tab2') {
      return true;
    }
    else if ((this.viewMode !== 'tab1' && this.viewMode !== 'tab2' && this.viewMode !== 'tab5') && this.searchService.employeeEmail.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  changeStyleOfheight() {
    if (this.viewMode === 'tab3') {
      return { 'height': '50px' };
    } else {
      return { 'height': 'auto' };
    }
  }
  isdropDownOpen() {
    this.dropDownopen = true;
    this.search = this.translateService.instant('search.AddTraveler');
  }
  closeDropdown() {
    let userid = this.userAccountInfoService.getUserEmail();
   
    if ((this.searchService.employeeEmail && this.searchService.employeeEmail.length === 0)&&  this.userAccountInfoService.showRadio && this.njoySpecificBuild && !this.bookingService.previousTransactionId || this.searchService.employeeEmail.length === 0 && !this.isUserCompanyTravelManager() && !this.userAccountInfoService.isUserCorporateAdmin()) {
      this.searchService.employeeEmail[0] = { Name: 'search.Myself', Id: 0, email: userid };

      for (let item of this.searchService.employeeEmail) {
        if (item.email !== "GUEST") {
          this.searchService.employeeOptions[0] = this.searchService.employeeOptions[0].filter(item1 => item1.email !== item.email);
        }
        this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
        this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
      }
      let storagePassangerData: any = this.gallopLocalStorage.getItem('passengersFormData');
      if (storagePassangerData && (storagePassangerData != null)) {
        this.gallopLocalStorage.removeItem('passengersFormData');

      }
    }
    if (this.viewMode === 'tab2') {
      // this.searchHotelForm.controls['personCount'].setValue("" + this.searchService.employeeEmail.length);
      this.searchHotelForm.controls['roomCount'].setValue("" + this.searchService.employeeEmail.length);
    }
    this.dropDownopen = false;
  }
  searchByApproverNameAndEmailChanged(term: string, item: any) {
    term = term.toLowerCase();
    return (item.Name && item.Name.toLowerCase().indexOf(term) > -1) || (item.employeeIdentifier && item.employeeIdentifier.toLowerCase().indexOf(term) > -1) || item.email.toLowerCase().indexOf(term) > -1;

  }
  onAutoCompleteClose(eventObject, formcontrolname: string, parentDivId) {
    if (!this.valueSelectedFromDropDown) {
      let form = { ...this.searchForm };
      let inputText: any = $('#' + parentDivId).find('input[type=text]').val();
      let itemList;
      if (formcontrolname === 'source') {
        itemList = this.autoCompleteSourceItems;
      } else {
        itemList = this.autoCompleteDestItems;
      }
      if (itemList && itemList.length > 0 && inputText && inputText.length > 0) {
        let item = itemList.find(
          x => x.code === inputText.toUpperCase()
        );
        if (item) {
          this.onAutoCompleteSelect(item);
          return;
        }
      }
      this.clearAirportField('');
    }
  }
  onFocused(e, formcontrolname: string) {
    // Reset the dropdown closed flag so errors don't show while user is editing
    this.airportDropdownClosed[formcontrolname] = false;
    this.searchForm.controls[formcontrolname].markAsTouched();
    this.searchForm.controls[formcontrolname + 'AirportCode'].updateValueAndValidity();
    //this.clearAirportField(formcontrolname);
  }
  getAirportCodeFromSearchResponse(input) {
    return input
  }
  getAirportLocationFromSearchRersponse(input) {
    if (input.length > 4) {
      return input;
    }
    return this.getAirportCodeFromSearchResponse(input);
  }
 omit_special_char(event) {
   CommonUtils.omit_special_char(event);
  }
  // Store scroll prevention handler for cleanup
  private scrollPreventionHandler: (() => void) | null = null;
  private visualViewportHandler: (() => void) | null = null;
  private mobileAirportWrapper: HTMLElement | null = null;

  getAirportListInMobile(index, formcontrolname, elementId) {
    if (this.isMobile) {
      this.searchService.inputId = elementId;
      this.showAirportComponent = true;
      this.selectIndex = index;
      this.selectFormControlname = formcontrolname;

      // Trigger change detection first so app-airports renders
      this.cdRef.detectChanges();

      // 🎯 iOS Real Device Fix: Focus MUST happen synchronously within the user
      // tap/click handler. iOS Safari only opens the keyboard for programmatic
      // focus() when it's in the direct synchronous call chain of a user gesture.
      // detectChanges() is synchronous, so the input element exists now.
      const inputElement = document.getElementById(elementId) as HTMLInputElement;

      // 🎯 iOS Real Device Caret Fix:
      // 1. Focus synchronously within the user tap chain (required for iOS keyboard)
      // 2. Use setSelectionRange to force iOS Safari to render the caret
      if (inputElement) {
        inputElement.focus();
        const len = inputElement.value?.length || 0;
        inputElement.setSelectionRange(len, len);
      }

      // Now handle positioning and scroll prevention asynchronously
      requestAnimationFrame(() => {
        this.activateAirportInput(elementId);

        // Force scroll to top BEFORE re-focusing
        window.scrollTo({ top: 0, behavior: 'instant' });

        if (inputElement) {
          const wrapper = inputElement.closest('.airport-input-wrapper') as HTMLElement;

          // Prevent iOS from scrolling when keyboard opens
          this.preventIOSKeyboardScroll(wrapper);

          // Re-focus and force caret after positioning is stable
          setTimeout(() => {
            inputElement.focus();
            const len = inputElement.value?.length || 0;
            inputElement.setSelectionRange(len, len);

            // 🎯 iOS caret repaint: toggle opacity to force Safari to repaint the caret
            inputElement.style.opacity = '0.99';
            requestAnimationFrame(() => {
              inputElement.style.opacity = '1';
            });

            // Keep forcing scroll to top multiple times to fight browser auto-scroll
            const forceTopPosition = () => {
              window.scrollTo({ top: 0, behavior: 'instant' });
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
              if (wrapper) {
                wrapper.style.top = '0px';
              }
            };

            forceTopPosition();
            setTimeout(forceTopPosition, 50);
            setTimeout(forceTopPosition, 100);
            setTimeout(forceTopPosition, 150);
            setTimeout(forceTopPosition, 200);
            setTimeout(forceTopPosition, 300);
            setTimeout(forceTopPosition, 500);
          }, 50);
        }
      });

    //  setInputOnReadonly(elementId);
    //  unsetsetFocusOnInputField(elementId)
      this.searchString = '';
      if (index > -1) {
        if (formcontrolname === 'source') {
          var value = (<UntypedFormGroup>this.getFormArrayFLightObject(index)).controls['source'].value;
          if (value && value.length > 0) {
            this.searchAirport(value);
            this.searchService.airportSelect = value;
          } else {
            this.searchService.airportSelect = '';
          }
        } else {
          var value = (<UntypedFormGroup>this.getFormArrayFLightObject(index)).controls['destination'].value;
          if (value && value.length > 0) {
            this.searchAirport(value);
            this.searchService.airportSelect = value;
          } else {
            this.searchService.airportSelect = '';
          }
        }
      } else {
        if (formcontrolname === 'source') {
          var value = this.searchForm.controls['source'].value;
          if (value && value.length > 0) {
            this.searchAirport(value);
            this.searchService.airportSelect = value;
          } else {
            this.searchService.airportSelect = '';
          }
        } else {
          var value = this.searchForm.controls['destination'].value;
          if (value && value.length > 0) {
            this.searchAirport(value);
            this.searchService.airportSelect = value;
          } else {
            this.searchService.airportSelect = '';
          }
        }
      }
      // Direct approach: Focus keyboard after component renders
     // this.focusKeyboardDirectly();
    } else {
      this.searchString = '';
      return;
    }
  }

  private focusTimeout: any;
  closeAirportComponent(event?: Event) {
    event?.stopPropagation();
    this.showAirportComponent = false;
    this.searchService.inputId = null;
    this.autoCompleteSourceItems = [];
    this.autoCompleteDestItems = [];
    this.searchString = '';

    // 🎯 Blur active element to close keyboard on mobile
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    // 🎯 Deactivate airport input positioning
    this.deactivateAirportInput();
  }

  private lastFocusedElement: string = '';
  
  // Direct and simple keyboard focus approach
  focusKeyboardDirectly() {
    if (this.isMobile) {
      // Use multiple attempts with increasing delays
      const attempts = [100, 300, 500, 800, 1200];
      
      attempts.forEach((delay, index) => {
        setTimeout(() => {
          this.attemptKeyboardFocus();
        }, delay);
      });
    }
  }
  
  private attemptKeyboardFocus() {
    // Try both the airport component input and any visible input
    const targetSelectors = [
      'airportInputOnFullScreen',
      '.airport-input',
    ];
    
    for (const selector of targetSelectors) {
      let targetInput: HTMLInputElement | null = null;
      
      if (selector.includes('airportInputOnFullScreen')) {
        targetInput = document.getElementById(selector) as HTMLInputElement;
      } else {
        targetInput = document.querySelector(selector) as HTMLInputElement;
      }
      
      if (targetInput && this.isElementVisible(targetInput)) {
        console.log('Attempting to focus input:', selector);
        
        // Remove any blocking attributes
        targetInput.removeAttribute('readonly');
        targetInput.removeAttribute('disabled');
        
        // Force focus with multiple methods
        targetInput.focus();
        
        // For mobile browsers, especially iOS
        if (/(iPad|iPhone|iPod|Android)/g.test(navigator.userAgent)) {
          // Check if an airport is already selected by checking the airport code fields
          const isSourceSelected = this.searchForm.controls['sourceAirportCode'] &&
                                   this.searchForm.controls['sourceAirportCode'].value &&
                                   this.searchForm.controls['sourceAirportCode'].value.length === 3;
          const isDestinationSelected = this.searchForm.controls['destinationAirportCode'] &&
                                        this.searchForm.controls['destinationAirportCode'].value &&
                                        this.searchForm.controls['destinationAirportCode'].value.length === 3;

          // Only select all text if no airport is selected (for easy replacement)
          // If an airport is already selected, don't select the text to avoid accidental deselection
          if (targetInput.value && targetInput.value.length > 0 && !isSourceSelected && !isDestinationSelected) {
            targetInput.select();
            // Fallback method for better compatibility
            targetInput.setSelectionRange(0, targetInput.value.length);
          }

          // Trigger input event
          const inputEvent = new Event('input', { bubbles: true });
          targetInput.dispatchEvent(inputEvent);

          // For iOS, ensure keyboard appears
          if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
            targetInput.click();
            
            // Final iOS hack - temporarily make it contenteditable
            setTimeout(() => {
              targetInput.setAttribute('contenteditable', 'true');
              targetInput.focus();
              setTimeout(() => {
                targetInput.removeAttribute('contenteditable');
              }, 100);
            }, 50);
          }
        }
        
        // Check if focus was successful
        if (document.activeElement === targetInput) {
          console.log('Successfully focused input');
          break;
        }
      }
    }
  }
  
  private isElementVisible(element: HTMLElement): boolean {
    return element.offsetParent !== null && 
           element.offsetWidth > 0 && 
           element.offsetHeight > 0 &&
           !element.hidden;
  }
  
  // Enhanced function to ensure keyboard opens on first tap for mobile
  focusInputAndOpenKeyboard(elementId: string) {
    if (this.isMobile) {
      // Prevent rapid repeated calls on the same element
      if (this.lastFocusedElement === elementId) {
        return;
      }
      
      // Clear any existing timeout
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
      
      this.lastFocusedElement = elementId;
      
      // Small delay to ensure DOM is ready
      this.focusTimeout = setTimeout(() => {
        const inputElement = document.getElementById(elementId) as HTMLInputElement;
        if (inputElement && !inputElement.readOnly) {
          // Remove readonly if set
          inputElement.removeAttribute('readonly');
          
          // Only trigger keyboard if element is not already focused
          if (document.activeElement !== inputElement) {
            inputElement.focus();
            
            // For iOS specifically, ensure keyboard opens
            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
              // Use a more reliable method for iOS
              inputElement.setSelectionRange(0, inputElement.value.length);
            }
          }
        }
        
        // Reset the debounce after a longer period
        setTimeout(() => {
          this.lastFocusedElement = '';
        }, 300);
      }, 100);
    }
  }

  backToNormalSearch(event) {
    if (event) {
      if (this.selectIndex > -1) {
       // this.clearAirportFieldMultiCity('');

      } else {
      //  this.clearAirportField('');
      }
    }

  }
  searchAirport(term) {
    let curQueryTime = new Date();
    if(this.viewMode == 'tab1'){
    this.searchService.search1(term, 'flights')
      .subscribe(response => {
        if (curQueryTime > this.lastAirportQueryTime) {
          this.lastAirportQueryTime = curQueryTime;
          this.searchString = term;
          let incomingData = this.groupingCityName(JSON.parse(JSON.stringify(response.data)));
          if (this.selectFormControlname === 'source') {
            this.autoCompleteSourceItems = incomingData;
          } else {
            this.autoCompleteDestItems = incomingData;
          }
          this.reOrderAirportListIfInputMatchesAirportCode(term, this.selectFormControlname,
            this.groupingCityName(JSON.parse(JSON.stringify(response.data))));
        }
      })
  }
    else if( this.viewMode == 'tab5') {
      let filteredData = this.setAutoCompleteTrainSearchStation(term);
      this.reOrderAirportListIfInputMatchesAirportCode(term, this.selectFormControlname,
       filteredData);
    }
  }
  showAirportComponent = false;
  debounceTimer: any;
  
  onInputChange(event: any, inputEl: HTMLInputElement, index: number, type: string, id: any) {
    const val = event.target.value;
    this.searchService.sourceAirportInputValue = event.target.value;
    this.searchAutoComplete(val, type, index, id);
    // Clear the previous debounce to avoid overlapping executions
   
    
   
   
   
  }
  onInputBlur(inputValue: string,formControl,index?) {
    // Mark dropdown as closed when input loses focus (user finished interacting)
    const key = (index === undefined || index === -1) ? formControl : `${formControl}_${index}`;
    this.airportDropdownClosed[key] = true;

    setTimeout(() => {
    if(!this.isMobile && inputValue && inputValue.length >=3 && !this.searchService.onSelectingFromDropdown){
    const searchText = inputValue.trim().toLowerCase();
    let autoValue=[];
    if(formControl=='source'){
   autoValue = this.autoCompleteSourceItems;
    }else{
      autoValue =this.autoCompleteDestItems
    }
  
    if (!searchText || !autoValue?.length) return;
  
    for (const group of autoValue) {
      const match = group.airports.find(airport =>
        airport.airport.toLowerCase() === searchText ||
        airport.code.toLowerCase() === searchText
      );
  
      if (match && index > -1) {
        this.onAutoCompleteSelectMultiCity(match,index)
      }else{
        if (match){
        this.onAutoCompleteSelect(match);
        } // manually select matched airport
        return;
      }
    }
  }else{
    // Only close dropdown if not navigating from keyboard (onSelectingFromDropdown)
    if(!this.isMobile && !this.searchService.onSelectingFromDropdown){
    this.showAirportComponent =false;
    }
    return;
  }
}, 150);
  }
  searchAutoComplete(term: string, formcontrolname: string, index, elementId) {
    let curQueryTime = new Date();
    this.valueSelectedFromDropDown = false;
    this.selectIndex = index;
    this.selectFormControlname = formcontrolname;
    this.showAirportComponent = true;
    this.searchService.inputId = elementId;
    this.searchString = term;
    if(this.viewMode == 'tab1'){
    this.searchService.search1(term, 'flights')
      .subscribe(response => {
        if (curQueryTime > this.lastAirportQueryTime) {
          this.lastAirportQueryTime = curQueryTime;
          let incomingData = this.groupingCityName(JSON.parse(JSON.stringify(response.data)));
          if (formcontrolname === 'source') {
            this.autoCompleteSourceItems = incomingData;
          } else {
            this.autoCompleteDestItems = incomingData;
          }
          this.reOrderAirportListIfInputMatchesAirportCode(term, formcontrolname,
            this.groupingCityName(JSON.parse(JSON.stringify(response.data))));
           
        }
      })
    }
      else if( this.viewMode == 'tab5') {
       let filteredData =  this.setAutoCompleteTrainSearchStation(term);
        this.reOrderAirportListIfInputMatchesAirportCode(term, formcontrolname,
          filteredData);
          
      }
  }
  modalOpen1() {
    if (this.ngxSmartModalService.getOpenedModals() &&
      (this.ngxSmartModalService.getOpenedModals().length > 0 && this.isMobile)
    ) {
      let modals = this.ngxSmartModalService.getOpenedModals();
      if (this.searchService.inputId && this.searchService.inputId.search('Dest') !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }
  modalOpen() {
    if (this.ngxSmartModalService.getOpenedModals() &&
      (this.ngxSmartModalService.getOpenedModals().length > 0 && this.isMobile)
    ) {
      let modals = this.ngxSmartModalService.getOpenedModals();
      if (this.searchService.inputId && this.searchService.inputId.search('Source') !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }
  airportListFilteredLogic(item,formcontrolname,rootCounter,counter){
    if (item.airports.length > 1) {
      if (formcontrolname == 'source') {
        const elem =  this.autoCompleteSourceItems.splice(rootCounter, 1);
        this.autoCompleteSourceItems.splice(0, 0, elem[0]);
        return;
      } else {
        const elem =  this.autoCompleteDestItems.splice(rootCounter, 1);
        this.autoCompleteDestItems.splice(0, 0, elem[0]);
        return;
      }
    } else {
      if (counter !== 0) {
        if (formcontrolname == 'source') {
          this.autoCompleteSourceItems.unshift(item);
          this.autoCompleteSourceItems = this.filterArray(this.autoCompleteSourceItems);
          return;
        } else {
          this.autoCompleteDestItems.unshift(item);
          this.autoCompleteDestItems = this.filterArray(this.autoCompleteDestItems);
          return;
        }
      }
    }
  }
  filterTrainlist(data,code){
    let findItem;
    for(let item of data){
      for(let i=0;i<item.airports.length;i++){
        if(item.airports[i].code.toLowerCase() ===code.toLowerCase()){
          if(i > 0){
            let tempItem = item.airports[0];
            item.airports[0] = item.airports[i];
            item.airports[i] = tempItem
          }
          findItem =item;
        }
      }
    }
return findItem;
  }
  reOrderAirportListIfInputMatchesAirportCode(code, formcontrolname, data) {
    let counter = 0;
    let rootCounter = 0;
    for (let item of data) {
      for (let item1 of item.airports) {
        let city= item1.city.toLowerCase();
        if (item1.code.toLowerCase() === code.toLowerCase()) {
          this.airportListFilteredLogic(item,formcontrolname,rootCounter,counter);
          // Update the AirportCode form control to hide error when exact match found
          if (code.length === 3) {
            const airportCodeControl = formcontrolname + 'AirportCode';
            this.searchForm.controls[airportCodeControl]?.setValue(item1.code);
          }
        }else if(this.viewMode==='tab5' && (code.length ===3 ||code.length ===4)){
          let findItem = this.filterTrainlist(data,code);
          if(findItem && findItem.airports > 0){
            this.airportListFilteredLogic(findItem,formcontrolname,rootCounter,counter);
          }
        }else if(this.viewMode==='tab5' && (city.search(code.toLowerCase()))!==-1){
          this.airportListFilteredLogic(item,formcontrolname,rootCounter,counter);
        }
        counter++;
      }
      rootCounter++;
    }
  }
  selectAirport(code, formcontrolname, index, data) {
    let counter = 0;
    for (let item of data) {
      for (let item1 of item.airports) {
        if (item1.code.toLowerCase() === code.toLowerCase()) {
          if (index > -1 && !this.isMobile) {
            if (formcontrolname === 'source') {
              var value = (<UntypedFormGroup>this.getFormArrayFLightObject(index)).controls['destination'].value;
              if (item1.code === value) {
                this.invalidForm[index].value = true;
                this.invalidForm[index].index = index;
              } else {
                this.invalidForm[index].value = false;
                this.invalidForm[index].index = index;
              }
            } else {
              var value = (<UntypedFormGroup>this.getFormArrayFLightObject(index)).controls['source'].value;
              if (item1.code === value) {
                this.invalidForm[index].value = true;
                this.invalidForm[index].index = index;
              } else {
                this.invalidForm[index].value = false;
                this.invalidForm[index].index = index;
              }
            }
            let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(index);
            if (item1.code
            ) {
              form.controls[formcontrolname].setValue(item1.code);
              form.controls[formcontrolname + 'AirportCode'].setValue(item1.code);
              // this.searchForm.patchValue({ ...form });
              if (formcontrolname === 'source') {
                let locationObj = { source: item1.code, location: item1.location,timeZoneId:item1.timeZoneId };
                this.searchService.sourceLocationForMultilatLng.push(locationObj);
                this.sourceAirportModel = item1.code;
              } else {
                let locationObj = { source: item1.code, location: item1.location ,timeZoneId:item1.timeZoneId };
                this.searchService.destLocationForMultilatLng.push(locationObj);
                this.destinationAirportModel = item1.code;
              }
            }
            return;
          } else {
            if (!this.isMobile) {
              if (item1.code) {
                // Update both the display control and the validation control
                const formUpdate = {};
                formUpdate[formcontrolname] = item1.code;
                formUpdate[formcontrolname + 'AirportCode'] = item1.code;
                this.searchForm.patchValue(formUpdate);
                if (formcontrolname === 'source') {
                  let locationObj = { source: item1.code, location: item1.location,timeZoneId:item1.timeZoneId };
                  this.searchService.sourceLocationForlatLng = locationObj;
                  this.sourceAirportModel = item1.code;
                  this.routeSetForDestination();
                } else {
                  let locationObj = { source: item1.code, location: item1.location,timeZoneId:item1.timeZoneId };
                  this.searchService.destLocationForlatLng = locationObj;
                  this.destinationAirportModel = item1.code;
                }
              }
            }
          }
          return;
        } else {
          if (!this.isMobile) {
            if (index > -1) {
              this.clearAirportFieldMultiCity(code);
            } else {
              this.clearAirportField(code);
            }
          }
        }
        counter++;
      }

    }
  }

  filterArray(arr) {
    var tmp = [];
    for (var i = 0; i < arr.length; i++) {
      if (tmp.indexOf(arr[i]) == -1) {
        tmp.push(arr[i]);
      }
    }
    return tmp;
  }
  groupingCityName(data?) {
    var cityArray = [];
    if(this.viewMode == 'tab5' && !data){
     data = this.trainLocations;
    }
    for (let i = 0; i < data.length; i++) {
      var cityDataArray = { city: '', airports: [] };
      let index = cityArray.find(item => item.city === data[i].city);
      if (!index) {
        cityDataArray.city = data[i].city;
        for (let j = 0; j < data.length; j++) {
          if (data[j].city === cityDataArray.city) {
            cityDataArray.airports.push(data[j]);
          }
        }
        cityArray.push(cityDataArray);
      }
    }
    return cityArray;
  }
  clearAirportField(code) {
    let form = { ...this.searchForm };
    form.controls[this.selectFormControlname].setValue(code);
    form.controls[this.selectFormControlname + 'AirportCode'].setValue(code);
    form.controls[this.selectFormControlname].markAsTouched();
    form.controls[this.selectFormControlname + 'AirportCode'].updateValueAndValidity();
    this.searchForm.patchValue({ ...form });
    let inputFieldElementId = '';
    if (this.selectFormControlname === 'source') {
      inputFieldElementId = 'inputFieldIDSourceAirport';
    } else {
      //destination
      inputFieldElementId = 'inputFieldIDDestAirport';
    }
    if (!this.isMobile) {
      setFocusOnInputField(inputFieldElementId, '');
    }

  }
  openTravelerModal() {
    // Check if dropdown should be shown at all
     this.closeAllCalendars();
    this.showToatsr()
    if(!this.userAccountInfoService.showRadio){
    return ;
    }
    if (this.searchService.multiTripBooking || this.bookingService.previousBooking) {
    return ;
    }
    if (!this.showDropDoown()) {
    return;
    }
    this.searchService.showTravelerDropDown=true;
  }

  getTravelerCountText(): string {
    const count = this.searchService.employeeEmail?.length || 0;
    if (count === 0) {
        return this.translateService.instant('search.selectTraveler');
    } else if (count === 1) {
      return `1 ${this.translateService.instant('search.travelerSelected')}`;
    } else {
      return `${count} ${this.translateService.instant('search.travelersSelected')}`;
    }
  }

  getDepartureLabel(forDatedropDown?): string {
    // For calendar popup title (forDatedropDown=true), don't change based on toggle
    if(forDatedropDown){
       return this.translate.instant('search.DEPARTURE');
    }

    // For date card label, check toggle switch
    const timeTypeFilter = this.searchForm?.controls['timeTypeFilter']?.value;
    if (timeTypeFilter === 'ARRIVAL_BASED') {
      return this.translate.instant('ngOption.Arrive');
    }

    return this.translate.instant('search.DEPART');
  }

  getArrivalLabel(forDatedropDown?,isRoundTrip?): string {
    // For calendar popup title (forDatedropDown=true), don't change based on toggle
    if(forDatedropDown){
       if(isRoundTrip){
         return this.translate.instant('setting.Return');
       }
       return this.translate.instant('search.DEPARTURE');
    }

    // For date card label, check toggle switch
    const timeTypeFilter1 = this.searchForm?.controls['timeTypeFilter1']?.value;
    if (timeTypeFilter1 === 'ARRIVAL_BASED') {
      return this.translate.instant('ngOption.Arrive');
    }

    if(isRoundTrip){
      return this.translate.instant('setting.Return');
    }
    return this.translate.instant('search.DEPART');
  }

  getMulticityDepartureLabel(index?: number,forDatedropDown?): string {
    // For calendar popup title (forDatedropDown=true), don't change based on toggle
    if(forDatedropDown){
       return this.translate.instant('search.DEPARTURE');
    }

    // For date card label, check toggle switch
    if (index === undefined || index === -1) {
      const timeType = this.searchForm?.controls['timeTypeFilter']?.value;
      return timeType === 'ARRIVAL_BASED'
        ? this.translate.instant('ngOption.Arrive')
        : this.translate.instant('search.DEPART');
    }

    // For additional legs, check if the flight form has constraint field
    try {
      const flightForm = <UntypedFormGroup>this.getFormArrayFLightObject(index);
      if (flightForm && flightForm.controls['constraint']) {
        const timeType = flightForm.controls['constraint'].value;
        return timeType === 'ARRIVAL_BASED'
          ? this.translate.instant('ngOption.Arrive')
          : this.translate.instant('search.DEPART');
      }
    } catch (e) {
      // If form doesn't exist or has no constraint, default to Depart
    }

    return this.translate.instant('search.DEPART');
  }

  getDepartureTimeDisplay(): string {
    // If Custom is selected and there's a custom time, show the formatted custom time
    if (this.selectedTimeOption === 'Custom' && this.selectedCustomTime) {
      const hourOption = this.hourlyTimeOptions.find(h => h.titleID === this.selectedCustomTime);
      return hourOption ? this.translate.instant(hourOption.title) : this.selectedCustomTime;
    }
    // Otherwise show the selected time option
      return this.selectedTimeOption
    ? (this.selectedTimeOption === 'Custom'
        ? this.translate.instant('search.CUSTOM')
        : this.selectedTimeOption)
    : this.translate.instant('search.ANYTIME');
  }

  getArrivalTimeDisplay(): string {
    // If Custom is selected and there's a custom time, show the formatted custom time
    if (this.selectedTimeOption1 === 'Custom' && this.selectedCustomTime1) {
      const hourOption = this.hourlyTimeOptions.find(h => h.titleID === this.selectedCustomTime1);
      return hourOption ? this.translate.instant(hourOption.title) : this.selectedCustomTime1;
    }
    // Otherwise show the selected time option
      return this.selectedTimeOption1
    ? (this.selectedTimeOption1 === 'Custom'
        ? this.translate.instant('search.CUSTOM')
        : this.selectedTimeOption1)
    : this.translate.instant('search.ANYTIME');
  }

  getMulticityTimeDisplay(index: number): string {
    const timeOption = this.selectedTimeOptionMulticity?.[index];
    const customTime = this.selectedCustomTimeMulticity?.[index];

    // If Custom is selected and there's a custom time, show the formatted custom time
    if (timeOption === 'Custom' && customTime) {
      const hourOption = this.hourlyTimeOptions.find(h => h.titleID === customTime);
      return hourOption ? this.translate.instant(hourOption.title) : customTime;
    }
    // Otherwise show the selected time option
     return timeOption
    ? (timeOption === 'Custom'
        ? this.translate.instant('search.CUSTOM')
        : timeOption)
    : this.translate.instant('search.ANYTIME');
  }

  onAutoCompleteSelectMultiCity(item: any,i) {
    this.valueSelectedFromDropDown = true;
    this.selectIndex = i;
    this.showAirportComponent = false;

    // 🎯 Blur active element to close keyboard on mobile
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    // 🎯 Deactivate airport input positioning
    this.deactivateAirportInput();
    let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(this.selectIndex);
    if (item.code
    ) {
      form.controls[this.selectFormControlname].setValue(item.code);
      form.controls[this.selectFormControlname + 'AirportCode'].setValue(item.code);
      if (this.selectFormControlname === 'source') {
        this.sourceAirportModel = item.code;
        let locationObj = { source: item.code, location: item.location,timeZoneId:item.timeZoneId  };
        this.searchService.sourceLocationForMultilatLng.push(locationObj);
        this.setTimeZoneForAirportSearch(item,this.selectIndex);
      } else {
        let locationObj = { source: item.code, location: item.location,timeZoneId:item.timeZoneId  };
        this.searchService.destLocationForMultilatLng.push(locationObj);
        this.destinationAirportModel = item.code;
      }
      if (this.selectFormControlname === 'source') {
        this.autoCompleteSourceItems = [];
      } else {
        this.autoCompleteDestItems = [];
      }
      setTimeout(() => {
        $('#' + this.searchService.inputId).find('input[type=text]').val(item.code);
      }, 1);
    }
  }
  onAutoCompleteCloseMultiCity(flightIndex: number, eventObject, formcontrolname: string, parentDivId) {
    if (!this.valueSelectedFromDropDown) {
      let form = this.getFormArrayFLightObject(flightIndex);
      let inputText: any = $('#' + parentDivId).find('input[type=text]').val();
      let itemList;
      if (formcontrolname === 'source') {
        itemList = this.autoCompleteSourceItems;
      } else {
        itemList = this.autoCompleteDestItems;
      }
      if (itemList && itemList.length > 0 && inputText && inputText.length > 0) {
        let item = itemList.find(
          x => x.code === inputText.toUpperCase()
        );
        if (item) {
          this.onAutoCompleteSelectMultiCity(item,flightIndex);
          return;
        }
      }
      this.clearAirportFieldMultiCity('');
    }
  }
  onFocusedMultiCity(flightIndex: number, e, formcontrolname: string) {
    // Reset the dropdown closed flag so errors don't show while user is editing
    const key = `${formcontrolname}_${flightIndex}`;
    this.airportDropdownClosed[key] = false;
    let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(flightIndex);
    form.controls[formcontrolname].markAsTouched();
    form.controls[formcontrolname + 'AirportCode'].updateValueAndValidity();
    //this.clearAirportField(formcontrolname);
  }

  clearAirportFieldMultiCity(code) {
    let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(this.selectIndex);
    form.controls[this.selectFormControlname].setValue(code);
    form.controls[this.selectFormControlname + 'AirportCode'].setValue(code);
    form.controls[this.selectFormControlname].markAsTouched();
    form.controls[this.selectFormControlname + 'AirportCode'].updateValueAndValidity();
    this.invalidForm[this.selectIndex].value = false;
    let inputFieldElementId = '';
    if (this.selectFormControlname === 'source') {
      inputFieldElementId = 'inputFieldIDSourceAirport_' + this.selectIndex;
    } else {
      //destination
      inputFieldElementId = 'inputFieldIDDestAirport_' + this.selectIndex;
    }
    // this.autoCompleteSourceItems = [];
    //this.autoCompleteDestItems = [];
    if (!this.isMobile) {
      setFocusOnInputField(inputFieldElementId, '');
    }
  }

  setDefaultOrigin(address: string, city: string) {
    this.searchForm.controls['source'].setValue(address);
    this.searchForm.controls['sourceCity'].setValue(city);
  }

  //depricated
  subscribeToServerSideFilterValueChanges() {
    if (this.componentType == 'request') { return; }

    this.searchForm.controls['trip'].valueChanges.subscribe((val) => {
      this.searchForm.patchValue({ ...this.searchForm });
      this.submitForm()
    });

    this.searchForm.controls['passengers'].valueChanges.subscribe((val) => {
      this.searchForm.patchValue({ ...this.searchForm });
      this.submitForm()
    }
    );
    this.searchForm.controls['class'].valueChanges.subscribe((val) => {
      this.searchForm.patchValue({ ...this.searchForm });
      this.submitForm()
    });
  }

  get departDate() {
    return this.searchForm.get('departureDate').value;
  }

  get arriveDate() {
    return this.searchForm.get('arrivalDate').value;
  }

  departLeg2Date(i) {
    return (<UntypedFormGroup>this.getFormArrayFLightObject(i)).get('departureDate').value;
  }
  isSourceDestinationSame(i) {
    var value = (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['source'].value;
    var value1 = (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['destination'].value;
    if ((value !== '' && value1 !== '') && value === value1) {
      return true;
    } else {
      false
    }
  }
  get formIfInvalid() {
    let Valid = false;
    let control = <UntypedFormArray>this.searchForm.controls.flights;
    if (control && control.length > 0) {
      for (let i = 0; i < control.length; i++) {
        var value = (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['source'].value;
        var value1 = (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['destination'].value;
        if (value === value1) {
          Valid = true;
        }
      }
    }
    
    if(this.showErrorIfAgeNotSelected()){
      return true;
    }
    
    if (Valid) {
      return true;
    } else if (this.searchService.employeeEmail.length === 0) {
      return true;
    } else if (this.searchService.employeeEmail.length > 0 && this.searchService.infantBookingAllowed && this.searchService.employeeEmail.length !== this.searchService.ageGroupArray.length) {

      return true;

    }
    else {
      return this.searchForm.invalid;
    }
  }

  get formHotelIfInvalid() {
    if (this.searchService.employeeEmail.length === 0) {
      return true;
    } else {


      return this.searchHotelForm.invalid;
    }
  }

  allowAddFlight(): boolean {
    //For MVP: to restrict only till two way flights
    return (this.searchFormObjectsCount) <= 1 ? true : false;
  }
  showSelectedFlight(index): boolean {
    if (this.searchService.multipleOutgoingSelectedFlight.length > 0 && this.searchService.seletedIndex === (index + 2)) {
      return true;
    } else {
      return false;
    }
  }
  getInfantAdyltCount() {
    if (this.searchService.infantBookingAllowed) {
      let selectedAgeGroup = [];
      let adults = 0;
      let infants = 0
      let children = 0;
      if (this.searchService.ageGroupArray.length > 0) {
        for (let item of this.searchService.ageGroupArray) {
          if (item.id === 'ADT') {
            adults++;
          } else if (item.id === 'CHD') {
            children++;
          } else if (item.id === 'INF') {
            infants++;
          }
          selectedAgeGroup.push(item);
        }


      }
      if (infants > 0) {
        if (infants > adults) {
          return true;
        } else {
          return false
        }
      } else {
        return false;
      }
    }
    return false;
  }
  originalresponseForFutureBooking = [];
  overlapBookings = [];
  bsModalRefTripsModal: BsModalRef;
  @ViewChild("futureTripDetsils", { static: false }) futureTripDetsils!: TemplateRef<any>;
  @ViewChild("eventModal", { static: false }) eventTripDetsils!: TemplateRef<any>;
  filterDataForTCheckingDuplicateBooking(response, firstReportDate, lastReportDate, type) {
    let firstDate = this.getDateForOverlapCheck(firstReportDate);
    let lastDate = this.getDateForOverlapCheck(lastReportDate);
    return this.filterTRavellersByDate(response, firstDate, lastDate, type);
  }
  getIsoFromMMDDYYY(input) {
    const dateParts = input.split("/");
    return dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1] ;
  }
  getDateForOverlapCheck(date) {
    return new Date(moment(new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60 * 1000).format());
  }
  filterTRavellersByDate(response, startDate, endDate, type) {
    let filteredReport = JSON.parse(JSON.stringify(response));
    filteredReport.bookingList = filteredReport.bookingList.filter(booking => {
      let travelStartDate = new Date(CommonUtils.getTravelDate(booking));
      travelStartDate = new Date(travelStartDate.toDateString());
      let travelEndDate = null;
      if (type === 'flight' && booking.type === 'flight') {
        const lastLeg = booking.option.flight_option.legs[booking.option.flight_option.legs.length - 1];
        const lastHop = lastLeg.hops[lastLeg.hops.length -1];
        travelEndDate = this.getDateForOverlapCheck(lastHop.ends.split('T')[0]);
        travelStartDate = this.getDateForOverlapCheck(booking.option.flight_option.legs[0].hops[0].starts.split('T')[0]);
        if (travelStartDate >= startDate && travelStartDate < endDate) {
          return true;
        }
        if (travelEndDate > startDate && travelEndDate <= endDate) {
          return true;
        }
        if (travelStartDate <= startDate && travelEndDate >= endDate) {
          return true;
        }
      }
      if (type === 'hotel' && booking.type === 'hotel') {
        travelEndDate = this.getDateForOverlapCheck(booking.option.hotel_option.checkOutDate);
        travelStartDate = this.getDateForOverlapCheck(booking.option.hotel_option.checkInDate);
        if (travelStartDate >= startDate && travelStartDate < endDate) {
          return true;
        }
        if (travelEndDate > startDate && travelEndDate <= endDate) {
          return true;
        }
        if (travelStartDate <= startDate && travelEndDate >= endDate) {
          return true;
        }

      }
      if (type === 'cars' && booking.type === 'cars') {
        travelEndDate = this.getDateForOverlapCheck(this.getIsoFromMMDDYYY(booking.option.car_option.dropOffDate));
        travelStartDate = this.getDateForOverlapCheck(this.getIsoFromMMDDYYY(booking.option.car_option.pickUpDate));
        if (travelStartDate >= startDate && travelStartDate < endDate) {
          return true;
        }
        if (travelEndDate > startDate && travelEndDate <= endDate) {
          return true;
        }
        if (travelStartDate <= startDate && travelEndDate >= endDate) {
          return true;
        }
      }

      return false;
    });
    return filteredReport;
  }
  dismissModal() {
    this.bsModalRefTripsModal.hide();
  }
  duplicatBookingSubscription: Subscription;
  handleBackFromSearchPage(event) {
    this.isThisDuplicateTrip(this.futureTripDetsils, 'car', event);
  }
  isThisDuplicateTrip(modal, type, event?) {
    let emails = [];
    for (let item of this.searchService.employeeEmail) {
      emails.push(item.email);

    }
    if (this.duplicatBookingSubscription) {
      this.duplicatBookingSubscription.unsubscribe();
    }

    this.duplicatBookingSubscription = this.adminPanelService.getFutureTripsOfTravellers(emails).subscribe(resp => {
      if (resp && resp.success) {
        this.airlines = resp.data.airlineNames;
        this.airports = resp.data.airports;
        if (resp.data && resp.data.bookingList && resp.data.bookingList.length > 0) {
          this.overlapBookings = [];
          this.originalresponseForFutureBooking = resp.data;
          let selectedFlight = JSON.parse(this.gallopLocalStorage.getItem("selectedFlight"))
          let selectedCar = JSON.parse(this.gallopLocalStorage.getItem("selectedCar"))
          let selectedHotel = JSON.parse(this.gallopLocalStorage.getItem("selectedHotel"));
          if (type === 'flight') {
            if (this.searchForm.controls['trip'].value === 'MULTICITY') {
              let queryAsJSON = JSON.parse(JSON.stringify(this.searchForm.value));
              if ('flights' in queryAsJSON && queryAsJSON['flights'].length > 0) {

                let departureDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.departureDate)) + "T00:00:00.000Z";
                let arrivalDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON['flights'][queryAsJSON['flights'].length - 1].departureDate)) + "T00:00:00.000Z";



                let fligthFound = this.filterDataForTCheckingDuplicateBooking(this.originalresponseForFutureBooking, departureDate.split('T')[0], arrivalDate.split('T')[0], 'flight');
                if (fligthFound.bookingList.length > 0) {
                  this.overlapBookings = [...this.overlapBookings, ...fligthFound.bookingList]
                }
              }
            } else {
              let queryAsJSON = JSON.parse(JSON.stringify(this.searchForm.value));
              // 
              queryAsJSON.departureDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.departureDate)) + "T00:00:00.000Z";
              if (this.searchForm.controls['trip'].value === 'ROUNDTRIP') {
                queryAsJSON.arrivalDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.arrivalDate)) + "T00:00:00.000Z";
              } else {
                queryAsJSON.arrivalDate = queryAsJSON.departureDate;
              }
              let fligthFound = this.filterDataForTCheckingDuplicateBooking(this.originalresponseForFutureBooking, queryAsJSON.departureDate.split('T')[0], queryAsJSON.arrivalDate.split('T')[0], 'flight')
              if (fligthFound.bookingList.length > 0) {
                this.overlapBookings = [...this.overlapBookings, ...fligthFound.bookingList]
              }
            }

          }

          if (type === 'car') {
            let pickUpDate = new DatePipe('en-US').transform(new Date(event.pickUpDate), 'yyyy-MM-dd');
            let dropOffDate = new DatePipe('en-US').transform(new Date(event.dropOffDate), 'yyyy-MM-dd');
            let fligthFound = this.filterDataForTCheckingDuplicateBooking(this.originalresponseForFutureBooking, pickUpDate, dropOffDate, 'cars');
            if (fligthFound.bookingList.length > 0) {
              this.overlapBookings = [...this.overlapBookings, ...fligthFound.bookingList]
            }



          }
          if (type === 'hotel') {
            let queryAsJSON = JSON.parse(JSON.stringify(this.searchHotelForm.value));
            queryAsJSON.checkinDate = new DatePipe('en-US').transform(new Date(queryAsJSON.checkinDate), 'yyyy-MM-dd');
            queryAsJSON.checkoutDate = new DatePipe('en-US').transform(new Date(queryAsJSON.checkoutDate), 'yyyy-MM-dd');
            let fligthFound = this.filterDataForTCheckingDuplicateBooking(this.originalresponseForFutureBooking, queryAsJSON.checkinDate, queryAsJSON.checkoutDate, 'hotel');
            if (fligthFound.bookingList.length > 0) {
              this.overlapBookings = [...this.overlapBookings, ...fligthFound.bookingList]
            }



          }
          this.searchService.overlapBookingsList = [];
          if (this.overlapBookings.length > 0) {
            this.searchService.overlapBookingsList = this.overlapBookings;
            
            if (this.bsModalRefTripsModal) {
              this.bsModalRefTripsModal.hide();
            }
            this.bsModalRefTripsModal = this.modalService.show(modal, {
              initialState: {

              }, backdrop: true, keyboard: false, ignoreBackdropClick: true
            })
          }
          
        }
      }

    })
  }
  getConfirmationNo(option): string {
    let confirmNo = '';
    const item = option


    if (item.type === 'flight') {
      if (item.option.flight_option.cancellationRequestReceived) { return 'cancelled'; };
      for (let leg of item.option.flight_option.legs) {
        for (let hop of leg.hops) {
          if (hop.pnr) {
            if (!confirmNo.match(hop.pnr)) {
              confirmNo = confirmNo + hop.pnr + ',';
            };
          };
        };
      };

      var trim = confirmNo.replace(/(^,)|(,$)/g, "");
      return trim;
    } else if (item.type === 'hotel') {
      if (item.option.hotel_option.cancellationRequestReceived) { return 'cancelled'; };
      return item.option.hotel_option.bookingId;
    } else {
      if (item.option.car_option.cancellationRequestReceived) { return 'cancelled'; };
      return item.option.car_option.bookingId;

    }
  }
  airplaneData: any;
  airports: any;
  airlines: any;
  tripSelectedToshowOnpopUp: any;
  selectedLegIndexForPopUp: any;
  bsModalRefForUpcomingTrip: BsModalRef;
  openItinenary(bookingOption) {
    let url = '/bookingHistory?type=detail&bookingType=upcoming&ticketid=' + bookingOption.ticketid + '&tripid=' + bookingOption.tripid + '&transactionid=' + bookingOption.option.selectTransId;
    if (this.njoySpecificBuild || this.isMobile) {
      if (bookingOption.type == "flight") {
        this.airplaneData = bookingOption;
        this.tripSelectedToshowOnpopUp = bookingOption;
        this.tripSelectedToshowOnpopUp['type'] = bookingOption.type;
      } else if (bookingOption.type == "cars") {

        this.tripSelectedToshowOnpopUp = bookingOption.option.car_option;
        this.tripSelectedToshowOnpopUp['type'] = 'car';

      } else {
        this.tripSelectedToshowOnpopUp = bookingOption.option.hotel_option;
        this.tripSelectedToshowOnpopUp['type'] = 'hotel';
      }
      this.bsModalRefForUpcomingTrip = this.modalService.show(SeeDetailsComponent, {
        initialState: {
          airlines: this.airlines,
          airports: this.airports,
          airplaneData: this.airplaneData,
          tripSelectedToshowOnpopUp: this.tripSelectedToshowOnpopUp,
          IsMobile: this.isMobile,
          comingFromSearchPage: true

        },
      });

    } else {
      window.open(url, "_blank");
    }
  }
  submitForm(content?,modal?): void {
    if(this.searchInProgress){
      return;
    }
    if(this.showErrorIfAgeNotSelected()) return;
    // if (this.userAccountInfoService.isConnected) {
    if (this.searchService.employeeEmail.length > 0 && this.searchService.infantBookingAllowed && this.searchService.employeeEmail.length === this.searchService.ageGroupArray.length) {
      let adultCount=0;
      for(let item of this.searchService.ageGroupArray){
        if(item.id === 'ADT' && item.superAdult){
             adultCount=1;
        }
      } 
      if (adultCount === 0) {
        this.toastr.error(this.translateService.instant('setting.Pleaseselectatleast1adulttravelerwithagegreaterthan16'));
        return;
      }

    }
    this.bookingService.showKtn = false;
    if(this.searchService.selectedEventID){
      this.searchService.isEventOutOfPolicy =false;
    }
    if (this.searchService.selectedCreditAirline) {
      this.searchService.selectedCreditAirline = undefined;
    }
    if (this.getInfantAdyltCount()) {
      this.toastr.error("Only 1 infant is allowed per adult traveler");
      return;
    }
    if (this.isResult) {
      this.searchService.isEventDetailsCollapsed = this.searchService.eventDetailsToggleOverride;
      this.setIsCollapsed(this.searchService.eventDetailsToggleOverride);
      this.searchRequest.emit();
    }

    this.searchService.outgoingSelectedFlight = undefined;
    this.searchInProgress = true;
    if ((this.userAccountInfoService.isUserCorporateAdmin() || this.userAccountInfoService.isUserIsTravelManager()) && !this.bookingService.previousTransactionId) {
      this.searchService.bookingAndApprovalDone = true;
    }
    if (this.bookingService.previousTransactionId) {
      this.searchService.searchStart = true;
    } else {
      this.bookingService.previousTransaction = undefined;
    }
    if (!this.searchService.multiTripBooking && this.bookingService.previousTransactionId == undefined) {
      this.searchService.tripName = '';
    }
    if(this.viewMode == 'tab1') {this.isThisDuplicateTrip(this.futureTripDetsils,'flight');}
    this.searchService.comingFromSelectionPAge =false;
    this.searchService.trainFilter=[];
    this.searchHotelService.previousSearch = null;
    this.userAccountInfoService.initResponseReceivedFoorSearchPage = true;
    this.searchService.searchHeaderCliked = false;
    this.bookingService.bookingData = undefined;
    this.searchService.bookingDone = false;

    this.searchService.hotelbookingDone = false;
    this.userAccountInfoService.doNotSaveProfile = false;
    this.userAccountInfoService.paymentPageSave = false;
    this.searchService.seletedIndex = 0;
    this.searchService.selectedFareIndex=1;
    if(this.viewMode == 'tab5'){
      this.thankyoumodal = modal;
      // this.searchForm.controls['trainLine'].disable();

      if(this.searchForm.controls['trainLine'].value==='EUS' && this.searchService.euroStarSupported){
        this.searchService.trainFilter=[];
        this.titleService.setTitle("Train Search.");
        this.searchService.trainFilter.push('9F');
      }
      this.searchForm.get('trainLine').disable();
     // this.searchForm.get('trip').disable();

    }
    this.searchService.emptyIntervalID();
    this.searchService.isEventDetailsCollapsed = this.searchService.eventDetailsToggleOverride;
    this.goToSearchResults();

  }
  calculateAge(dateOfBirth: Date, currentDate: Date): number {
    const dob = new Date(dateOfBirth);
    const now = new Date(currentDate);

    let age = now.getFullYear() - dob.getFullYear();
    const monthDiff = now.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < dob.getDate())) {
      age--;
    } else if (monthDiff < 0 || (monthDiff === 0 && now.getDate() > dob.getDate())) {
      age++;
    }

    return age;
  }

  isAgeEighteenPlus() {
    let userid = this.userAccountInfoService.getUserEmail();
    let found = false;
    let count = 0
    for (let item1 of this.searchService.employeeEmail) {

      if (item1.email !== 'GUEST') {
        let employee: any = this.searchService.travellerList.filter(item => item.userId === item1.email)
        if (employee && employee.length > 0 && employee[0].dob) {
          employee = employee[0];
          let dob = new Date(employee.dob);
          let todayDate;
          if (this.searchHotelForm.controls['checkinDate'].value) {
            todayDate = this.searchHotelForm.controls['checkinDate'].value;
          } else {
            todayDate = new Date();
          }
          const oneDay = 24 * 60 * 60 * 1000;
          let twelveYearsAgo: Date = new Date(todayDate.getFullYear() - 18, todayDate.getMonth(), todayDate.getDate());
          let differenceInMs: number = todayDate.getTime() - twelveYearsAgo.getTime();
          let days: number = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
          let diff2 = Math.floor((todayDate.getTime() - dob.getTime()) / oneDay);
          if (diff2 <= days) {
            count = 1;
            break;
          }
        } else if (userid === this.searchService.employeeEmail[0].email && this.userAccountInfoService.getAccountInfo()) {
          let userInfoDTO = this.userAccountInfoService.getAccountInfo().userInfo;
          let dob;
          if (userInfoDTO && userInfoDTO.dob) {
            dob = new Date(userInfoDTO.dob);

            let todayDate;
            if (this.searchHotelForm.controls['checkinDate'].value) {
              todayDate = this.searchHotelForm.controls['checkinDate'].value;
            } else {
              todayDate = new Date();
            }
            const oneDay = 24 * 60 * 60 * 1000;
            let twelveYearsAgo: Date = new Date(todayDate.getFullYear() - 18, todayDate.getMonth(), todayDate.getDate());
            let differenceInMs: number = todayDate.getTime() - twelveYearsAgo.getTime();
            let days: number = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
            let diff2 = Math.floor((todayDate.getTime() - dob.getTime()) / oneDay);
            if (diff2 <= days) {
              count = 1;
              break;
            }

          }

        }

      }
    }
    if (count == 1) {
      found = true;
    }
    return found;
  }
  submitHotelForm(): void {
    //  if (this.userAccountInfoService.isConnected) {
    if(this.showErrorIfAgeNotSelected()){return}
    var todayDate = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    var checkInDate = this.searchHotelForm.controls['checkinDate'].value;
    var diff2 = Math.round(Math.abs((todayDate.getTime() - checkInDate) / oneDay));
    this.userAccountInfoService.doNotSaveProfile = false;
    if ((this.userAccountInfoService.isUserCorporateAdmin() || this.userAccountInfoService.isUserIsTravelManager()) && !this.bookingService.previousTransactionId) {
      this.searchService.bookingAndApprovalDone = true;
    }
    if (this.isAgeEighteenPlus()) {
      this.toastr.error("Hotel bookings are allowed only for travelers with age of 18+ years");
      return
    }
    this.userAccountInfoService.paymentPageSave = false;
    this.searchService.comingFromSelectionPAge = false;
    this.searchService.searchHeaderCliked = false;
    this.isThisDuplicateTrip(this.futureTripDetsils, 'hotel');
    this.bookingService.bookingData = undefined;
    this.searchService.bookingDone = false;
    this.searchService.hotelbookingDone = false;
    if (!this.searchService.multiTripBooking && this.bookingService.previousTransactionId == undefined) {
      this.searchService.tripName = '';
    } else {
      let seatArray = JSON.parse(this.gallopLocalStorage.getItem("selectedSeat"));
      if (seatArray && seatArray.length > 0) {
        //  seatArray.pop();
        this.gallopLocalStorage.removeItem("selectedSeat");
      }
    }
    if (this.isResult) {
      this.setIsCollapsed(true);
      this.searchRequest.emit();
      this.showCurrentLocation = false;
    }
    this.searchInProgress = true;
    let value1 = this.searchHotelForm.controls['hotelAddress'].value;
    if (value1 !== 'Your current location') {
      this.searchHotelForm.controls['currentLocation'].setValue("");
    }
    // window.alert(JSON.stringify(this.searchHotelForm.value));
      this.searchService.emptyIntervalID();
      this.searchService.currentSearchToken=null;
      this.filterService.originalHotelSearchResponse=undefined
      this.searchHotelService.broadCastHotelResponse(undefined);
      this.searchService.isEventDetailsCollapsed = this.searchService.eventDetailsToggleOverride;
    this.goToHotelSearchResults();


  }
  selectCurrentLocation(modal) {
    if (!this.locationDisabled && 'geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
        this.selectedCurrentLocation = true;
        this.currentHotelLocation = 'Current Location';
          this.searchHotelForm.controls['currentLocation'].patchValue(
            `${resp.coords.latitude},${resp.coords.longitude}`
          );
        this.searchHotelForm.controls['hotelAddress'].patchValue('Your current location');
      },
        (err) => {
          this.selectedCurrentLocation = false;
          this.locationDisabled = true;
          // Optional: Show user-friendly message
          console.warn('Location access denied or unavailable', err);
        },
        {
          timeout: 10000, // set timeout to avoid hanging
          enableHighAccuracy: true,
        }
      );
    } else {
      console.warn('Geolocation not supported or disabled');
      // fallback or user message
    }
  }
  
  onModelCancel() {
    this.bsModalRef.hide();
    document.body.classList.remove('event-modal-open');
  }

  cancelEvent(eventid, msg) {
    this.declineEventId = eventid;
    this.userAccountInfoService.respondEvent(eventid, msg).subscribe(resp => {
      this.declineEventId = null;
      if (resp && resp.success) {
        this.userAccountInfoService.eventList = this.userAccountInfoService.eventList.filter(item => item.event.id !== eventid);
        this.searchService.selectedEventForBooking = null;
        this.searchService.selectedEventID = null;

        if (this.userAccountInfoService.eventList.length === 0) {
          this.bsModalRef.hide();
          document.body.classList.remove('event-modal-open');
          this.router.navigate(['/' + this.userAccountInfoService.getDefaultRoutePath()], {
            queryParams: { eventid: 'exitEvent' },
            replaceUrl: true
          });
        }
      }
    });
  }

  openEventModalFromNav() {
    // Clear the query param to prevent reopening on refresh
    this.searchService.openEventModalFromHeader = false;
    this.router.navigate(['/search'], { replaceUrl: true });

    // Open the event modal if event list exists
    if (this.userAccountInfoService.eventList && this.userAccountInfoService.eventList.length > 0) {
      setTimeout(() => {
        if (this.bsModalRef) {
          this.bsModalRef.hide();
        }
        this.bsModalRef = this.modalService.show(this.eventTripDetsils, { class: 'modal-dialog-centered event-modal-dialog' });
        document.body.classList.add('event-modal-open');
        this.bsModalRef.onHidden.subscribe(() => {
          document.body.classList.remove('event-modal-open');
        });
      }, 100);
    }
  }

  searchOption='flight';
cancelSearch(){
  this.bsModalRefTripsModal.hide();
if(this.searchOption==='flight'){
  this.titleService.setTitle(this.translateService.instant('search.FlightSearch'));
  // this.searchForm.controls['trip'].setValue('ONEWAY');
  // this.setInitTripType(this.initResponse,false)
  this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()]);
}else if(this.searchOption==='hotel'){
  this.titleService.setTitle(this.translateService.instant('search.HotelSearch'));
  this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
      {
        queryParams:
        {
          type: 'hotel',
        },
        replaceUrl: true
      }
    );
}else{
  this.titleService.setTitle(this.translateService.instant('search.CarSearch'));
  this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
    {
      queryParams:
      {
        type: 'car',
      },
      replaceUrl: true
    }
  );
}
}
  hotelTabClicked(modal?) {
    // if (this.userAccountInfoService.isConnected) 
    this.closeAirportComponent();
    this.searchService.currentTimeZone = null;
    if (this.bookingService.previousBooking && this.bookingService.previousBooking.type !== 'hotel' || this.searchService.multiTripBooking) {
      return;
    }

   
    this.searchOption='hotel';
    this.searchService.isSearchPage = true;
    this.searchHotelForm.controls['roomCount'].setValue("" + this.searchService.employeeEmail.length);
    // this.titleService.setTitle('Hotel Search');
    this.titleService.setTitle(this.translateService.instant('search.HotelSearch'));
    this.userAccountInfoService.initResponseReceivedFoorSearchPage = false;
    this.viewMode = 'tab2';
    this.resetTraveler();
    //  if (this.searchService.infantBookingAllowed) {
    //   this.searchService.ageGroupArray = [];
    // }
    
    if (this.viewMode === 'tab2') {
      // this.searchHotelForm.controls['personCount'].setValue("" + this.searchService.employeeEmail.length);
      this.searchHotelForm.controls['roomCount'].setValue("" + this.searchService.employeeEmail.length);
    }
    this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
      {
        queryParams:
        {
          type: 'hotel',
        },
        replaceUrl: true
      }
    );

  }
  showAllBookings = false;
  isUserCompanyManager() {
    return this.userAccountInfoService.isUserCorporateAdmin();
  }
  isUserCompanyTravelManager() {
    return this.userAccountInfoService.isUserIsTravelManager();
  }
  BookingsTabClicked() {
    //  if (this.userAccountInfoService.isConnected) {
    if (this.bookingService.previousBooking || this.searchService.multiTripBooking) {
      return;
    }
    this.viewMode = 'tab4';
    this.showAllBookings = true;
    this.searchService.comingBackFromDetailsPAge = false;
    this.searchService.showAllBookings = true;
    this.userAccountInfoService.initResponseReceivedFoorSearchPage = false;
    // this.titleService.setTitle('Car Search');
    this.titleService.setTitle(this.translateService.instant('search.ALLBookings'));
    this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
      {
        queryParams:
        {
          type: 'allbookings',
        },
        replaceUrl: true
      }
    );

  }
  carTabClicked() {
    // if (this.userAccountInfoService.isConnected) {
    this.closeAirportComponent();
    this.searchService.currentTimeZone = null;
    if (this.bookingService.previousBooking && this.bookingService.previousBooking.type !== 'cars' || this.searchService.multiTripBooking) {
      return;
    }
    this.viewMode = 'tab3';
     this.resetTraveler();
    // if (this.searchService.infantBookingAllowed) {
    //   this.searchService.ageGroupArray = [];
    // }
   
    this.searchOption='car';
    this.searchService.isSearchPage = true;
    if (this.searchService.employeeEmail.length > 1) {
      this.searchService.employeeEmail.splice(1);
    }
    if (this.searchService.ageGroupArray.length > 1) {
      this.searchService.ageGroupArray.splice(1);
    }
    this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
    this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
    
    this.userAccountInfoService.initResponseReceivedFoorSearchPage = false;
    // this.titleService.setTitle('Car Search');
    this.titleService.setTitle(this.translateService.instant('search.CarSearch'));
    
    this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
      {
        queryParams:
        {
          type: 'car',
        },
        replaceUrl: true
      }
    );

  }
  flightTabClicked() {
    // if (this.userAccountInfoService.isConnected) {
      if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.eventid && !this.route.snapshot.queryParams['query'] && !this.searchService.comingBackFromFlights){
            return;
      }
      let tripType = this.searchForm.controls['trip'].value;
      this.closeAirportComponent();
      this.searchForm.reset();
      this.createForm();
      if (tripType === 'MULTICITY') {

        this.addFlight();
        this.searchService.isSearchPage = false;
        this.setMinimumDate((0));
        this.multicity = true;
      }else{
        this.multicity = false;
      }
      if (tripType === 'ROUNDTRIP') {
        this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
        this.searchForm.controls['arrivalDate'].updateValueAndValidity();
      } else {
        this.searchForm.controls['arrivalDate'].clearValidators();
        this.searchForm.controls['arrivalDate'].updateValueAndValidity();
      }
      this.searchForm.controls['trip'].setValue(tripType); 
   // this.multicity = false;
    this.searchService.trainFilter=[];
    this.searchOption='flight';
    this.searchInProgress = false;
    this.searchService.currentTimeZone=null;
    if(this.bookingService.previousBooking && this.bookingService.previousBooking.type !=='flight' || this.searchService.multiTripBooking){
      return;
    }
    this.viewMode = 'tab1';
    this.resetTraveler();
    
    if (this.searchService.employeeEmail.length > environment.maxTravellersForFlight) {
      this.searchService.employeeEmail.splice(environment.maxTravellersForFlight);
    }
    this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
    this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
    //this.titleService.setTitle('Flight Search');
    this.titleService.setTitle(this.translateService.instant('search.FlightSearch'));
    // this.searchForm.controls['trip'].setValue('ONEWAY');
    // this.setInitTripType(this.initResponse,false)
    this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()]);
    this.cdRef.detectChanges();

  }
  addPassenger(item, index) {
    if (index == 0) {
      item.number = item.number + 1;
      this.adults = this.adults + 2;
      this.leisureValue = this.leisureValue + 1;
    } else if (index == 1) {
      item.number = item.number + 1;
      this.leisureValue = this.leisureValue + 1;
    } else if (index == 2) {
      item.number = item.number + 1;
      this.leisureValue = this.leisureValue + 1;
      this.infants = this.infants + 1;


    }
  }
  subPassenger(item, index) {
    if (index == 0) {
      item.number = item.number - 1;
      this.adults = this.adults - 2;
      this.leisureValue = this.leisureValue - 1;
    } else if (index == 1) {
      item.number = item.number - 1;
      this.leisureValue = this.leisureValue - 1;
    } else if (index == 2) {
      item.number = item.number - 1;
      this.leisureValue = this.leisureValue - 1;
      this.infants = this.infants - 1;

    }
  }
  //subPassenger(item){
  //if(item.number > 0){
  // item.number=item.number - 1;
  //}
  //}

  setTotalPassengersDetails(modalName) {
    let totalPassangers = 0;
    for (let typeItem of this.passengerTypeSpecific) {
      this.searchForm.controls[typeItem.id].setValue(typeItem.number);
      totalPassangers = totalPassangers + typeItem.number;
    }
    if (totalPassangers <= 9 && this.infants <= this.adults) {
      this.searchForm.controls['passengers'].setValue('0' + totalPassangers);
      this.onSmartModelCancel(modalName);

    }

  }
  searchInProgress: boolean = false;
  setFormGroupDateAsPerConstraint() {
    // this.searchForm.controls['constraintTime'].setValue(null);
    if (this.searchForm.controls['constraint'].value === IntervalType.DEPARTURE_BASED) {
      this.searchForm.controls['departureDate'].setValue(DateUtils.getFormattedDateWithoutTimeZone(new Date(this.departDate)));

      if (!this.isResult) {
        this.searchForm.controls['arrivalDate'].setValue(null);
      }
    } else {
      this.searchForm.controls['arrivalDate'].setValue(DateUtils.getFormattedDateWithoutTimeZone(new Date(this.arriveDate)));

      if (!this.isResult) {
        this.searchForm.controls['departureDate'].setValue(null);
      }
    }
  }

  backToSearch() {
    //  this.titleService.setTitle('Flight Search');
    this.titleService.setTitle(this.translateService.instant('search.FlightSearch'));
    if(this.searchService.trainFilter.length > 0){
      this.titleService.setTitle(this.translate.instant('search.TrainSearch'));
    }
    this.searchService.searchHeaderCliked = true;
    this.searchService.comingBackFromFlights=true;
    if(this.searchService.trainFilter.length > 0){
      this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
      {
        queryParams:
        {
          type: 'train',
        },
        replaceUrl: true
      }
  );
    }else if(!this.searchService.selectedEventID){
    this.router.navigate(['/'+this.userAccountInfoService.getDefaultRoutePath()]);
    }else{
      this.router.navigate(['/'+this.userAccountInfoService.getDefaultRoutePath()], {
        queryParams: {eventid:this.searchService.selectedEventID},
        replaceUrl: true
      }); 
    }
  }
  setFormArrayDateAsPerConstraint() {

    let form: AbstractControl;

    for (let i = 0; i < this.formArrayLength; i++) {

      form = this.getFormArrayFLightObject(i);
      // form['constraintTime'] = null;

      if (form['controls'].constraint.value === IntervalType.DEPARTURE_BASED) {
        form['departureDate'] = DateUtils.getFormattedDateWithoutTimeZone(new Date(form['controls'].departureDate.value));

        if (!this.isResult) {
          form['arrivalDate'] = null;
        }
      } else {
        form['arrivalDate'] = DateUtils.getFormattedDateWithoutTimeZone(new Date(form['controls'].arrivalDate.value));

        if (!this.isResult) {
          form['departureDate'] = null;
        }
      }
      this.getFormArrayFLightObject(i).patchValue(form)
    }

  }

  minAgeValidator(control: AbstractControl): ValidationErrors | null {
    let result = null;
    if (control.value) {
      let yearsDiff = DateUtils.getYearsDiffFromNow(control.value);
      if (yearsDiff < Constants.MIN_DOB_AGE) {
        result = { 'lessThanMinAge': true };
      }
    }
    return result;
  }

  getCityNameFromGoogleAddress(address: any) {
    let componentForm = {
      locality: 'long_name',
      sublocality: 'long_name',
      administrative_area_level_2: 'short_name',
      administrative_area_level_4: 'long_name',
      administrative_area_level_3: 'short_name',
      neighborhood: 'short_name',
      country: 'short_name',
      postal_code: 'short_name',
    };

    let addressComponentsValues = {};
    // Get each component of the address from the place details
    // and   the corresponding field on the form.
    for (var i = 0; i < address.address_components.length; i++) {
      for (var typeCounter = 0; typeCounter < address.address_components[i].types.length;
        typeCounter++) {
        var addressType = address.address_components[i].types[typeCounter];
        if (componentForm[addressType]) {
          var val = address.address_components[i][componentForm[addressType]];
          addressComponentsValues[addressType] = val;
        }
      }
    }


    let cityName = '';
    if (addressComponentsValues['locality']) {
      cityName = addressComponentsValues['locality'];
    } else if (addressComponentsValues['sublocality']) {
      cityName = addressComponentsValues['sublocality'];
    } else if (addressComponentsValues['administrative_area_level_2']) {
      cityName = addressComponentsValues['administrative_area_level_2'];
    } else if (addressComponentsValues['administrative_area_level_4']) {
      cityName = addressComponentsValues['administrative_area_level_4'];
    } else if (addressComponentsValues['administrative_area_level_3']) {
      cityName = addressComponentsValues['administrative_area_level_3'];
    } else if (addressComponentsValues['neighborhood']) {
      cityName = addressComponentsValues['neighborhood'];
    }
    return cityName;
  }

  addCityFormControlValue(form: any, address: any, formcontrolname: string) {
    form[formcontrolname + 'City'] = this.getCityNameFromGoogleAddress(address);

  }
  handleAddressChange(address: any, formcontrolname: string) {
    let form = { ...this.searchForm };
    form[formcontrolname] = address.formatted_address;
    this.addCityFormControlValue(form, address, formcontrolname);
    this.searchForm.patchValue({ ...form });
  }

  handleAddressChangeMulticity(address: any, formcontrolname: string) {
    let form = { ...this.searchForm.controls['flights']['controls'][0] };
    form[formcontrolname] = address.formatted_address;
    form[formcontrolname + 'City'] = this.getCityNameFromGoogleAddress(address);
    this.searchForm.controls['flights']['controls'][0].patchValue({ ...form });
  }
  getInput(event) {
    if (event) {

    }

  }
  handleHotelAddressChange(address: any, fieldInput) {
    let form = { ...this.searchHotelForm };
    form['hotelAddress'] = fieldInput;
    
    
    this.addCityFormControlValue(form, address, 'hotelAddress');
    this.searchHotelForm.patchValue({ ...form });
  }

  handleFormArrayAddressChange(address: any, formControlName: string, formArrayIndex: number) {
    let form = this.getFormArrayFLightObject(formArrayIndex);
    form[formControlName] = address.formatted_address;
    this.addCityFormControlValue(form, address, formControlName);
    (<UntypedFormArray>this.searchForm.controls['flights']).at(formArrayIndex).patchValue(form);
  }

  goToSearchResults(): void {
    let userid = this.userAccountInfoService.getUserEmail();
    let sToken = this.userAccountInfoService.getSToken();
    this.gallopLocalStorage.removeItem("emergencyContactDetails");
    this.searchService.previousDate = true;
    
    // Fetch delegated cards if eligible
    CommonUtils.fetchDelegatedCardsIfEligible(this.searchService, this.userAccountInfoService);
    let queryAsJSON = JSON.parse(JSON.stringify(this.searchForm.value));
    // 
    queryAsJSON.departureDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.departureDate)) + "T00:00:00.000Z";
    if(queryAsJSON.arrivalDate){
    queryAsJSON.arrivalDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.arrivalDate)) + "T00:00:00.000Z";
    }
    if (this.isInputSearchTypeAirport()) {
      queryAsJSON.originType = AddressType.GIVEN_AIRPORT_ONLY;
      queryAsJSON.destinationType = AddressType.GIVEN_AIRPORT_ONLY;
    }
    let selectedTravler = [];
    if (this.searchService.employeeEmail.length > 0) {
      for (let item of this.searchService.employeeEmail) {
        selectedTravler.push(item.email);
      }
    }
    //   queryAsJSON.combo = !this.searchService.nonCombo;
    if (this.searchService.infantBookingAllowed) {
      let selectedAgeGroup = [];
      let adults = 0;
      let infants = 0
      let children = 0;
      if (this.searchService.ageGroupArray.length > 0) {
        for (let item of this.searchService.ageGroupArray) {
          if (item.id === 'ADT') {
            adults++;
          } else if (item.id === 'CHD') {
            children++;
          } else if (item.id === 'INF') {
            infants++;
          }
          selectedAgeGroup.push(item);
        }
        this.searchService.adultCount = adults + children;
        queryAsJSON.adults = adults;
        queryAsJSON.children = children;
        queryAsJSON.infants = infants;

      } else {
        this.searchService.adultCount = selectedTravler.length;
      }
      queryAsJSON.travellerAgeGroup = selectedAgeGroup;
    } else {
      this.searchService.adultCount = selectedTravler.length;
      queryAsJSON.adults = selectedTravler.length;
    }
    queryAsJSON.travellerEmails = selectedTravler;
    if (this.searchService.selectedEventID) {
      queryAsJSON.eventid = this.searchService.selectedEventID;
    }
    

    if ('flights' in queryAsJSON && queryAsJSON['flights'].length > 0) {
      for (let i = 0; i < queryAsJSON['flights'].length; i++) {
        let leg2FlightReq = queryAsJSON['flights'][i];
        leg2FlightReq.departureDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(leg2FlightReq.departureDate)) + "T00:00:00.000Z";
        leg2FlightReq.arrivalDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(leg2FlightReq.departureDate)) + "T00:00:00.000Z";
        if (this.isInputSearchTypeAirport()) {
          leg2FlightReq.originType = AddressType.GIVEN_AIRPORT_ONLY;
          leg2FlightReq.destinationType = AddressType.GIVEN_AIRPORT_ONLY;
        }
      }
    }
    this.searchService.noAvailability = [];
    if(this.viewMode == 'tab1' || (this.searchService.trainFilter.length > 0 && this.viewMode == 'tab5')){
    this.searchService.comingBackFromFlights = false;
    this.router.navigate(["flights"],
      {
        queryParams:
        {
          query: encodeURIComponent(JSON.stringify(queryAsJSON)),
          step: 0,
          index: this.searchService.seletedIndex
        },
        replaceUrl: this.isResult
      }
    );
    }else {
      let trainSearchDataToSend = this.searchService.getSearchRequest(queryAsJSON);
      if(this.searchForm.controls['trainLine'].value==='UKT'){
       let  selectedRailcardValue =[];
        if(this.railCardsSelected.length > 0 ){
          for(let item of this.railCardsSelected){
            let railValue = this.railCardsOptions.filter(item1 => item1.id ===item);
            if(railValue  && railValue.length > 0 && railValue[0].id){
              selectedRailcardValue.push(railValue[0].value)
            }
          }
        
        }
        if(this.searchForm.controls['seat'].value!==""){
        trainSearchDataToSend['seat']   = this.searchForm.controls['seat'].value;
        }else{
          trainSearchDataToSend['seat']   = 'no preference'
        }
        trainSearchDataToSend['ticket']   = this.searchForm.controls['ticket'].value;
        trainSearchDataToSend['railCards']   = selectedRailcardValue;
        trainSearchDataToSend['class']   = this.searchForm.controls['class'].value;
      }
    
      trainSearchDataToSend['trainLine']  = this.translateService.instant( this.getValueOfId((this.searchForm.controls['trainLine'].value),this.trainLineList));
      this.sendSearchDataForTrain(trainSearchDataToSend);
    }
  }

  goToHotelSearchResults(): void {
    let userid = this.userAccountInfoService.getUserEmail();
    let sToken = this.userAccountInfoService.getSToken();
    this.gallopLocalStorage.removeItem("emergencyContactDetails");
    
    // Fetch delegated cards if eligible
    CommonUtils.fetchDelegatedCardsIfEligible(this.searchService, this.userAccountInfoService);
    let queryAsJSON = JSON.parse(JSON.stringify(this.searchHotelForm.value));
    queryAsJSON.checkinDate = new DatePipe('en-US').transform(new Date(queryAsJSON.checkinDate), 'yyyy-MM-dd');
    queryAsJSON.checkoutDate = new DatePipe('en-US').transform(new Date(queryAsJSON.checkoutDate), 'yyyy-MM-dd');
    let selectedTravler = [];
    if (this.searchService.employeeEmail.length > 0) {
      for (let item of this.searchService.employeeEmail) {
        selectedTravler.push(item.email);
      }
    }
    //   queryAsJSON.combo = !this.searchService.nonCombo;
    queryAsJSON.travellerEmail = selectedTravler;
    this.router.navigate(["hotels"],
      {
        queryParams:
        {
          query: encodeURIComponent(JSON.stringify(queryAsJSON)),
          step: 0
        },
        replaceUrl: this.isResult
      }
    );
  }
  zIndex(i) {
    var index = 'zIndex' + i;
    return index;
  }
  setDepartureConstraint(item) {
    let params = "?ua_action=TimeTypeMenuItem&ua_Flight=1&ua_item=" + item.value;
    this.searchService.letsTrack(params);
    this.searchForm.controls['constraint'].setValue(item.id);
  }

  setMultiLeg2DepartureConstraint(item, i) {
    let params = "?ua_action=TimeTypeMenuItem&ua_Flight=" + (i + 2) + "&ua_item=" + item.value;
    this.searchService.letsTrack(params);
    (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['constraint'].setValue(item.id);
  }
  setArrivalConstraint(item) {
    let params = "?ua_action=TimeTypeMenuItem&ua_Flight=2&ua_item=" + item.value;
    this.searchService.letsTrack(params);
    this.searchForm.controls['constraint1'].setValue(item.id);
  }
  setConstraintTimeArrival(id) {
    // 
    let params = "?ua_action=SelectTimeIntervalItem&ua_Flight=2&ua_item=" + id;
    this.searchService.letsTrack(params);
  }
  setConstraintTimeDeparture(id) {
    let params = "?ua_action=SelectTimeIntervalItem&ua_Flight=1&ua_item=" + id;
    this.searchService.letsTrack(params);
    // Update form control
    this.searchForm.controls['constraintTime'].setValue(id);
  }
  getParams(i) {
    return 'Flight=' + (i + 2);
  }
  setMultiLeg2Constraint(id, i) {
    let params = "?ua_action=SelectTimeIntervalItem&ua_Flight=" + (i + 2) + "&ua_item=" + id;
    this.searchService.letsTrack(params);
    //(<FormGroup>this.getFormArrayFLightObject(i)).controls['constraint'].setValue(value);
  }
  setConstraintTimeDepart(id) {
    // 
    let params = "?ua_action=SelectTimeIntervalItem&ua_Flight=1&ua_item=" + id;
    this.searchService.letsTrack(params);
  }
  setTripType(value: string) {
    this.switchTripType = value === AlgoTypes.LEISURE.toString() ? AlgoTypes.LEISURE : AlgoTypes.PODUCTIVITY;
    this.searchForm.controls['classTypeSwitch'].setValue(value);

  }
  getFlightCount(i) {
    return (i + 2);
  }
  setFormConstraint(value: string, formArrayIndex?: number) {
    // if (formArrayIndex >= 0) {
    //   let form = this.getFormArrayFLightObject(formArrayIndex);
    //   form['constraint'] = value;

    //   (<FormArray>this.searchForm.controls['flights']).at(formArrayIndex).patchValue(form);
    // } else {
    //   this.searchForm.controls['constraint'].setValue(value);
    //   if (value == IntervalType.ARRIVAL_BASED) {
    //     this.onDateChange(this.arriveDate);
    //   }

    //   if (value == IntervalType.DEPARTURE_BASED) {
    //     this.onDateChange(this.departDate);
    //   }
    // }
  }

  getTimeOptions(timeConstraintType: string) {
    let time: number;
    let today = DateUtils.getCurrentDateAsUTCDate();
    let constraintDate;
    if (timeConstraintType == IntervalType.DEPARTURE_BASED) {
      this.timeOptions = Constants.CONSTRAINT_TIME_OPTIONS_FOR_DEPART;
    } else {
      this.timeOptions = Constants.CONSTRAINT_TIME_OPTIONS_FOR_ARRIVE;
    }
  }

  getTimeOptionValue(option) {

    if (option.title == this.translate.instant('search.ANYTIME')) {
      return "";
    }

    let startAMPM = (option.hours.start < 12 || option.hours.start == 24) ? this.translateService.instant('search.AM') : this.translateService.instant('search.PM');
    let endAMPM = (option.hours.end < 12 || option.hours.end == 24) ? this.translateService.instant('search.AM') : this.translateService.instant('search.PM');

    let start = option.hours.start > 12 ? option.hours.start - 12 : option.hours.start;
    let end = option.hours.end > 12 ? option.hours.end - 12 : option.hours.end;
    start = (start == 0) ? 0 : start;

    return `${start} ${startAMPM} to ${end} ${endAMPM}`;
  }

  getPlaces(query) {
    this.googlePlacesService.search(query).subscribe(data => {
    })
  }

  tripTypeChanged(type?: any) {
    this.totalLeg = this.getAdditionalReqeustControl().length ? this.getAdditionalReqeustControl().length : 1;
    // this.selectedTimeOption = this.translate.instant('search.ANYTIME');
    // Preserve the user's time selection when switching between trip types (removed reset to ANYTIME)
    let params = "?ua_action=TripTypeItem&ua_triptype=" + type.id.toLowerCase();
    this.searchService.letsTrack(params);

    // Update the form control value
    this.searchForm.controls['trip'].setValue(type.id);

    // Force change detection to update the view
    this.cdRef.detectChanges();

    if (type.id === 'ROUNDTRIP') {
      this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
      this.searchForm.controls['arrivalDate'].updateValueAndValidity();
      if (this.searchForm.controls['arrivalDate'].value) {
        this.searchForm.controls['arrivalDate'].setValue(null);
      }
    } else {
      if (this.searchForm.controls['arrivalDate'].value) {
        this.searchForm.controls['arrivalDate'].setValue(null);
      }
      this.searchForm.controls['arrivalDate'].clearValidators();
      this.searchForm.controls['arrivalDate'].updateValueAndValidity();
    }
    if (type.id == 'MULTICITY') {
      // setTimeout(() => {
      this.addFlight();
      this.searchService.isSearchPage = false;
      this.setMinimumDate((0));
      this.multicity = true;

      // Initialize multicity calendar state for first flight
      this.showCustomCalendarMulticity = [];
      this.selectedTimeOptionMulticity = [];
      this.showCustomTimingMulticity = [];
      this.selectedCustomTimeMulticity = [];
      this.minDateMulticity = [];
      this.selectedTimeOptionMulticity[0] = this.translate.instant('search.ANYTIME');
      this.showCustomTimingMulticity[0] = false;
      this.showCustomCalendarMulticity[0] = false;
      this.minDateMulticity[0] = new Date();
      // }, 10);

    } else {
      var tempArray = [...this.invalidForm];
      this.invalidForm = [{ value: false, index: 0 }];
      this.multicity = false;
      this.searchService.isSearchPage = true;

      // Clear multicity calendar state when switching away from multicity
      this.showCustomCalendarMulticity = [];
      this.selectedTimeOptionMulticity = [];
      this.showCustomTimingMulticity = [];
      this.selectedCustomTimeMulticity = [];
      this.minDateMulticity = [];

      while (this.getAdditionalReqeustControl().length !== 0) {
        this.removeFlight(0, tempArray);
      }
     
    }
  }
isRadioSelected(formvalue, tripTypeId){
  return formvalue === tripTypeId;
}
  addFlight(flight?: FlightQueryParam) {

    let prefilledReturnDate = new Date();
    // prefilledReturnDate.setDate( this.searchForm.controls['departureDate'].value.getDate() + 7);
    prefilledReturnDate.setDate(prefilledReturnDate.getDate() + 22);
    this.setIsCollapsed(false);

    let formArrayLength: number = this.formArrayLength;
    let destValue = ''
    let sourceValue = ''
    if (formArrayLength > 0) {
      if (this.searchService.sourceLocationForMultilatLng[formArrayLength - 1]) {
        let locationObj = { source: this.searchService.sourceLocationForMultilatLng[formArrayLength - 1].source, location: this.searchService.sourceLocationForMultilatLng[formArrayLength - 1].location,timeZoneId:this.searchService.sourceLocationForMultilatLng[formArrayLength - 1].timeZoneId  };
        this.searchService.destLocationForMultilatLng.push(locationObj);
      }
      if (this.searchService.destLocationForMultilatLng[formArrayLength - 1]) {
        let locationObj1 = { source: this.searchService.destLocationForMultilatLng[formArrayLength - 1].source, location: this.searchService.destLocationForMultilatLng[formArrayLength - 1].location,timeZoneId:this.searchService.destLocationForMultilatLng[formArrayLength - 1].timeZoneId  };
        this.searchService.sourceLocationForMultilatLng.push(locationObj1);
      }

      destValue = (this.getFormArrayFLightObject(formArrayLength - 1).get('destinationAirportCode').value)
      if (destValue && destValue.length !== 3) {
        destValue = '';
      }
      sourceValue = (this.getFormArrayFLightObject(formArrayLength - 1).get('sourceAirportCode').value)
      if (sourceValue && sourceValue.length !== 3) {
        sourceValue = '';
      }
    } else {
      destValue = this.searchForm.controls['destinationAirportCode'].value;
      if (this.searchService.sourceLocationForlatLng) {
        let locationObj = { source: this.searchService.sourceLocationForlatLng.source, location: this.searchService.sourceLocationForlatLng.location ,timeZoneId:this.searchService.sourceLocationForlatLng.timeZoneId};
        this.searchService.destLocationForMultilatLng.push(locationObj);
      }
      if (this.searchService.destLocationForlatLng) {
        let locationObj1 = { source: this.searchService.destLocationForlatLng.source, location: this.searchService.destLocationForlatLng.location ,timeZoneId:this.searchService.destLocationForlatLng.timeZoneId};
        this.searchService.sourceLocationForMultilatLng.push(locationObj1);
      }
      if (destValue && destValue.length !== 3) {
        destValue = '';
      }
      sourceValue = this.searchForm.controls['sourceAirportCode'].value;
      if (sourceValue && sourceValue.length !== 3) {
        sourceValue = '';
      }
    }

    let formArraySource = (formArrayLength == 0) ? destValue :
      (formArrayLength > 0 ? destValue : '');

    let formArraySourceCity = (formArrayLength == 0) ? sourceValue :
      (formArrayLength > 0 ? this.searchForm.controls['sourceAirportCode'].value : null);
    if (formArraySource === formArraySourceCity) {
      formArraySourceCity = (formArrayLength > 0 ? sourceValue : '')
    }
    if (formArrayLength > 1) {
      formArraySourceCity = null;
    }
    let formArrayDestination = (formArrayLength == 0 ? this.searchForm.controls['source'].value : null);
    let formArrayDestinationCity = (formArrayLength == 0 ? this.searchForm.controls['sourceCity'].value : null);
    // Get previous flight's departure date for the new flight
    let previousDepartureDate = null;
    if (formArrayLength > 0) {
      previousDepartureDate = (<UntypedFormGroup>this.getFormArrayFLightObject(formArrayLength - 1)).controls['departureDate'].value;
    } else {
      previousDepartureDate = this.searchForm.controls['departureDate'].value;
    }

    let newFlightSearchForm = this.fb.group({
      source: [(flight && flight.source) ? flight.source : formArraySource, Validators.compose([Validators.required, this.spaceValidator])],
      // sourceCity: [(flight && flight['sourceCity']) ? flight['sourceCity'] : formArraySourceCity, Validators.compose([Validators.required, this.spaceValidator])],
      sourceCity: [null],
      sourceAirportCode: [(flight && flight['sourceAirportCode']) ? flight['sourceAirportCode'] : formArraySource, this.isInputSearchTypeAirport() ? Validators.compose([Validators.required, this.spaceValidator]) : null],
      destination: [(flight && flight.destination) ? flight.destination : formArraySourceCity, Validators.compose([Validators.required, this.spaceValidator])],
      // destinationCity: [(flight && flight['destinationCity']) ? flight['destinationCity'] : formArrayDestinationCity, Validators.compose([Validators.required, this.spaceValidator])],
      destinationCity: [null],
      destinationAirportCode: [(flight && flight['destinationAirportCode']) ? flight['destinationAirportCode'] : formArraySourceCity, this.isInputSearchTypeAirport() ? Validators.compose([Validators.required, this.spaceValidator]) : null],
      constraint: [(flight && flight.constraint) ? flight.constraint : IntervalType.DEPARTURE_BASED],
      departureDate: [(flight && flight.departureDate) ? new Date(flight.departureDate) : previousDepartureDate, Validators.compose([Validators.required])],
      arrivalDate: [(flight && flight.arrivalDate) ? new Date(flight.arrivalDate) : null],
      constraintTime: [(flight && flight.constraintTime) ? flight.constraintTime : this.translate.instant('search.ANYTIME')]
    });
    if(this.viewMode==='tab5' &&  this.searchForm.controls['trainLine'].value==='2R'){
    newFlightSearchForm.controls['source'].setValidators([Validators.required, this.spaceValidator, this.minLengthArray(4), this.maxLengthArray(4)]);
    newFlightSearchForm.controls['destination'].setValidators([Validators.required, this.spaceValidator, this.minLengthArray(4), this.maxLengthArray(4)]);
    }else{
      newFlightSearchForm.controls['source'].setValidators([Validators.required, this.spaceValidator, this.minLengthArray(3), this.maxLengthArray(3)]);
      newFlightSearchForm.controls['destination'].setValidators([Validators.required, this.spaceValidator, this.minLengthArray(3), this.maxLengthArray(3)]);
    }
    (<UntypedFormArray>this.searchForm.controls['flights']).push(newFlightSearchForm);

    // Initialize multicity calendar state for the newly added flight
    const newIndex = this.getAdditionalReqeustControl().length - 1;
    this.selectedTimeOptionMulticity[newIndex] = this.translate.instant('search.ANYTIME');
    this.showCustomTimingMulticity[newIndex] = false;
    this.showCustomCalendarMulticity[newIndex] = false;
    this.selectedCustomTimeMulticity[newIndex] = '';
    this.swapRotatedMulticity[newIndex] = false;

    // Initialize minimum date for the new flight
    this.updateMinimumDateMulticity(newIndex);
  }

  removeFlight(fgIndex: number, tempArray) {
    (<UntypedFormArray>this.searchForm.controls['flights']).removeAt(fgIndex);
    if (this.multicity) {
      this.invalidForm.splice(fgIndex, 1);
      for (let i = fgIndex; i < this.getAdditionalReqeustControl().length; i++) {
        this.invalidForm[i].index = i;
        this.invalidForm[i].value = tempArray[i + 1].value;
      }

      // Clean up multicity calendar state - arrays automatically re-index with splice
      this.showCustomCalendarMulticity.splice(fgIndex, 1);
      this.selectedTimeOptionMulticity.splice(fgIndex, 1);
      this.showCustomTimingMulticity.splice(fgIndex, 1);
      this.selectedCustomTimeMulticity.splice(fgIndex, 1);
      this.minDateMulticity.splice(fgIndex, 1);

      // Update minimum dates for subsequent flights after removal
      for (let i = fgIndex; i < this.getAdditionalReqeustControl().length; i++) {
        this.updateMinimumDateMulticity(i);
      }
    }
  }

  fillReturnFlight() {

    setTimeout(() => {
      let returnFlight = this.getFormArrayFLightObject(0);
      if (!returnFlight) return;
      if (returnFlight.value.source !== '' && returnFlight.value.destination !== '') {
        return;
      }

      (<UntypedFormArray>this.searchForm.controls['flights']).controls[0].patchValue({
        destination: this.searchForm.controls['source'].value,
        destinationCity: this.searchForm.controls['sourceCity'].value
      });
      (<UntypedFormArray>this.searchForm.controls['flights']).controls[0].patchValue({
        source: this.searchForm.controls['destination'].value,
        sourceCity: this.searchForm.controls['destinationCity'].value
      })
    }, 500);
  }

  getFormArrayFLightObject(formArrayIndex: number): AbstractControl {
    return (<UntypedFormArray>this.searchForm.controls['flights']).at(formArrayIndex);
  }

  get formArrayLength(): number {
    return (<UntypedFormArray>this.searchForm.controls['flights']).length;
  }

  get searchFormObjectsCount(): number {
    return this.formArrayLength + 1;
  }

  patchFormArrayFromQueryParam() {
    // this.searchForm.controls['flights'] = this.fb.array([]);
    let formArrayIndex = 0;
    var arrayValue = { value: false, index: 0 };
    for (let f of this.previousSearch.flights) {
      let flight = f;
      this.invalidForm.push(arrayValue);
      flight.source = flight.source.trim();
      flight.destination = flight.destination.trim();
      this.addFlight(flight);
      let formGroup = (<UntypedFormGroup>(<UntypedFormArray>this.searchForm.controls['flights']).at(formArrayIndex));
      if (this.isInputSearchTypeAirport()) {
        if (formGroup.controls['sourceAirportCode'].value == null || formGroup.controls['sourceAirportCode'].value.trim() == '') {
          formGroup.controls['sourceAirportCode'].setValue(flight.source);
        }
        if (formGroup.controls['destinationAirportCode'].value == null || formGroup.controls['destinationAirportCode'].value.trim() == '') {
          formGroup.controls['destinationAirportCode'].setValue(flight.destination);
        }
      } else {
        if (formGroup.controls['sourceCity'].value == null || formGroup.controls['sourceCity'].value.trim() == '') {
          formGroup.controls['sourceCity'].setValue(flight.source);
        }
        if (formGroup.controls['destinationCity'].value == null || formGroup.controls['destinationCity'].value.trim() == '') {
          formGroup.controls['destinationCity'].setValue(flight.destination);
        }
      }
      formArrayIndex++;
    }

    // Initialize minDateMulticity for all flights after loading from previous search
    if (this.previousSearch.trip === 'MULTICITY' && this.getAdditionalReqeustControl().length > 0) {
      // Initialize multicity calendar state arrays
      this.showCustomCalendarMulticity = [];
      this.selectedTimeOptionMulticity = [];
      this.showCustomTimingMulticity = [];
      this.selectedCustomTimeMulticity = [];
      this.minDateMulticity = [];

      for (let i = 0; i < this.getAdditionalReqeustControl().length; i++) {
        // Restore time option from previous search
        const flightData = this.previousSearch.flights[i];
        const timeValue = flightData?.constraintTime;
        if (timeValue && this.hourlyTimeOptions && this.hourlyTimeOptions.some(h => h.titleID === timeValue)) {
          this.selectedTimeOptionMulticity[i] = 'Custom';
          this.selectedCustomTimeMulticity[i] = timeValue;
          this.showCustomTimingMulticity[i] = true;
        } else {
          this.selectedTimeOptionMulticity[i] = timeValue || this.translate.instant('search.ANYTIME');
          this.selectedCustomTimeMulticity[i] = '';
          this.showCustomTimingMulticity[i] = false;
        }
        this.showCustomCalendarMulticity[i] = false;

        // Set minDateMulticity based on the previous flight's date
        if (i === 0) {
          // First additional flight (Flight 2) - min date is Flight 1's date
          this.minDateMulticity[i] = this.searchForm.controls['departureDate'].value
            ? new Date(this.searchForm.controls['departureDate'].value)
            : new Date();
        } else {
          // Subsequent flights - min date is previous flight's date
          const prevFlightDate = (<UntypedFormGroup>this.getFormArrayFLightObject(i - 1)).controls['departureDate'].value;
          this.minDateMulticity[i] = prevFlightDate ? new Date(prevFlightDate) : new Date();
        }
      }
    }

    if (!this.isInputSearchTypeAirport()) return;
    let fcount = 0;
    for (let f of this.previousSearch.flights) {
      this.prefillInputAirportFields(fcount, f);
      fcount++;
    }
  }

  prefillInputAirportFields(index: number, flight) {
    setTimeout(() => {
      $('#inputFieldIDSourceAirport_' + index).find('input[type=text]').val(flight.source);
      $('#inputFieldIDDestAirport_' + index).find('input[type=text]').val(flight.destination);
    }, 500);

  }
  get isResult() {
    return this.componentType === 'result';
  }

  setIsCollapsed(collapse) {
    this.isCollapsed = collapse;
    this.collapseToggle.emit(this.isCollapsed);
  }
  clearPreviousResults() {
    //     this.searchService.broadCastFlightResponse(null);
    //     this.searchService.broadcastNoOfFlightLegs(0);
  }
  onHidePicker() {
    this.searchService.calendarOpenEventListsner.next(null);
  }

  onShowPicker(event, picker) {
    this.searchService.calendarOpenEventListsner.next(picker);
    this.searchService.previousDate = false;
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if ((isHovered &&
        !!navigator.platform &&
        /iPad|iPhone|iPod/.test(navigator.platform)) &&
        'ontouchstart' in window
      ) {
        (picker as any)._datepickerRef.instance.daySelectHandler(cell);
      }

      return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  getDepartureAirportsForLeg(index: number) {

  }

  getArrivalAirportsForLeg(index: number) {

  }

  setLeg1Date(date) {
    this.minimumDateLeg2 = new Date(date);
    if (date && this.searchForm) {
      let leg1DateControl = this.searchForm.controls['departureDate'];

      // Check if date actually changed (not just calendar opening with existing value)
      const previousDate = leg1DateControl.value;
      const dateActuallyChanged = !previousDate ||
        new Date(date).setHours(0,0,0,0) !== new Date(previousDate).setHours(0,0,0,0);

      leg1DateControl.setValue(date);

      let leg2DateControl = this.searchForm.controls['arrivalDate'];
      if (this.searchForm.controls['trip'].value==='ROUNDTRIP' && !this.searchService.searchHeaderCliked && leg2DateControl.value < this.minimumDateLeg2) {
         this.searchForm.get('arrivalDate').setValue(null);
         this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
         this.searchForm.controls['arrivalDate'].updateValueAndValidity();
      }
      // Save flag before resetting - we need to skip multi-city date update when coming back from edit
      const comingBackFromEdit = this.searchService.searchHeaderCliked;
      if(this.searchService.searchHeaderCliked){
        this.searchService.searchHeaderCliked=false;
      }

      // For multi-city: when Flight 1 date changes, update ALL subsequent flights to same date
      // Skip this when coming back from EditFlightSearch to preserve original flight dates
      // Only update if date actually changed (not just calendar opening)
      if (date && this.multicity && !comingBackFromEdit && dateActuallyChanged) {
        if (this.getAdditionalReqeustControl().length > 0) {
          for (let i = 0; i < this.getAdditionalReqeustControl().length; i++) {
            // Update minimum date for this flight
            this.minDateMulticity[i] = new Date(date);

            // Set all subsequent flight dates to Flight 1's date
            let flightDateControl = (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['departureDate'];
            flightDateControl.setValue(date);
            this.setMinimumDate(i);
          }
        } else {
          this.minimumDateMultiple = date;
          this.minDateMulticity[0] = new Date(date);
        }
      }

    }
  }
  setLeg2Date(date) {
    if (date && this.searchForm) {
      let leg2DateControl = this.searchForm.controls['arrivalDate'];
      leg2DateControl.setValue(date);
    }
  }

  // New custom calendar methods
  private clickOutsideListener: any;
  private multicityClickOutsideListener: any;
  private currentMulticityCalendarIndex: number = -1;
  private ignoreNextOutsideClick: boolean = false;
  private savedScrollPosition: number = 0;

  // Helper method to scroll calendar into viewport when it opens on desktop
  private scrollCalendarIntoView(calendarSelector: string) {
    if (!this.isMobile && window.innerWidth >= 768) {
      this.savedScrollPosition = window.scrollY;
      // Use setTimeout to allow the calendar to render first
      setTimeout(() => {
        const calendarElement = document.querySelector(calendarSelector);
        if (calendarElement) {
          calendarElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 50);
    }
  }

  // Helper method to close all calendars before opening a new one
  private closeAllCalendars() {
    console.log('closeAllCalendars called');
    // Close departure calendar
    this.showCustomCalendar = false;
    // Close return calendar
    this.showCustomCalendar1 = false;
    // Close all multicity calendars
    for (let i = 0; i < this.showCustomCalendarMulticity.length; i++) {
      this.showCustomCalendarMulticity[i] = false;
    }
    // Remove click outside listener
    this.removeClickOutsideListener();
  }

  toggleCustomCalendar($event) {
    // Validate that source is selected before opening calendar (same check as openDepartureCalender)
     this.searchService.showTravelerDropDown=false;
    if (this.searchForm.controls['source'].value && this.searchForm.controls['source'].value !== '') {
      // Close all other calendars first
      this.closeAllCalendars();

      this.showCustomCalendar = !this.showCustomCalendar;

      if (this.showCustomCalendar) {
        // Scroll calendar into viewport on desktop
        this.scrollCalendarIntoView('.new-calendar-container:not(.new-calendar-container-return):not([class*="new-calendar-container-multicity"])');
        // Add click outside listener when calendar opens
        setTimeout(() => {
          this.clickOutsideListener = this.onClickOutside.bind(this);
          document.addEventListener('click', this.clickOutsideListener);
        }, 100);
      } else {
        this.removeClickOutsideListener();
      }
    } else {
      if(this.viewMode == 'tab1') this.toastr.error(this.translate.instant('setting.Pleaseenteranoriginairport'));
      else if(this.viewMode == 'tab5') this.toastr.error("Please enter an origin station.");
    }
  }

  closeCustomCalendar() {
    this.showCustomCalendar = false;
    this.removeClickOutsideListener();
  }

  private onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // Only select one-way calendar (not multicity or return)
    const calendarPopup = document.querySelector('.new-calendar-container:not(.new-calendar-container-return):not([class*="new-calendar-container-multicity"])');
    const dateInput = target.closest('.date-input-wrapper');

    // Close if click is outside both the popup and the date input
    if (calendarPopup && !calendarPopup.contains(target) && !dateInput) {
      this.closeCustomCalendar();
    }
  }

  private removeClickOutsideListener() {
    if (this.clickOutsideListener) {
      document.removeEventListener('click', this.clickOutsideListener, true); // Must match the addEventListener parameters
      this.clickOutsideListener = null;
      console.log('Click listener removed');
    }
  }

  onTimeTypeChange(type: string) {
    this.searchForm.controls['timeTypeFilter'].setValue(type);
    this.setDepartureConstraint({id: type, value: type === 'DEPARTURE_BASED' ? 'Depart' : 'Arrive', name: type === 'DEPARTURE_BASED' ? 'Depart' : 'Arrive'});
  }

  onTimeOptionChange(titleID: string) {
    if (titleID === 'Custom') {
      // Toggle custom timing grid
      this.showCustomTiming = !this.showCustomTiming;
    } else {
      // Regular time option selected
      this.selectedTimeOption = titleID;
      this.selectedCustomTime = ''; // Clear any custom time selection
      this.showCustomTiming = false;
      // Update form control
      this.searchForm.controls['constraintTime'].setValue(titleID);
      this.setConstraintTimeDeparture(titleID);
    }
  }

  onHourlyTimeSelect(titleID: string) {
    this.selectedTimeOption = 'Custom'; // Keep Custom icon selected
    this.selectedCustomTime = titleID; // Store the specific time selected
    this.showCustomTiming = false;
    // Update form control with the actual time selected
    this.searchForm.controls['constraintTime'].setValue(titleID);
    this.setConstraintTimeDeparture(titleID);
  }

  toggleCustomTiming() {
    this.showCustomTiming = !this.showCustomTiming;
  }

  getCustomTimeTitle() {
    if (!this.selectedCustomTime) {
      return 'Custom';
    }
    const hourOption = this.hourlyTimeOptions.find(h => h.titleID === this.selectedCustomTime);
    return hourOption ? hourOption.title : 'Custom';
  }

  // Methods for return date calendar
  toggleCustomCalendar1() {
    this.searchService.showTravelerDropDown=false;
    // Validate that source and destination are selected before opening return calendar
    if (this.searchForm.controls['source'].value && this.searchForm.controls['source'].value !== '' &&
        this.searchForm.controls['destination'].value && this.searchForm.controls['destination'].value !== '') {
      // Close all other calendars first
      this.closeAllCalendars();

      this.showCustomCalendar1 = !this.showCustomCalendar1;
      if (this.showCustomCalendar1) {
        // Scroll calendar into viewport on desktop
        this.scrollCalendarIntoView('.new-calendar-container-return');
        setTimeout(() => {
          this.clickOutsideListener = this.onClickOutside1.bind(this);
          document.addEventListener('click', this.clickOutsideListener);
        }, 100);
      } else {
        this.removeClickOutsideListener();
      }
    } else {
      if (!this.searchForm.controls['source'].value || this.searchForm.controls['source'].value === '') {
        if(this.viewMode == 'tab1') this.toastr.error(this.translate.instant('setting.Pleaseenteranoriginairport'));
        else if(this.viewMode == 'tab5') this.toastr.error("Please enter an origin station.");
      } else if (!this.searchForm.controls['destination'].value || this.searchForm.controls['destination'].value === '') {
        if(this.viewMode == 'tab1') this.toastr.error(this.translate.instant('setting.Pleaseenteradestination'));
        else if(this.viewMode == 'tab5') this.toastr.error("Please enter a destination station.");
      }
    }
  }

  closeCustomCalendar1() {
    this.showCustomCalendar1 = false;
    this.removeClickOutsideListener();
  }

  private onClickOutside1(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const calendarPopup = document.querySelector('.new-calendar-container-return');
    const dateInput = target.closest('.date-input-wrapper-return');

    // Don't close if clicking on multicity calendars
    const multicityCalendar = target.closest('[class*="new-calendar-container-multicity"]');

    if (calendarPopup && !calendarPopup.contains(target) && !dateInput && !multicityCalendar) {
      this.closeCustomCalendar1();
    }
  }

  private onClickOutsideMulticity(event: MouseEvent) {
    if (this.currentMulticityCalendarIndex < 0) return;

    const target = event.target as HTMLElement;
    const calendarPopup = document.querySelector(`.new-calendar-container-multicity-${this.currentMulticityCalendarIndex}`);
    const dateInput = target.closest('.date-input-wrapper-multicity');

    // Close if click is outside both the popup and the date input
    if (calendarPopup && !calendarPopup.contains(target) && !dateInput) {
      this.closeCustomCalendarMulticity(this.currentMulticityCalendarIndex);
    }
  }

  private addMulticityClickOutsideListener(index: number) {
    // Remove any existing listener first
    this.removeMulticityClickOutsideListener();

    // Store the current index
    this.currentMulticityCalendarIndex = index;

    // Add the listener
    setTimeout(() => {
      this.multicityClickOutsideListener = this.onClickOutsideMulticity.bind(this);
      document.addEventListener('click', this.multicityClickOutsideListener);
    }, 100);
  }

  private removeMulticityClickOutsideListener() {
    if (this.multicityClickOutsideListener) {
      document.removeEventListener('click', this.multicityClickOutsideListener, true);
      this.multicityClickOutsideListener = null;
      this.currentMulticityCalendarIndex = -1;
    }
  }

  onTimeTypeChange1(type: string) {
    this.searchForm.controls['timeTypeFilter1'].setValue(type);
    this.setArrivalConstraint({id: type, value: type === 'DEPARTURE_BASED' ? 'Depart' : 'Arrive', name: type === 'DEPARTURE_BASED' ? 'Depart' : 'Arrive'});
  }

  onTimeOptionChange1(titleID: string) {
    if (titleID === 'Custom') {
      this.showCustomTiming1 = !this.showCustomTiming1;
    } else {
      this.selectedTimeOption1 = titleID;
      this.selectedCustomTime1 = '';
      this.showCustomTiming1 = false;
      this.searchForm.controls['constraintTime1'].setValue(titleID);
      this.setConstraintTimeArrival(titleID);
    }
  }

  onHourlyTimeSelect1(titleID: string) {
    this.selectedTimeOption1 = 'Custom';
    this.selectedCustomTime1 = titleID;
    this.showCustomTiming1 = false;
    this.searchForm.controls['constraintTime1'].setValue(titleID);
    this.setConstraintTimeArrival(titleID);
  }

  getCustomTimeTitle1() {
    if (!this.selectedCustomTime1) {
      return 'Custom';
    }
    const hourOption = this.hourlyTimeOptions.find(h => h.titleID === this.selectedCustomTime1);
    return hourOption ? hourOption.title : 'Custom';
  }

  // Methods for multicity calendar
  toggleCustomCalendarMulticity(index: number) {
    console.log('toggleCustomCalendarMulticity called for index:', index);

    // Validate that source is selected before opening calendar
    let form: UntypedFormGroup = <UntypedFormGroup>this.getFormArrayFLightObject(index);

    if (form && form.controls['source'] && form.controls['source'].value && form.controls['source'].value !== '') {
      // Close all other calendars first
      for (let i = 0; i < this.showCustomCalendarMulticity.length; i++) {
        if (i !== index) {
          this.showCustomCalendarMulticity[i] = false;
        }
      }

      // Toggle current calendar
      this.showCustomCalendarMulticity[index] = !this.showCustomCalendarMulticity[index];

      // Force Angular change detection by creating a new array reference
      this.showCustomCalendarMulticity = [...this.showCustomCalendarMulticity];

      // Add/remove click outside listener
      if (this.showCustomCalendarMulticity[index]) {
        // Scroll calendar into viewport on desktop
        this.scrollCalendarIntoView(`.new-calendar-container-multicity-${index}`);
        this.addMulticityClickOutsideListener(index);
      } else {
        this.removeMulticityClickOutsideListener();
      }

      console.log('Calendar', index, 'is now:', this.showCustomCalendarMulticity[index] ? 'OPEN' : 'CLOSED');
    } else {
      console.log('Source validation failed for index', index);
      if(this.viewMode == 'tab1') this.toastr.error(this.translate.instant('setting.Pleaseenteranoriginairport'));
      else if(this.viewMode == 'tab5') this.toastr.error("Please enter an origin station.");
    }
  }

  closeCustomCalendarMulticity(index: number) {
    console.log('closeCustomCalendarMulticity called for index:', index);
    this.showCustomCalendarMulticity[index] = false;
    // Trigger change detection
    this.showCustomCalendarMulticity = [...this.showCustomCalendarMulticity];
    // Remove click outside listener
    this.removeMulticityClickOutsideListener();
  }

  onBackdropClickMulticity(index: number, event: MouseEvent) {
    // Close the calendar when backdrop is clicked
    console.log('Backdrop clicked for calendar', index);
    this.closeCustomCalendarMulticity(index);
    event.stopPropagation();
  }

  onTimeTypeChangeMulticity(type: string, index: number) {
    const formGroup = this.getFormArrayFLightObject(index) as UntypedFormGroup;
    formGroup.controls['constraint'].setValue(type);
    this.setMultiLeg2DepartureConstraint({id: type, value: type === 'DEPARTURE_BASED' ? 'Depart' : 'Arrive', name: type === 'DEPARTURE_BASED' ? 'Depart' : 'Arrive'}, index);
  }

  onTimeOptionChangeMulticity(titleID: string, index: number) {
    if (titleID === 'Custom') {
      this.showCustomTimingMulticity[index] = !this.showCustomTimingMulticity[index];
    } else {
      this.selectedTimeOptionMulticity[index] = titleID;
      this.selectedCustomTimeMulticity[index] = '';
      this.showCustomTimingMulticity[index] = false;
      const formGroup = this.getFormArrayFLightObject(index) as UntypedFormGroup;
      formGroup.controls['constraintTime'].setValue(titleID);
      this.setMultiLeg2Constraint(titleID, index);
    }
  }

  onHourlyTimeSelectMulticity(titleID: string, index: number) {
    this.selectedTimeOptionMulticity[index] = 'Custom';
    this.selectedCustomTimeMulticity[index] = titleID;
    this.showCustomTimingMulticity[index] = false;
    const formGroup = this.getFormArrayFLightObject(index) as UntypedFormGroup;
    formGroup.controls['constraintTime'].setValue(titleID);
    this.setMultiLeg2Constraint(titleID, index);
  }

  getCustomTimeTitleMulticity(index: number) {
    if (!this.selectedCustomTimeMulticity || !this.selectedCustomTimeMulticity[index]) {
      return 'Custom';
    }
    const hourOption = this.hourlyTimeOptions.find(h => h.titleID === this.selectedCustomTimeMulticity[index]);
    return hourOption ? hourOption.title : 'Custom';
  }

  getSelectedTimeOptionMulticity(index: number): string {
    if (!this.selectedTimeOptionMulticity) {
      return this.translate.instant('search.ANYTIME');
    }
    return this.selectedTimeOptionMulticity[index] || this.translate.instant('search.ANYTIME');
  }

  getSelectedCustomTimeMulticity(index: number): string {
    if (!this.selectedCustomTimeMulticity) {
      return '';
    }
    return this.selectedCustomTimeMulticity[index] || '';
  }

  getShowCustomTimingMulticity(index: number): boolean {
    if (!this.showCustomTimingMulticity) {
      return false;
    }
    return this.showCustomTimingMulticity[index] || false;
  }

  isMulticityCalendarOpen(index: number): boolean {
    return this.showCustomCalendarMulticity && this.showCustomCalendarMulticity[index] === true;
  }

  setMultiLeg2Date(date, i) {
    if (date) {
      if (this.searchForm) {
        let leg2DateControl = (<UntypedFormGroup>this.getFormArrayFLightObject(i)).controls['departureDate']
        const prev = leg2DateControl.value;
        leg2DateControl.setValue(date);
        if (!prev || date.getTime() !== new Date(prev).getTime()) {this.closeMulticityCalender(i);}

        // Update ALL subsequent flights: set their minDate and date to this flight's date
        // This should always work regardless of previousDate flag
        if (this.getAdditionalReqeustControl().length > i) {
          for (let j = (i + 1); j < this.getAdditionalReqeustControl().length; j++) {
            // Update minimum date for subsequent flight
            this.minDateMulticity[j] = new Date(date);

            // Set subsequent flight dates to this flight's date
            let subsequentDateControl = (<UntypedFormGroup>this.getFormArrayFLightObject(j)).controls['departureDate'];
            subsequentDateControl.setValue(date);
          }
        }
      }
    }
  }
  
  closeMulticityCalender(i){
     if (i < 0) return;
    const calendarPopup = document.querySelector(`.new-calendar-container-multicity-${i}`);
    if (calendarPopup) {this.closeCustomCalendarMulticity(this.currentMulticityCalendarIndex);}
  }

  // Update minimum date for multicity flight at index i
  updateMinimumDateMulticity(i: number) {
    var index = i - 1;
    if (index >= 0) {
      const formGroup = <UntypedFormGroup>this.getFormArrayFLightObject(index);
      this.minDateMulticity[i] = formGroup.get('departureDate').value ? formGroup.get('departureDate').value : new Date();
    } else {
      this.minDateMulticity[i] = this.searchForm.controls['departureDate'].value ? this.searchForm.controls['departureDate'].value : new Date();
    }
  }

  setMinimumDate(i) {
    var index = i - 1;
    if (index >= 0) {
      this.minimumDateMultiple = (<UntypedFormGroup>this.getFormArrayFLightObject(index)).get('departureDate').value ? (<UntypedFormGroup>this.getFormArrayFLightObject(index)).get('departureDate').value : new Date();
    } else {
      this.minimumDateMultiple = this.searchForm.controls['departureDate'].value ? this.searchForm.controls['departureDate'].value : new Date();
    }
    return this.minimumDateMultiple;
  }
  setCheckInDate(date) {
    if (date) {
      this.minimumDateLeg2 = new Date(date);
      this.minimumDateLeg2.setDate(this.minimumDateLeg2.getDate() + 1);
      if (date) {
        this.maximumDate3 = new Date(date);
        this.maximumDate3.setDate(this.maximumDate3.getDate() + this.searchService.maxAllowedHotelStay);
      }
      if (this.searchHotelForm) {
        let leg1DateControl = this.searchHotelForm.controls['checkinDate'];
        leg1DateControl.setValue(date);
        let leg2DateControl = this.searchHotelForm.controls['checkoutDate']; const oneDay = 24 * 60 * 60 * 1000;
        if (date && leg2DateControl.value < this.minimumDateLeg2) {
          setTimeout(() => {
            this.searchHotelForm.get('checkoutDate').setValue(this.minimumDateLeg2);
          }, 200);
        }
        var checkOutDate = this.searchHotelForm.controls['checkoutDate'].value;
        var currntDate = Math.round(Math.abs((date - checkOutDate) / oneDay));
        if (currntDate > 21) {
          setTimeout(() => {
            this.searchHotelForm.get('checkoutDate').setValue(this.minimumDateLeg2);
          }, 200);

        }
      }
    }
  }
  setCheckOutDate(date) {
    if (date) {
      if (this.searchHotelForm) {
        let leg2DateControl = this.searchHotelForm.controls['checkoutDate'];
        leg2DateControl.setValue(date);
      }
    }
  }

  onHotelTravellerCountChanged(count) {
    if (Number.parseInt(this.searchHotelForm.controls['roomCount'].value) > Number.parseInt(count.id)) {
      this.searchHotelForm.controls['roomCount'].setValue(count.id);
    }
    let params = "?ua_action=NumberOfPeopleMenuItem&ua_item=" + parseInt(count.id) + "&ua_type=hotels";;
    this.searchService.letsTrack(params);
  }

  onHotelRoomCountChanged(count) {
    if (Number.parseInt(this.searchHotelForm.controls['personCount'].value) < Number.parseInt(count.id)) {
      this.searchHotelForm.controls['personCount'].setValue(count.id);
    }
    let params = "?ua_action=NumberOfRoomsMenuItem&ua_item=" + parseInt(count.id);
    this.searchService.letsTrack(params);
  }


  onDateChange(date) {
    if ((<UntypedFormArray>this.searchForm.controls['flights']).length == 0) { return; }
    let departureDateControl = (<UntypedFormGroup>(<UntypedFormArray>this.searchForm.controls['flights']).controls[0]).controls['departureDate'];
    let arrivalDateControl = (<UntypedFormGroup>(<UntypedFormArray>this.searchForm.controls['flights']).controls[0]).controls['arrivalDate'];

    if (departureDateControl.value > date || arrivalDateControl.value > date) {
      return;
    }

    departureDateControl.setValue(date);
    arrivalDateControl.setValue(date);
  }

  getFlightsFormArrayControl(): AbstractControl[] {
    return (<UntypedFormArray>this.searchForm.controls['flights']).controls;
  }
  railCardsSelected=[];
  onRailCardChangeClicked(item,event){

  if (this.railCardsSelected.length >= 3) {
    this.railCardsSelected.pop();
  }

  event.preventDefault();
  event.stopPropagation();

  const alreadySelected = this.railCardsSelected.includes(item);

  if (alreadySelected) {
    // remove item
    this.railCardsSelected = this.railCardsSelected.filter(x => x !== item);
  } else {
      this.railCardsSelected.push(item);
    
  }
}
isRailCardChecked(item){
  return this.railCardsSelected.indexOf(item) > -1;
}
getRailCardsName(){
  let selectedRailcard;
  let selectedRailcardValue=[];
  if(this.railCardsSelected.length > 0 ){
    for(let item of this.railCardsSelected){
      let railValue = this.railCardsOptions.filter(item1 => item1.id ===item);
      if(railValue  && railValue.length > 0 && railValue[0].id){
        selectedRailcardValue.push(railValue[0].value)
      }
    }
    let selectedRailcard = selectedRailcardValue.join(', ');
  return selectedRailcard;
 }else{
  return this.translateService.instant('search.Railcards');
 }
}
  getClassName(id) {
    let className;

    this.classOptions.map(item => {
      if (item.id.toLowerCase() == id.toLowerCase()) {
        className = item.value;
        return;
      }
    });

    return className;
  }
  getTicketName(id) {
    let className=this.translateService.instant('search.Tickettype');;

    this.ticketOptions.map(item => {
      if (item.id.toLowerCase() == id.toLowerCase()) {
        className = item.value;
      
      }
    });

    return className;
  }
  getSeatName(id) {
    let className=this.translateService.instant('search.SelectSeat');;

    this.seatOptions.map(item => {
      if (item.id.toLowerCase() == id.toLowerCase()) {
        className = item.value;
        return;
      }
    });

    return className;
  }
  getValueOfId(id, options) {
    let value;
    options.map(item => {
      if (item.id.toLowerCase() == id.toLowerCase()) {
        value = item.value;
        return;
      }
    });
    return value;
  }

  getValueOfRoomId(id, options) {
    let value;
    options.map(item => {
      if (Number.parseInt(item.id) == Number.parseInt(id)) {
        value = item.value;
        return;
      }
    });
    return value;
  }


  getTimeTypeName(id) {
    let timeTypeName;

    this.timeTypeOptions.map(item => {
      if (item.id.toLowerCase() == id.toLowerCase()) {
        timeTypeName = item.value;
        // return;
      }
    });

    return timeTypeName;
  }


  getTimeOptionName(id, item) {
    if (item) {
      this.getTimeOptions(item);
    }
    let timeOptionName;
    if (!this.timeOptions) {
      return 'ngOption.Anytime';
    }
    this.timeOptions.map(item => {
      if (item.titleID.toLowerCase() == id.toLowerCase()
        || item.value.toLowerCase() == id.toLowerCase()) {
        timeOptionName = item.value;
        // return;
      }
    });

    return timeOptionName;
  }
  showMutiCity(i, j) {
    if ((i + 1) !== this.searchService.flight.length) {
      return true;
    } else {
      return false;
    }
  }
  getClassName1(event) {
    //
    let className;
    this.classOptions.map(item => {
      if (item.id.toLowerCase() == event.id.toLowerCase()) {
        let params = "?ua_action=ClassMenuItem&ua_item=" + item.value;
        this.searchService.letsTrack(params);
        return;
      }
    });
  }
  getTicketType(event) {
    //
    let className;
    this.ticketOptions.map(item => {
      if (item.id.toLowerCase() == event.id.toLowerCase()) {
        let params = "?ua_action=ticketMenuItem&ua_item=" + item.value;
        this.searchService.letsTrack(params);
        return;
      }
    });
  }
  getHotelChain(event) {
    let params = (event.id !== '') ? "?ua_action=HotelChainMenuItem&ua_item=" + event.id : "?ua_action=HotelChainMenuItem&ua_item=Any";
    this.searchService.letsTrack(params);
  }
  getTripName(id) {
    let tripName;

    this.tripOptions.map(item => {
      if (item.id.toLowerCase() == id.toLowerCase()) {
        tripName = item.value;
        return;
      }
    });

    return tripName;
  }

  // 🎯 Setup Visual Viewport listener for keyboard offset management
  private setupVisualViewportListener() {
    // The visual viewport is the portion of the screen currently visible
    // (excluding the keyboard and browser UI).
    // Listen for changes in the visual viewport size (when keyboard appears/hides).
    fromEvent(window.visualViewport!, 'resize')
      .pipe(
        // Use debounceTime to avoid excessive calculations during a rapid resize event
        debounceTime(50),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.calculateKeyboardOffset();
      });

    // Initial calculation
    this.calculateKeyboardOffset();
  }

  private calculateKeyboardOffset() {
    const visualViewport = window.visualViewport!;

    // The Layout Viewport is the original, static screen size (before keyboard).
    // The Visual Viewport is the current, scaled, and panned view (after keyboard).

    // We calculate how much the visible area has shifted upwards due to the keyboard.
    // The amount of vertical offset applied by the browser to keep the input visible:
    const offsetTop = visualViewport.offsetTop;

    // Set CSS custom property on document root so SCSS can use it
    // This value represents the amount the component needs to shift down
    // to align correctly under the new top edge of the visual viewport.
    document.documentElement.style.setProperty('--keyboard-offset', `${offsetTop}px`);
  }

  // 🎯 Activate airport input positioning when an input is clicked
  public activateAirportInput(inputElementId: string) {
    // Find the airport-input-wrapper element (includes icon and label structure)
    const inputElement = document.getElementById(inputElementId);

    if (inputElement) {
      const airportInputWrapper = inputElement.closest('.airport-input-wrapper');

      if (airportInputWrapper) {
        this.activeInputElement = airportInputWrapper as HTMLElement;
        this.activeInputElement.classList.add('airport-input-active');

        // Also find and activate the airport modal
        const airportModal = airportInputWrapper.querySelector('app-airports');

        if (airportModal) {
          this.activeAirportModalElement = airportModal as HTMLElement;
          this.activeAirportModalElement.classList.add('airport-modal-active');
        }
      }
    }
  }

  // 🎯 Deactivate airport input positioning when selection is done
  public deactivateAirportInput() {
    if (this.activeInputElement) {
      this.activeInputElement.classList.remove('airport-input-active');

      // Remove inline styles that were set
      this.activeInputElement.style.top = '';
      this.activeInputElement.style.height = '';

      this.activeInputElement = null;
    }

    if (this.activeAirportModalElement) {
      this.activeAirportModalElement.classList.remove('airport-modal-active');
      this.activeAirportModalElement = null;
    }

    // Clean up scroll prevention handlers
    this.cleanupIOSKeyboardScrollPrevention();
  }

  // 🎯 Prevent iOS from scrolling when keyboard opens
  private preventIOSKeyboardScroll(wrapper: HTMLElement) {
    // Clean up any existing handlers first
    this.cleanupIOSKeyboardScrollPrevention();

    // Store wrapper reference for cleanup
    this.mobileAirportWrapper = wrapper;

    // Prevent window scroll
    this.scrollPreventionHandler = () => {
      window.scrollTo({ top: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Add scroll listener to prevent any scrolling
    window.addEventListener('scroll', this.scrollPreventionHandler, { passive: false });

    // Use visualViewport API to handle keyboard appearance on iOS
    if (window.visualViewport) {
      this.visualViewportHandler = () => {
        // When keyboard opens, visualViewport height decreases
        // Force the wrapper to stay at top
        if (this.mobileAirportWrapper) {
          this.mobileAirportWrapper.style.top = '0px';
          this.mobileAirportWrapper.style.height = `${window.visualViewport!.height}px`;
        }
        // Force scroll to top
        window.scrollTo({ top: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      };

      window.visualViewport.addEventListener('resize', this.visualViewportHandler);
      window.visualViewport.addEventListener('scroll', this.visualViewportHandler);
    }

    // Prevent background scrolling — do NOT set position:fixed on body,
    // it causes the input caret to be invisible on real iOS devices.
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.documentElement.style.overflow = 'hidden';
  }

  // 🎯 Clean up iOS keyboard scroll prevention
  private cleanupIOSKeyboardScrollPrevention() {
    if (this.scrollPreventionHandler) {
      window.removeEventListener('scroll', this.scrollPreventionHandler);
      this.scrollPreventionHandler = null;
    }

    if (this.visualViewportHandler && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.visualViewportHandler);
      window.visualViewport.removeEventListener('scroll', this.visualViewportHandler);
      this.visualViewportHandler = null;
    }

    // Reset wrapper styles that were set dynamically
    if (this.mobileAirportWrapper) {
      this.mobileAirportWrapper.style.height = '';
      this.mobileAirportWrapper.style.top = '';
      this.mobileAirportWrapper = null;
    }

    // Restore body scroll
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
    document.documentElement.style.overflow = '';
  }

  ngOnDestroy() {
     document.body.classList.remove('search-body');
    // Reset event modal flag
    this.eventModalShown = false;

    // Cleanup iOS keyboard scroll prevention
    this.cleanupIOSKeyboardScrollPrevention();

    // Cleanup custom calendar click outside listener
    this.removeClickOutsideListener();

    // Cleanup hotel calendar click outside listeners
    if (this.hotelCheckinClickOutsideListener) {
      document.removeEventListener('click', this.hotelCheckinClickOutsideListener);
    }
    if (this.hotelCheckoutClickOutsideListener) {
      document.removeEventListener('click', this.hotelCheckoutClickOutsideListener);
    }

    if (this.deviceSubscription) {
      this.deviceSubscription.unsubscribe();
    }
    if (this.companyApprovalSubscription) {
      this.companyApprovalSubscription.unsubscribe();
    }
    if (this.listEmployeesResponseSubscription) {
      this.listEmployeesResponseSubscription.unsubscribe();
    }
    if (this.listEmployeesResponseSubscription) {
      this.listEmployeesResponseSubscription.unsubscribe();
    }
    if (this.userDetailsSubscription) {
      this.userDetailsSubscription.unsubscribe();
    }
    if (this.urlParameterSubscription) {
      this.urlParameterSubscription.unsubscribe();
    }
    if (this.userInItSubscription) {
      this.userInItSubscription.unsubscribe();
    }
    if (this.fetchInviteListSubscription) {
      this.fetchInviteListSubscription.unsubscribe();
    }

    // 🎯 Complete destroy$ subject to cleanup Visual Viewport listener
    this.destroy$.next();
    this.destroy$.complete();
  }

  public handleTripTypeChange(data: any) {

    let adult;
    if (data === 'PODUCTIVITY') {
      adult = +this.searchForm.controls['adults'].value;
      this.searchForm.controls['passengers'].setValue('0' + adult);
      this.setTripType(data);
    } else if (data === 'LEISURE') {
      adult = +this.searchForm.controls['passengers'].value;
      this.adults = 2 * adult;
      this.infants = 0;
      this.leisureValue = +this.searchForm.controls['passengers'].value;
      let index = 0;
      for (let typeItem of this.passengerTypeSpecific) {
        if (index > 0) {
          this.searchForm.controls[typeItem.id].setValue(0);
          typeItem.number = 0;
        } else {
          this.searchForm.controls[typeItem.id].setValue(adult);
          typeItem.number = adult;
        }
        index = index + 1;
      }
      this.setTripType(data);
    }

  }
  getSearchIndex() {
    return this.searchService.seletedIndex;
  }
  getOutgoingSelectedFlight() {
    var selectedFlights;
    if (this.searchService.seletedIndex === 1) {
      if (!this.searchService.nonCombo) {
        this.searchService.flight = this.searchService.multipleOutgoingSelectedFlight;
      } else {
        this.searchService.flight = this.searchService.nonComboSelectedFlight;
      }
    } else if (this.searchService.seletedIndex > 1) {
      if (!this.searchService.nonCombo) {
        selectedFlights = this.searchService.multipleOutgoingSelectedFlight;
        //this.selectedFlights.splice(0,1);
        for(let item of selectedFlights){
             if(item.travelCreditsInfo){
              for(let flight of this.searchService.flight){
                if(!flight.travelCreditsInfo){
                  flight.travelCreditsInfo = item.travelCreditsInfo;
                }
              } 
             }
        }
        this.searchService.flight = selectedFlights;
        for (let i = 0; i < this.searchService.multipleOutgoingSelectedFlight.length; i++) {
          if (this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].displayPrice) {
            this.searchService.flight[i].displayPrice = this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].displayPrice;

          }
          this.searchService.flight[i].price = this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].price;
          this.searchService.flight[i].fareBreakup = this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].fareBreakup;
        }
      } else {
        selectedFlights = this.searchService.nonComboSelectedFlight;
        this.searchService.flight = selectedFlights;
        for (let i = 0; i < this.searchService.nonComboSelectedFlight.length; i++) {
          if (this.searchService.nonComboSelectedFlight[i].displayPrice) {
            this.searchService.flight[i].displayPrice = this.searchService.nonComboSelectedFlight[i].displayPrice;

          }
          this.searchService.flight[i].price = this.searchService.nonComboSelectedFlight[i].price;
          this.searchService.flight[i].fareBreakup = this.searchService.nonComboSelectedFlight[i].fareBreakup;
        }
      }
    }

    return this.searchService.outgoingSelectedFlight;
  }

  flightUnSelected(index) {
    var selectedFlights;
    this.searchService.backClick = false;
    if (index === 0 && this.searchService.priceWithTravelCreditsZero) {
      this.searchService.priceWithTravelCreditsZero = false;
    }
    this.changeSelectedFlight.emit(true);
    this.searchService.flightId.splice(index);
    if (index === 0) {
      this.searchService.nonComboSelectedFlight = [];
      this.searchService.flight = [];
      this.searchService.flightId = [];
      //  this.searchService.outgoingSelectedFlight = undefined;
    } else {
      this.searchService.flight.splice(index);
      if (this.searchService.seletedIndex > 1) {
        this.searchService.nonComboSelectedFlight.splice(index);
        this.searchService.multipleOutgoingSelectedFlight.splice(index);
        if (!this.searchService.nonCombo) {
          selectedFlights = this.searchService.multipleOutgoingSelectedFlight;
          //this.selectedFlights.splice(0,1);
          this.searchService.flight = selectedFlights;
          for (let i = 0; i < this.searchService.multipleOutgoingSelectedFlight.length; i++) {
            if (this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].displayPrice) {
              this.searchService.flight[i].displayPrice = this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].displayPrice;

            }
            this.searchService.flight[i].price = this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].price;
            this.searchService.flight[i].fareBreakup = this.searchService.multipleOutgoingSelectedFlight[(this.searchService.multipleOutgoingSelectedFlight.length - 1)].fareBreakup;
          }
        } else {
          selectedFlights = this.searchService.nonComboSelectedFlight;
          this.searchService.flight = selectedFlights;
          for (let i = 0; i < this.searchService.nonComboSelectedFlight.length; i++) {
            if (this.searchService.nonComboSelectedFlight[i].displayPrice) {
              this.searchService.flight[i].displayPrice = this.searchService.nonComboSelectedFlight[i].displayPrice;

            }
            this.searchService.flight[i].price = this.searchService.nonComboSelectedFlight[i].price;
            this.searchService.flight[i].fareBreakup = this.searchService.nonComboSelectedFlight[i].fareBreakup;
          }
        }
      }
    }
    if (index !== 0 && this.searchService.nonComboSelectedFlight && this.searchService.nonComboSelectedFlight.length > 0) {
      // var creditDetails11 = CommonUtils.getCreditValue(this.searchService.nonComboSelectedFlight[0], this.noOfPassengers);
      if (this.searchService.nonComboSelectedFlight[0].travelCreditsInfo && this.searchService.nonComboSelectedFlight[0].travelCreditsInfo.length > 0) {
        this.searchService.priceWithTravelCreditsZero = true;
      }
    }
    this.searchService.resetOutgoingSelectedFlight(index);
    let queryAsJSON = JSON.parse(JSON.stringify(this.searchService.flightSearchQueryParam));
    queryAsJSON.departureDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.departureDate)) + "T00:00:00.000Z";
    queryAsJSON.arrivalDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(queryAsJSON.arrivalDate)) + "T00:00:00.000Z";
    if (queryAsJSON.flights && queryAsJSON.flights.length > 0) {
      for (let multiFlightObj of queryAsJSON.flights) {
        multiFlightObj.departureDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(multiFlightObj.departureDate)) + "T00:00:00.000Z";
        multiFlightObj.arrivalDate = DateUtils.getFormattedDateWithoutTimeZone(new Date(multiFlightObj.arrivalDate)) + "T00:00:00.000Z";
      }
    }
    if (this.searchService.flightId.length === 0) {
      this.searchService.comingBackFromFlights = false;
      this.router.navigate(["flights"],
        {
          queryParams:
          {
            query: encodeURIComponent(JSON.stringify(queryAsJSON)),
            step: 0,
            index: this.searchService.flightId.length,
            resultFound: 1
          },
          replaceUrl: false
        }
      );
      //this.location1.replaceState('/search');
    } else {
      this.searchService.comingBackFromFlights = false;
      this.router.navigate(["flights"],
        {
          queryParams:
          {
            query: encodeURIComponent(JSON.stringify(queryAsJSON)),
            step: 0,
            index: this.searchService.flightId.length,
            flight: JSON.parse(JSON.stringify(this.searchService.flightId)),
            resultFound: 1
          },
          replaceUrl: false
        }
      );
    }
  }


  handleModalEvents(eventName: string, currentModalId: string) {
    CommonUtils.handleModalEvents(this.ngxSmartModalService, eventName, currentModalId);
  }
  onSmartModelCancel(modelName: string) {
    this.ngxSmartModalService.getModal(modelName).close();
  }

  clearHotelTextField() {
    this.selectedCurrentLocation = false;
    let form = { ...this.searchHotelForm };
    form['currentLocation'] = '';
    form['hotelAddress'] = '';
    form['hotelAddressCity'] = '';
    this.searchHotelForm.patchValue({ ...form });

    this.setSearchForm(-1);
    this.showCurrentLocation = false;
    setTimeout(() => {
      this.initAutocomplete();
    setFocusOnHotelInputField();
    }, 200);
  }
  isSearchFormNonEmpty() {
    return (this.searchHotelForm.controls.hotelAddress
      && this.searchHotelForm.controls.hotelAddress.value
      && this.searchHotelForm.controls.hotelAddress.value.trim().length > 0);
  }

  getCheckinDate() {
    return this.searchHotelForm.controls['checkinDate'].value;
  }
  getCheckoutDate() {
    return this.searchHotelForm.controls['checkoutDate'].value;
  }
 
  
  public onHotelAddressFocused() {
    if (this.location_feature_enabled) {
      if (!this.isSearchFormNonEmpty()) {
        setTimeout(() => {
          this.showCurrentLocation = this.location_feature_enabled;
        }, 100); 
        return;
      }
    }
    this.showCurrentLocation = false;
  }
  public isAlgoSwitchVisible() {
    return false;
  }
  public isCarsEnabled() {
    return this.userAccountInfoService.isCarsEnabled;
  }
  public isShowAllBookings() {
    return this.userAccountInfoService.isShowAllBookings();
  }
  trainTabClicked(){
    this.closeAirportComponent();
    
    if(this.searchService.multiTripBooking){
      return;
    }
    this.getStationListForTrain();
    let tripType = this.searchForm.controls['trip'].value;
   
    this.searchForm.reset();
    this.createForm();
    if (tripType === 'MULTICITY') {

      this.addFlight();
      this.searchService.isSearchPage = false;
      this.setMinimumDate((0));
      this.multicity = true;
    }else{
      this.multicity = false;
    }
    if (tripType === 'ROUNDTRIP') {
      this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
      this.searchForm.controls['arrivalDate'].updateValueAndValidity();
    } else {
      this.searchForm.controls['arrivalDate'].clearValidators();
      this.searchForm.controls['arrivalDate'].updateValueAndValidity();
    }
    this.searchForm.controls['trip'].setValue(tripType); 
    this.railCardsSelected=[];
      this.viewMode = 'tab5';
       if (this.searchService.employeeEmail.length > environment.maxTravellersForFlight) {
         this.searchService.employeeEmail.splice(environment.maxTravellersForFlight);
       }
       this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
       this.searchForm.controls['adults'].setValue("" + this.searchService.employeeEmail.length);
       this.cdRef.detectChanges();
       this.titleService.setTitle("Train Search.");
       this.resetTraveler();
       this.router.navigate([this.userAccountInfoService.getDefaultRoutePath()],
         {
           queryParams:
           {
             type: 'train',
           },
           replaceUrl: true
         }
     );
  }
  sendSearchDataForTrain(searchData){
    this.searchService.sendSearchDataForTrain(searchData).subscribe(resp=>{
      if(resp && resp.success && resp.success == true){
        this.searchInProgress = false;
       this.bsModalRef = this.modalService.show(this.thankyoumodal, {
        backdrop: 'static',
        keyboard: false
      });
        
      }else{
        this.searchForm.controls['trainLine'].enable();
        this.searchForm.controls['trip'].enable();
        this.searchInProgress = false;
       this.toastr.error("Something went wrong.");
      }
    })
  }
  searchAgainForTrain(){
    this.bsModalRef.hide();
    this.searchService.employeeEmail=[];
    this.searchForm.controls['trainLine'].enable();
    this.searchForm.controls['trip'].enable();
    this.searchForm.reset();
    this.createForm();
    this.multicity = false;
    this.viewMode = 'tab5';
    this.employeeListCame = false;
    this.getEmployeeAndTravellerList();
    this.filterTrainStationWithTrainLine();
  }
  addSpaceAfterComma(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(value => this.addSpaceAfterComma(value));
    } else if (obj !== null && typeof obj === 'object') {
      const updated = {};
      for (const key in obj) {
        updated[key] = this.addSpaceAfterComma(obj[key]);
      }
      return updated;
    } else if (typeof obj === 'string') {
      return obj.replace(/,([^ ])/g, ', $1');
    }
    return obj;
  }

  getStationListForTrain(){
    this.searchService.getStationListDataForTrain().subscribe(data => {
    if(data){
      this.trainLocations =this.addSpaceAfterComma(data);
      this.originalTrainLocationResponse = this.addSpaceAfterComma(data);
      this.filterTrainStationWithTrainLine();
      
    } 
    });
  }
  itemContainsInput(item, input){
    if ( (input && input.trim().length > 0) &&
      (item.airport.toLowerCase().indexOf(input.trim().toLowerCase()) > -1
      || item.label.toLowerCase().indexOf(input.trim().toLowerCase()) > -1
      || item.city.toLowerCase().indexOf(input.trim().toLowerCase()) > -1)
    ) {
      return true;
    }
    return false;
  }
  sortTrainStationsWithInput(input) {
    let filteredData = this.trainLocations;
    if ( input && input.trim().length > 0 ) {
      filteredData = this.trainLocations.sort((item1, item2) => {
        const item1Matches = this.itemContainsInput(item1, input);
        const item2Matches = this.itemContainsInput(item2, input);
        if ((item1Matches && item2Matches)||(!item1Matches && !item2Matches)) {
          if (item1.code < item2.code) {return -1;}
          if (item2.code < item1.code) {return 1;}
          return 0;
        }
        if (item1Matches && !item2Matches) {return -1}
        if (item2Matches && !item1Matches) {return 1}
        return 0;
      }
      );
    }
    return filteredData;
  }
  setAutoCompleteTrainSearchStation(input){
    const sortedData = this.groupingCityName(this.sortTrainStationsWithInput(input));
    if (this.selectFormControlname === 'source') {
      this.autoCompleteSourceItems = sortedData;
      return this.autoCompleteSourceItems;
    } else {
      this.autoCompleteDestItems = sortedData;
      if (this.trainRouteSelectedInOrigin?.length) {
        this.autoCompleteDestItems = this.autoCompleteDestItems.filter(item =>
          Array.isArray(item.airports) &&
          item.airports.length > 0 &&
          Array.isArray(item.airports[0].routes) &&
          this.trainRouteSelectedInOrigin.some(route =>
            item.airports[0].routes.includes(route)
          )
        );
      }
     return  this.autoCompleteDestItems;
    }
  }
  filterTrainStationWithTrainLine(){
    let tempTrainStationList = [];
    for(let i = 0; i<this.originalTrainLocationResponse.length; i++){
      let trainLineAvailable = this.originalTrainLocationResponse[i].trainLineCode.filter((train)=>{
          return train == this.searchForm.controls['trainLine'].value;
      })
      if(trainLineAvailable && trainLineAvailable.length != 0){
        tempTrainStationList.push(this.originalTrainLocationResponse[i]);
      }
  }
  this.trainLocations = tempTrainStationList;
  
  // this.searchForm.reset();
  // this.createForm();
  // this.multicity = false;
  // this.viewMode = 'tab5';
  // this.searchForm.controls['trainLine'].setValue(selectedTrainLine);
  }
  handleTrainLineChange(){
    let selectedTrainLine = this.searchForm.controls['trainLine'].value;
    this.filterTrainStationWithTrainLine();
    let selectedTripType = this.searchForm.controls['trip'].value;
    this.searchForm.reset();
    this.createForm();
    this.railCardsSelected=[];

    if(selectedTrainLine==='UKT'){
      this.searchForm.controls['class'].setValue('STANDARD');
    }
    this.multicity = false;
    this.viewMode = 'tab5';
    if(selectedTrainLine==='2R'){
      this.updateSourceValidators(4,4,'source');
      this.updateSourceValidators(4,4,'destination');
    }else{
      this.updateSourceValidators(3,3,'source');
      this.updateSourceValidators(3,3,'destination');
    }
    if (selectedTripType === 'ROUNDTRIP') {
      this.searchForm.controls['arrivalDate'].setValidators([Validators.required]);
      this.searchForm.controls['arrivalDate'].updateValueAndValidity();
    } else {
      this.searchForm.controls['arrivalDate'].clearValidators();
      this.searchForm.controls['arrivalDate'].updateValueAndValidity();
    }
    this.searchForm.controls['trip'].setValue(selectedTripType);
    this.searchForm.controls['trainLine'].setValue(selectedTrainLine);
  }

  // Hotel calendar methods
  private onClickOutsideHotelCheckin = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const calendarPopup = document.querySelector('.hotel-calendar-container');
    const dateInput = target.closest('.date-input-wrapper-hotel');

    if (this.showHotelCheckinCalendar && calendarPopup && !calendarPopup.contains(target) && !dateInput) {
      this.closeHotelCheckinCalendar();
    }
  }

  private onClickOutsideHotelCheckout = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const calendarPopup = document.querySelector('.hotel-calendar-container');
    const dateInput = target.closest('.date-input-wrapper-hotel');

    if (this.showHotelCheckoutCalendar && calendarPopup && !calendarPopup.contains(target) && !dateInput) {
      this.closeHotelCheckoutCalendar();
    }
  }

  toggleHotelCheckinCalendar(checkinDatePicker?: any, container?: HTMLElement) {
    if (!this.searchHotelForm.controls['hotelAddress'].value) {
        this.toastr.error(this.translate.instant('setting.Pleaseenteradestination'));
        return;
    }
    

    this.showHotelCheckinCalendar = !this.showHotelCheckinCalendar;

    if (this.showHotelCheckinCalendar) {
        this.checkinCalendarOpenedAt = Date.now();

        if (container) {
          this.calendarWidth = container.offsetWidth;
        }

        // Scroll calendar into viewport on desktop
        this.scrollCalendarIntoView('.hotel-checkin-calendar');

        this.showHotelCheckoutCalendar = false;
        if (this.hotelCheckoutClickOutsideListener) {
            document.removeEventListener('click', this.hotelCheckoutClickOutsideListener);
        }


        setTimeout(() => {
          this.hotelCheckinClickOutsideListener = this.onClickOutsideHotelCheckin;
          document.addEventListener('click', this.hotelCheckinClickOutsideListener);
        }, 100);
    } else {
        this.closeHotelCheckinCalendar();
    }
  }

  closeHotelCheckinCalendar() {
    this.showHotelCheckinCalendar = false;
    // Remove listener
    if (this.hotelCheckinClickOutsideListener) {
      document.removeEventListener('click', this.hotelCheckinClickOutsideListener);
      this.hotelCheckinClickOutsideListener = null;
    }
  }

  setHotelCheckinDate(date: Date) {

    if (Date.now() - this.checkinCalendarOpenedAt < 200) {
        return;
    }
    if (date) {
      this.setCheckInDate(date);
      this.closeHotelCheckinCalendar();
    }
  }

  toggleHotelCheckoutCalendar(checkoutDatePicker?: any, container?: HTMLElement) {
     if (!this.searchHotelForm.controls['hotelAddress'].value) {
        this.toastr.error(this.translate.instant('setting.Pleaseenteradestination'));
        return;
    }
    

    this.showHotelCheckoutCalendar = !this.showHotelCheckoutCalendar;

    if (this.showHotelCheckoutCalendar) {
        this.checkoutCalendarOpenedAt = Date.now();

        if (container) {
          this.calendarWidth = container.offsetWidth;
        }

        // Scroll calendar into viewport on desktop
        this.scrollCalendarIntoView('.hotel-checkout-calendar');

        this.showHotelCheckinCalendar = false;
        if (this.hotelCheckinClickOutsideListener) {
          document.removeEventListener('click', this.hotelCheckinClickOutsideListener);
        }


        setTimeout(() => {
          this.hotelCheckoutClickOutsideListener = this.onClickOutsideHotelCheckout;
          document.addEventListener('click', this.hotelCheckoutClickOutsideListener);
        }, 100);
    } else {
        this.closeHotelCheckoutCalendar();
    }
  }

  closeHotelCheckoutCalendar() {
    this.showHotelCheckoutCalendar = false;

    if (this.hotelCheckoutClickOutsideListener) {
      document.removeEventListener('click', this.hotelCheckoutClickOutsideListener);
      this.hotelCheckoutClickOutsideListener = null;
    }
  }

  setHotelCheckoutDate(date: Date) {

    if (Date.now() - this.checkoutCalendarOpenedAt < 200) {
        return;
    }
    if (date) {
      this.setCheckOutDate(date);
      this.closeHotelCheckoutCalendar();
    }
  }
  
  onTravelerApplied(event: any) {
      this.searchForm.controls['passengers'].setValue("" + this.searchService.employeeEmail.length);
       if (this.viewMode === 'tab2') {
      this.searchHotelForm.controls['roomCount'].setValue("" + this.searchService.employeeEmail.length);
    };
  }
  
  previousBookingInProgress(viewModeCheck){
    if(this.bookingService.previousBooking || this.searchService.multiTripBooking){
      if(this.viewMode != viewModeCheck ){
        return true
      };
    };
    
    return false;
    
  }
  
   @HostListener('window:popstate', ['$event'])
  onBrowserBack(event: PopStateEvent): void {
     this.closeAirportComponent();
  }
  
  resetTraveler(){
        if(this.searchService.infantBookingAllowed && this.searchService.previousTab !== this.viewMode){         
          let reset = false          
          for (let i = 0; i < this.searchService.employeeEmail.length; i++) {
            const employee = this.searchService.employeeEmail[i];
            const ageGroup = this.searchService.ageGroupArray[i];
            if(ageGroup && ((ageGroup.id == 'CHD' || ageGroup.id == 'INF') && ageGroup.selectedByUser)){
              reset = true;
              break;
            };
          };
          
        
          if(reset){            
            if(this.viewMode == 'tab2' || this.viewMode == 'tab3'){
              this.searchService.employeeEmail = [];
              this.searchService.ageGroupArray = [];
            }                        
            if(!this.searchService.previousTab){  
              if (!this.isUserCompanyTravelManager() && !this.userAccountInfoService.isUserCorporateAdmin() && this.searchService.employeeEmail.length === 0 ) {
               const userid = this.userAccountInfoService.getUserEmail();
               const currentUser = (this.searchService.travellerList || []).find(traveler => traveler.userId === userid);
               const currentUserExists = this.searchService.employeeEmail.some(t => t.email === userid);
                 if (!currentUserExists) {
                   // Add current user to employeeEmail
                   this.searchService.employeeEmail.push({Name: 'search.Myself',Id: 0,email: userid,employeeIdentifier: currentUser?.employeeIdentifier || ''});
                   
              };
             };
            }
            
            this.searchService.previousTab = this.viewMode;
          };
                    
        };
      }
      
      showErrorIfAgeNotSelected(): boolean {
        if((this.viewMode == 'tab1' || this.viewMode == 'tab5') && this.searchService.employeeEmail.length > 0 && this.searchService.infantBookingAllowed){
          return  this.searchService.ageGroupArray.some(ageGroup => ageGroup && ageGroup.id == null);
        }
        
        return false
  
}
}
